"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areas = void 0;
exports.areas = [
    {
        code: "AB",
        name: "ABIA",
        lgas: [
            "ABA NORTH",
            "ABA SOUTH",
            "AROCHUKWU",
            "BENDE",
            "IKWUAN",
            "ISIALA NGWA",
            "ISIALA NGWA SOUTH",
            "ISUIKWUATO",
            "OBINGWA",
            "OHAFIA",
            "OSISIOMA",
            "UGWUNABO",
            "UKWA EAST",
            "UKWA WEST",
            "UMU NNEOCHI",
            "UMUAHIA NORTH",
            "UMUAHIA SOUTH",
        ],
        subs: {
            "ABA NORTH": [
                "ARIARIA MARKET",
                "EZIAMA",
                "INDUSTRIAL AREA",
                "OGBOR I",
                "OGBOR II",
                "OLD GRA",
                "OSUSU I",
                "OSUSU II",
                "ST. EUGENE",
                "UMUOGOR",
                "UMUOLA",
                "URATTA",
            ],
            "ABA SOUTH": [
                "ABA RIVER",
                "ABA TOWN HALL",
                "ASA",
                "EKEOHA",
                "ENYIMBA",
                "EZIUKWU",
                "GLOUCETER",
                "IGWEBIKE",
                "MOSQUE",
                "NGWA",
                "OHAZU I",
                "OHAZU II",
            ],
            AROCHUKWU: [
                "AROCHUKWU I",
                "AROCHUKWU II",
                "AROCHUKWU III",
                "ELEOCHA IHECHIWA",
                "IKWUN IHEOCHIOWA",
                "ISU",
                "OHAEKE",
                "OHAFOR I",
                "OHAFOR II",
                "OVUKWU",
                "UTUTU",
            ],
            BENDE: [
                "AMANKALU/ AKOLIOFU",
                "BENDE",
                "IGBERE ' A'",
                "IGBERE 'B'",
                "ITEM 'A'",
                "ITEM 'B'",
                "ITEM 'C'",
                "ITUMBAZO",
                "OZUITEM",
                "UGWUEKE/EZEUKWU",
                "UMUHU/EZECHI",
                "UMUIMENYI/NKPA",
                "UZUAKOLI",
            ],
            IKWUAN: [
                "ARIAM",
                "IBERE I",
                "IBERE II",
                "OBORO I",
                "OBORO II",
                "OBORO III",
                "OBORO IV",
                "OLOKO I",
                "OLOKO II",
                "USAKA",
            ],
            "ISIALA NGWA": [
                "AMA SA NTIGHA",
                "AMAPU NTIGHA",
                "AMASA NSULU",
                "IHIE",
                "ISIALA NSULU",
                "NBAWSUI/UMUOMAINTA",
                "NGWA UKWU  II",
                "NGWA UKWU I",
                "UMUNNA NSULU",
                "UMUOHA",
            ],
            "ISIALA NGWA SOUTH": [
                "AKU NA EKPU, EZIAMA NA OBU",
                "AMAISE/AMAISE AHABA",
                "EHI NA NGURU OSOKWA",
                "M BUTU NGWA",
                "MBUTU UKWU",
                "NGWAOBI",
                "OKPORO AHABA",
                "OMOBA",
                "OVUNGWU",
                "OVUOKWU",
            ],
            ISUIKWUATO: [
                "ACHARA/ MBUGWU",
                "EZERE",
                "IKEAGHA  II",
                "IKEAGHA I",
                "IMENYI",
                "ISIALA AMAWU",
                "ISU AMAWU",
                "OGUNDUASA",
                "UMUANYI/ ABSU",
                "UMUNNEKWU",
            ],
            OBINGWA: [
                "ABAYI  II",
                "ABAYI I",
                "AHIABA",
                "AKUMAIMO",
                "ALAUKWU OHANZE",
                "IBEME",
                "MGBOKO AMIRI",
                "MGBOKO NTUNGWA",
                "MGBOKO- UMUANUNU",
                "NDIAKATA/AMAIRINABUO",
                "NTIGHAUZO AMAIRI",
            ],
            OHAFIA: [
                "AGBORJI ABIRIBA",
                "AMEKE",
                "AMOGUDU ABIRIBA",
                "ANIA",
                "EBEM",
                "ISIAMA",
                "NDI AGBO NKPORO",
                "NDI ELU",
                "NDI ETITI  NKPORO",
                "OHAFOR",
                "OKAMU",
            ],
            OSISIOMA: [
                "AMA-ASAA",
                "AMAFOR",
                "AMASATOR",
                "AMAVO",
                "AMITOLU MBUTU UMUOJIOMA",
                "ARO-NGWA",
                "OSO-OKWA",
                "UKPU- UMUOBO",
                "UMUNNEISE",
                "URATTA",
            ],
            UGWUNABO: [
                "EIGHT",
                "FIV E",
                "FOUR",
                "NINE",
                "ONE",
                "SEVEN",
                "SIX",
                "TEN",
                "THREE",
                "TWO",
            ],
            "UKWA EAST": [
                "AKWETE",
                "AZUMINI",
                "IKWEKE  EAST",
                "IKWEKE WEST",
                "IKWUORIE",
                "IKWURIATOR",
                "IKWURIATOR WEST",
                "NKPOROBE/OHURU",
                "OBOHIA",
                "UMUIEGUBE/ACHARA",
            ],
            "UKWA WEST": [
                "ASA NORTH",
                "IPU EAST",
                "IPU SOUTH",
                "IPU WEST",
                "OBOKWE",
                "OBUZOR",
                "OGWE",
                "OZAA UKWU",
                "OZAA WEST",
            ],
            "UMU NNEOCHI": [
                "AMUDA",
                "EZIAMA AGBO",
                "EZIAMA UGWU",
                "EZINGODO",
                "MBALA/ACHARA",
                "NDIAWA/ UMUELEM",
                "OBINULO/OBIAGULU/LOMARA",
                "UBAHU/AKAWA/AROIKPO",
                "UMUAKU",
                "UMUCHIEZE I",
                "UMUCHIEZE II",
                "UMUCHIEZE III",
            ],
            "UMUAHIA NORTH": [
                "AFUGIRI",
                "IBEKU EAST I",
                "IBEKU EAST II",
                "IBEKU WEST",
                "ISINGWU",
                "NDUME",
                "NKWOCHARA",
                "NKWOEGWU",
                "UMUHU",
                "UR BAN II",
                "URBAN I",
                "URBAN III",
            ],
            "UMUAHIA SOUTH": [
                "AHIAUKWU I",
                "AHIAUKWU II",
                "AMAKAMA",
                "EZELEKE/ OGBODIUKWU",
                "NSRIMO",
                "OHIOCHA",
                "OLD UMUAHIA",
                "OMAEGWU",
                "UBAKALA  'A'",
                "UBAKALA  'B'",
            ],
        },
    },
    {
        code: "AD",
        name: "ADAMAWA",
        lgas: [
            "DEMSA",
            "FUFORE",
            "GANYE",
            "GIREI",
            "GOMBI",
            "GUYUK",
            "HONG",
            "JADA",
            "LAMURDE",
            "MADAGALI",
            "MAIHA",
            "MAYO BELWA",
            "MICHIKA",
            "MUBI NORTH",
            "MUBI SOUTH",
            "NUMAN",
            "SHELLENGE",
            "SONG",
            "TOUNGO",
            "YOLA NORTH",
            "YOLA SOUTH",
        ],
        subs: {
            DEMSA: [
                "BILLE",
                "BORRONG",
                "DEMSA",
                "DILLI",
                "DONG",
                "DWAM",
                "GWAMBA",
                "KPASHAM",
                "MBULA KULI",
                "NASSARAWO DEMSA",
            ],
            FUFORE: [
                "BETI",
                "FARANG",
                "FUFORE",
                "GURIN",
                "KARLAHI",
                "MAYO-INE",
                "PARIYA",
                "RIBADU",
                "UKI-TUKI",
                "WURO- BOKKI",
                "YADIM",
            ],
            GANYE: [
                "BAKARI GUSO",
                "GAMU",
                "GANYE  I",
                "GANYE  II",
                "GURUM",
                "JAGGU",
                "SANGASSUMI",
                "SUGU",
                "TIMDORE",
                "YEBBI",
            ],
            GIREI: [
                "DAKRI",
                "DAMARE",
                "GERENG",
                "GIREI",
                "GIREI II",
                "JERA BAKARI",
                "JERA BONYO",
                "MODIRE VINIKILANG",
                "TAMBO",
                "WURO DOLE",
            ],
            GOMBI: [
                "BOGA/DINGAI",
                "DUWA",
                "GA'ANDA",
                "GABUN",
                "GARKIDA",
                "GOMBI NORTH",
                "GOMBI SOUTH",
                "GUYAKU",
                "TAWA",
                "YANG",
            ],
            GUYUK: [
                "BANJIRAM",
                "BOBINI",
                "BODEN",
                "CHIKILA",
                "DUKUL",
                "DUMNA",
                "GUYUK",
                "KOLA",
                "LOKORO",
                "PUROKAYO",
            ],
            HONG: [
                "BANGSHIKA",
                "DAKSIRI",
                "GARAHA",
                "GAYA",
                "HILDI",
                "HONG",
                "HUSHERE ZUM",
                "KWARHI",
                "MAYO LOPE",
                "SHANGUI",
                "THILBANG",
                "UBA",
            ],
            JADA: [
                "DANABA",
                "JADA I",
                "JADA II",
                "KOMA I",
                "KOMA II",
                "LEKO",
                "MAPEO",
                "MAYO-KALAYE",
                "MBULO",
                "NYIBANGO",
                "YELLI",
            ],
            LAMURDE: [
                "DUBWAGUN",
                "GYAWANA",
                "LAFIYA",
                "LAMURDE",
                "MGBEBONGUN",
                "NGBAKOWO",
                "OPALO",
                "RIGANGE",
                "SUWA",
                "WADUKU",
            ],
            MADAGALI: [
                "BABEL",
                "DUHU/SHUWA",
                "GULAK",
                "HYAMBULA",
                "KIRCHINGA/WNGAYANDI",
                "MADAGALI",
                "PALLAM",
                "S/S/VAPURA",
                "WAGGA",
                "WULA",
            ],
            MAIHA: [
                "BELEL",
                "HUMBUTUDI",
                "KONKOL",
                "MAIHA GARI",
                "MANJEKIN",
                "MAYONGULI",
                "PAKKA",
                "SORAU A",
                "SORAU B",
                "TAMBAJAM",
            ],
            "MAYO BELWA": [
                "BAJAMA",
                "BINYERI",
                "GANGFADA",
                "GENGLE",
                "GOROBI",
                "MAYO BELWA",
                "MAYO FARANG",
                "NASSARAWO JERENG",
                "NDIKONG",
                "RIBADU",
                "TOLA",
                "YOFFO",
            ],
            MICHIKA: [
                "BAZZA/MARGI",
                "FUTUDOU/FUTULESS",
                "GARTA/GUNCHI",
                "JIGALAMBU",
                "MADZI",
                "MICHIKA I",
                "MICHIKA II",
                "MINKISI/WURO NGIKI",
                "MODA/DLAKA/GHENJAWA",
                "MUNKVICITA",
                "SINA/KAMALE/KWANDE",
                "SUKUMU/TILLIJO",
                "THUKUDOU/SUFUKU/ZAH",
                "TUMBARA/NGABILI",
                "VI/BOKA",
                "WAMBILIMI/TILLI",
            ],
            "MUBI NORTH": [
                "BAHULI",
                "BETSO",
                "DIGIL",
                "KOLERE",
                "LOKUWA",
                "MAYO BANI",
                "MIJILU",
                "MUCHALLA",
                "SABON LAYI",
                "VIMTIM",
                "YELWA",
            ],
            "MUBI SOUTH": [
                "DIRBISHI",
                "DUVU",
                "GELLA",
                "GUDE",
                "KWAJA",
                "LAMORDE",
                "MUGULBU",
                "MUJARA",
                "NASSARAWO",
                "NDUKU",
            ],
            NUMAN: [
                "BARE",
                "BOLKI",
                "GAMADIO",
                "IMBURU",
                "KODOMTI",
                "NUMAN I",
                "NUMAN II",
                "NUMAN III",
                "SABON PEGI",
                "VULPI",
            ],
            SHELLENGE: [
                "BAKTA",
                "BODWAI",
                "GUNDO",
                "GWAPOPOLOK",
                "JUMBUL",
                "KETEMBERE",
                "KIRI",
                "LIBBO",
                "SHELLENG",
                "TALLUM",
            ],
            SONG: [
                "DIRMA",
                "DUMNE",
                "GUDUMBOI",
                "KILANGE FUNA",
                "KILANGE HIRNA",
                "SIGIRE",
                "SONG GARI",
                "SONG WAJE",
                "SUKTU",
                "WALTANDI",
                "ZUMO",
            ],
            TOUNGO: [
                "DAWO I",
                "DAWO II",
                "GUMTI",
                "KIRI I",
                "KIRI II",
                "KOGIN BABA I",
                "KOGIN BABA II",
                "TOUNGO I",
                "TOUNGO II",
                "TOUNGO III",
            ],
            "YOLA NORTH": [
                "AJIYA",
                "ALKALAWA",
                "DOUBELI",
                "GWADABAWA",
                "JAMBUTU",
                "KAREWA",
                "LIMAWA",
                "LUGGERE",
                "NASSARAWO",
                "RUMDE",
                "YELWA",
            ],
            "YOLA SOUTH": [
                "ADARAWO",
                "BAKO",
                "BOLE/YOLDE PATE",
                "MAKAMA A",
                "MAKAMA B",
                "MBAMBA",
                "MBAMOI",
                "NAMTARI",
                "NGURORE",
                "TOUNGO",
                "YOLDE KOHI",
            ],
        },
    },
    {
        code: "AK",
        name: "AKWA IBOM",
        lgas: [
            "ABAK",
            "EASTERN OBOLO",
            "EKET",
            "ESIT EKET",
            "ESSIEN UDIM",
            "ETIM EKPO",
            "ETINAN",
            "IBESIKPO ASUTAN",
            "IBION",
            "IBION IBOM",
            "IKA",
            "IKON",
            "IKOT ABASI",
            "IKOT EKPENE",
            "INI",
            "ITU",
            "MBO",
            "MKPAT ENIN",
            "NSIT ATAI",
            "NSIT IBOM",
            "NSIT UBIUM",
            "OBOT AKARA",
            "OKOBO",
            "ONNA",
            "ORON",
            "ORUK ANAM",
            "UDUNG UKO",
            "UKANAFUN",
            "URE OFFONG/ORUKO",
            "URUAN",
            "UYO",
        ],
        subs: {
            ABAK: [
                "ABAK URBAN I",
                "ABAK URBAN II",
                "ABAK URBAN III",
                "ABAK URBAN IV",
                "AFAHA OBONG I",
                "AFAHA OBONG II",
                "MIDIM I",
                "MIDIM II",
                "OTORO I",
                "OTORO II",
                "OTORO III",
            ],
            "EASTERN OBOLO": [
                "EASTERN OBOLO I",
                "EASTERN OBOLO II",
                "EASTERN OBOLO III",
                "EASTERN OBOLO IV",
                "EASTERN OBOLO IX",
                "EASTERN OBOLO V",
                "EASTERN OBOLO VI",
                "EASTERN OBOLO VII",
                "EASTERN OBOLO VIII",
                "EASTERN OBOLO X",
            ],
            EKET: [
                "EKET CENTRAL I",
                "EKET CENTRAL II",
                "EKET CENTRAL III",
                "EKET CENTRAL IV",
                "EKET CENTRAL V",
                "EKET URBAN I",
                "EKET URBAN II",
                "EKET URBAN III",
                "EKET URBAN IV",
                "OKON I",
                "OKON II",
            ],
            "ESIT EKET": [
                "AKPAUTONG",
                "EBE  EKPI",
                "EBIGIHE OKPON",
                "EDOR",
                "EKPENE OBO",
                "ETEBI AKWATA",
                "ETEBI IDUNG ASSAN",
                "IKPA",
                "NTAK INYANG",
                "UQUO",
            ],
            "ESSIEN UDIM": [
                "ADIASIM",
                "AFAHA",
                "EKPENYONG ATAI I",
                "EKPENYONG ATAI II",
                "IKPE ANNANG",
                "ODORO IKOT I",
                "ODORO IKOT II",
                "OKON",
                "UKANA EAST",
                "UKANA WEST I",
                "UKANA WEST II",
            ],
            "ETIM EKPO": [
                "ETIM EKPO I",
                "ETIM EKPO II",
                "ETIM EKPO III",
                "ETIM EKPO IV",
                "ETIM EKPO IX",
                "ETIM EKPO V",
                "ETIM EKPO VI",
                "ETIM EKPO VII",
                "ETIM EKPO VIII",
                "ETIM EKPO X",
            ],
            ETINAN: [
                "ETINAN URBAN I",
                "ETINAN URBAN II",
                "ETINAN URBAN III",
                "ETINAN URBAN IV",
                "ETINAN URBAN V",
                "NORTHERN IMAN I",
                "NORTHERN IMAN II",
                "SOUTHERN IMAN I",
                "SOUTHERN IMAN II",
                "SOUTHERN IMAN III",
                "SOUTHERN IMAN IV",
            ],
            "IBESIKPO ASUTAN": [
                "ASUTAN I",
                "ASUTAN II",
                "ASUTAN III",
                "ASUTAN IV",
                "ASUTAN V",
                "IBESIKPO I",
                "IBESIKPO II",
                "IBESIKPO III",
                "IBESIKPO IV",
                "IBESIKPO V",
            ],
            IBION: [
                "IBEN I",
                "IBEN II",
                "IBEN III",
                "IBEN IV",
                "IBEN IX",
                "IBEN V",
                "IBEN VI",
                "IBEN VII",
                "IBEN VIII",
                "IBEN X",
            ],
            "IBION IBOM": [
                "IBION CENTRAL I",
                "IBION CENTRAL II",
                "IBION EASTERN I",
                "IBION EASTERN II",
                "IBION NORTHERN I",
                "IBION NORTHERN II",
                "IBION SOUTHERN I",
                "IBION SOUTHERN II",
                "IBION WESTERN I",
                "IBION WESTERN II",
                "IKPANYA CLAN",
            ],
            IKA: [
                "ACHAN I",
                "ACHAN II",
                "ACHAN III",
                "ITO I",
                "ITO II",
                "ITO III",
                "ODORO I",
                "ODORO II",
                "URBAN I",
                "URBAN II",
            ],
            IKON: [
                "EDIENE I",
                "EDIENE II",
                "IKON MIDDLE I",
                "IKON MIDDLE II",
                "IKON MIDDLE III",
                "IKON MIDDLE IV",
                "IKON SOUTH",
                "ITAK",
                "NDIYA/IKOT IDAHA",
                "NKWOT I",
                "NKWOT II",
            ],
            "IKOT ABASI": [
                "EDEMAYA I",
                "EDEMAYA II",
                "EDEMAYA III",
                "IKPA IBEKWE I",
                "IKPA IBEKWE II",
                "IKPA NUNG ASANG I",
                "IKPA NUNG ASANG II",
                "UKPUM ETE I",
                "UKPUM ETE II",
                "UKPUM OKON",
            ],
            "IKOT EKPENE": [
                "IKOT EKPENE I",
                "IKOT EKPENE II",
                "IKOT EKPENE III",
                "IKOT EKPENE IV",
                "IKOT EKPENE IX",
                "IKOT EKPENE V",
                "IKOT EKPENE VI",
                "IKOT EKPENE VII",
                "IKOT EKPENE VIII",
                "IKOT EKPENE X",
                "IKOT EKPENE XI",
            ],
            INI: [
                "IKON NORTH I",
                "IKON NORTH II",
                "IKON NORTH III",
                "IKPE",
                "IKPE II",
                "ITU MBONUSO",
                "IWERRE",
                "NKARI",
                "ODORO UKWOK",
                "USUK UKWOK",
            ],
            ITU: [
                "EAST ITAM I",
                "EAST ITAM II",
                "EAST ITAM III",
                "EAST ITAM IV",
                "EAST ITAM V",
                "MBIABO/AYADEHE",
                "OKU IBOKU",
                "WEST ITAM I",
                "WEST ITAM II",
                "WEST ITAM III",
            ],
            MBO: [
                "EBUGHU I",
                "EBUGHU II",
                "EFIAT I",
                "EFIAT II",
                "ENWANG I",
                "IBAKA",
                "UDA I",
                "UDA II",
                "UDESI",
            ],
            "MKPAT ENIN": [
                "IBIAKU I",
                "IBIAKU II",
                "IBIAKU III",
                "IKPA IBOM I",
                "IKPA IBOM II",
                "IKPA IBOM III",
                "IKPA IBOM IV",
                "IKPA IKON I",
                "IKPA IKON II",
                "IKPA IKON III",
                "UKPUM MINYA I",
                "UKPUM MINYA II",
                "UKPUM MINYA III",
                "UKPUM MINYA IV",
            ],
            "NSIT ATAI": [
                "EASTERN NSIT I",
                "EASTERN NSIT II",
                "EASTERN NSIT III",
                "EASTERN NSIT IV",
                "EASTERN NSIT IX",
                "EASTERN NSIT V",
                "EASTERN NSIT VI",
                "EASTERN NSIT VII",
                "EASTERN NSIT VIII",
                "EASTERN NSIT X",
            ],
            "NSIT IBOM": [
                "ASANG I",
                "ASANG II",
                "ASANG III",
                "ASANG IV",
                "ASANG V",
                "MBIASO I",
                "MBIASO II",
                "MBIASO III",
                "MBIASO IV",
                "MBIASO V",
            ],
            "NSIT UBIUM": [
                "IBIAKAN OBOTIM II",
                "IBIAKPAN OBOTIM I",
                "ITRETO",
                "NDIYA",
                "UBIUM NORTH I",
                "UBIUM NORTH II",
                "UBIUM NORTH III",
                "UBIUM SOUTH I",
                "UBIUM SOUTH II",
                "UBIUM SOUTH III",
            ],
            "OBOT AKARA": [
                "IKOT ABIA I",
                "IKOT ABIA II",
                "IKOT ABIA III",
                "NTO EDIN I",
                "NTO EDIN II",
                "NTO EDIN III",
                "NTO EDIN IV",
                "OBOT AKARA I",
                "OBOT AKARA II",
                "OBOT AKARA III",
            ],
            OKOBO: [
                "AKAI/MBUKPU/UDUNG",
                "EKEYA",
                "EWEME II",
                "EWEMEI",
                "NUNG ATTAI /UBE II",
                "NUNG ATTAI/UBE I",
                "OFFI I",
                "OFFI II",
                "OKOPEDI I",
                "OKOPEDI II",
            ],
            ONNA: [
                "AWA I",
                "AWA II",
                "AWA III",
                "AWA IV",
                "NUNG NDEM I",
                "NUNG NDEM II",
                "ONIONG EAST I",
                "ONIONG EAST II",
                "ONIONG EAST III",
                "ONIONG WEST I",
                "ONIONG WEST II",
                "ONIONG WEST III",
            ],
            ORON: [
                "ORON URBAN I",
                "ORON URBAN II",
                "ORON URBAN III",
                "ORON URBAN IV",
                "ORON URBAN IX",
                "ORON URBAN V",
                "ORON URBAN VI",
                "ORON URBAN VII",
                "ORON URBAN VIII",
                "ORON URBAN X",
            ],
            "ORUK ANAM": [
                "ABAK /MIDIM I",
                "ABAK/ MIDIM III",
                "ABAK/ MIDIM IV",
                "ABAK/MIDIM II",
                "EKPARAKWA",
                "IBESIT",
                "IBESIT/NUNG IKOT I",
                "IBESIT/NUNG IKOT II",
                "IKOT IBRITAM I",
                "IKOT IBRITAM II",
                "NDOT/ IKOT OKORO II",
                "NDOT/ IKOT OKORO III",
                "NDOT/IKOT OKORO I",
            ],
            "UDUNG UKO": [
                "UDUNG UKO I",
                "UDUNG UKO II",
                "UDUNG UKO III",
                "UDUNG UKO IV",
                "UDUNG UKO IX",
                "UDUNG UKO V",
                "UDUNG UKO VI",
                "UDUNG UKO VII",
                "UDUNG UKO VIII",
                "UDUNG UKO X",
            ],
            UKANAFUN: [
                "NORTHERN AFAHA I",
                "NORTHERN AFAHA II",
                "NORTHERN UKANAFUN I",
                "NORTHERN UKANAFUN II",
                "SOUTHERN AFAHA/ ADAT IFANG I",
                "SOUTHERN AFAHA/ ADAT IFANG II",
                "SOUTHERN AFAHA/ ADAT IFANG III",
                "SOUTHERN AFAHA/ ADAT IFANG IV",
                "SOUTHERN UKANAFUN I",
                "SOUTHERN UKANAFUN II",
                "UKANAFUN URBAN",
            ],
            "URE OFFONG/ORUKO": [
                "ORUKO I",
                "ORUKO II",
                "ORUKO III",
                "ORUKO IV",
                "ORUKO V",
                "URUE OFFONG I",
                "URUE OFFONG II",
                "URUE OFFONG III",
                "URUE OFFONG IV",
                "URUE OFFONG V",
            ],
            URUAN: [
                "CENTRAL URUAN I",
                "CENTRAL URUAN II",
                "CENTRAL URUAN III",
                "NORTHERN URUAN I",
                "NORTHERN URUAN II",
                "SOUTHERN URUAN I",
                "SOUTHERN URUAN II",
                "SOUTHERN URUAN III",
                "SOUTHERN URUAN IV",
                "SOUTHERN URUAN V",
                "SOUTHERN URUAN VI",
            ],
            UYO: [
                "ETOI I",
                "ETOI II",
                "IKON I",
                "IKON II",
                "OFFOT I",
                "OFFOT II",
                "OKU I",
                "OKU II",
                "UYO URBAN I",
                "UYO URBAN II",
                "UYO URBAN III",
            ],
        },
    },
    {
        code: "AN",
        name: "ANAMBRA",
        lgas: [
            "AGUATA",
            "ANAMBRA EAST",
            "ANAMBRA WEST",
            "ANAOCHA",
            "AWKA NORTH",
            "AWKA SOUTH",
            "AYAMELUM",
            "DUNUKOFIA",
            "EKWUSIGO",
            "IDEMILI NORTH",
            "IDEMILI SOUTH",
            "IHIALA",
            "NJIKOKA",
            "NNEWI NORTH",
            "NNEWI SOUTH",
            "OGBARU",
            "ONITSHA NORTH",
            "ONITSHA SOUTH",
            "ORUMBA NORTH",
            "ORUMBA SOUTH",
            "OYI",
        ],
        subs: {
            AGUATA: [
                "ACHINA I",
                "ACHINA II",
                "AGULUEZECHUKWU",
                "AKPO",
                "AMESI",
                "EKWULOBIA I",
                "EKWULOBIA II",
                "EZINIFITE I",
                "EZINIFITE II",
                "IGBO-UKWU I",
                "IGBO-UKWU II",
                "IKENGA",
                "ISUOFIA",
                "NKPOLOGWU",
                "ORAERI",
                "UGA I",
                "UGA II",
                "UMUCHU I",
                "UMUCHU II",
                "UMUONA",
            ],
            "ANAMBRA EAST": [
                "AGULERI I",
                "AGULERI II",
                "ENUGWU OTU",
                "EZIAGULU OTU",
                "IGBARIAM",
                "NANDO I",
                "NANDO II",
                "NANDO III",
                "NSUGBE I",
                "NSUGBE II",
                "OTUOCHA I",
                "OTUOCHA II",
                "UMULERI I",
                "UMULERI II",
                "UMUOBA ANAM",
            ],
            "ANAMBRA WEST": [
                "EZI ANAM",
                "IFITE ANAM",
                "NZAM",
                "OLUMBANASA INMA",
                "OLUMBANASA ODE",
                "OROMAETITI ANAM",
                "UMUENWELUM ANAM",
                "UMUEZE ANAM I",
                "UMUEZE ANAM II",
                "UMUOBA ANAM",
            ],
            ANAOCHA: [
                "ADAZI-ANI I",
                "ADAZI-ANI II",
                "ADAZI-ENU I",
                "ADAZI-ENU II",
                "ADAZI-NNUKWU I",
                "ADAZI-NNUKWU II",
                "AGULU I",
                "AGULU II",
                "AGULU III",
                "AGULU IV",
                "AGULUZIGBO",
                "AKWAEZE",
                "ICHIDA I",
                "ICHIDA II",
                "NENI I",
                "NENI II",
                "NRI I",
                "NRI II",
                "OBELEDU",
            ],
            "AWKA NORTH": [
                "ACHALLA I",
                "ACHALLA II",
                "ACHALLA III",
                "AMANSEA",
                "AMANUKE",
                "AWBA-OFEMILI",
                "EBENEBE I",
                "EBENEBE II",
                "EBENEBE III",
                "ISUANIOCHA",
                "MGBAKWU",
                "UGBENE",
                "UGBENU",
                "URUM",
            ],
            "AWKA SOUTH": [
                "AGU OKA",
                "AMAWBIA I",
                "AMAWBIA II",
                "AMAWBIA III",
                "AWKA I",
                "AWKA II",
                "AWKA III",
                "AWKA IV",
                "AWKA V",
                "AWKA VI",
                "AWKA VII",
                "EZINATO/ISIAGU",
                "MBA-UKWU",
                "NIBO I",
                "NIBO II",
                "NIBO III",
                "NISE I",
                "NISE II",
                "OKPUN",
                "UMUAWULU",
            ],
            AYAMELUM: [
                "ANAKU",
                "IFITE OGWARI I",
                "IFITE OGWARI II",
                "IGBAKU",
                "OMASI",
                "OMOR I",
                "OMOR II",
                "OMOR III",
                "UMUEJE",
                "UMUELUM",
                "UMUMBO",
            ],
            DUNUKOFIA: [
                "AKWA",
                "IFITEDUNU II",
                "NAWGU I",
                "NAWGU II",
                "UKPO I",
                "UKPO II",
                "UKPO III",
                "UKWULU I",
                "UKWULU II",
                "UMUDIOKA I",
                "UMUDIOKA II",
                "UMUNACHI I",
                "UMUNACHI II",
            ],
            EKWUSIGO: [
                "AMAKWA II",
                "ICHI",
                "IHEMBOSI/ ANABUDU",
                "IHITEOHA",
                "ORAIFITE I",
                "ORAIFITE II",
                "ORAIFITE III",
                "OZUBULU I",
                "OZUBULU II",
                "OZUBULU III",
                "OZUBULU IV",
                "OZUBULU V",
            ],
            "IDEMILI NORTH": [
                "ABACHA",
                "ABATETE",
                "EZIOWELLE",
                "IDEANI",
                "NKPOR I",
                "NKPOR II",
                "OBOSI",
                "OGIDI I",
                "OGIDI II",
                "ORAUKWU",
                "UKE",
                "UMUOJI",
            ],
            "IDEMILI SOUTH": [
                "AKWUKWU",
                "ALOR I",
                "ALOR II",
                "AWKA-ETITI I",
                "AWKA-ETITI II",
                "NNBI I",
                "NNBI II",
                "NNBI III",
                "NNKWA",
                "OBA I",
                "OBA II",
                "OJOTO",
            ],
            IHIALA: [
                "AMAMU I",
                "AMAMU II",
                "AMORKA",
                "AZIA",
                "IHITE",
                "ISSEKE",
                "LILU",
                "MBOSI",
                "OGBOLO",
                "OKIJA I",
                "OKIJA II",
                "OKIJA III",
                "OKIJA IV",
                "OKIJA V",
                "ORSUMOGHU",
                "UBULUISIUZOR",
                "ULI I",
                "ULI II",
                "ULI III",
                "UZOAKWA",
            ],
            NJIKOKA: [
                "ABAGANA I",
                "ABAGANA II",
                "ABAGANA III",
                "ABAGANA IV",
                "ABBA I",
                "ABBA II",
                "ENUGU AGIDI I",
                "ENUGU AGIDI II",
                "ENUGU/UKWU I",
                "ENUGU/UKWU II",
                "ENUGU/UKWU III",
                "ENUGU/UKWU IV",
                "NAWFIA I",
                "NAWFIA II",
                "NIMO I",
                "NIMO II",
                "NIMO III",
                "NIMO IV",
            ],
            "NNEWI NORTH": [
                "NNEWI-ICHI I",
                "NNEWI-ICHI II",
                "OTOLO I",
                "OTOLO II",
                "OTOLO III",
                "UMUDIM I",
                "UMUDIM II",
                "URUAGU I",
                "URUAGU II",
                "URUAGU III",
            ],
            "NNEWI SOUTH": [
                "AKWA-IHEDI",
                "AMICHI I",
                "AMICHI II",
                "AMICHI III",
                "AZUIGBO",
                "EBENATOR",
                "EKWULUMILI",
                "EZINIFITE I",
                "EZINIFITE II",
                "EZINIFITE III",
                "OSUMENYI I",
                "OSUMENYI II",
                "UKPOR I",
                "UKPOR II",
                "UKPOR III",
                "UKPOR IV",
                "UKPOR V",
                "UKPOR VI",
                "UNUBI",
                "UTUH",
            ],
            OGBARU: [
                "AKILI-OZIZOR",
                "AKILIOGIDI/OBEAGWE",
                "ATANI I",
                "ATANI II",
                "IYIOWA/ODEKPE/OHITA",
                "OCHUCHE-UMUODU/ OGBAKUBA/AMIYI",
                "OGWUANIOCHA",
                "OGWUIKPELE",
                "OKPOKO I",
                "OKPOKO II",
                "OKPOKO III",
                "OKPOKO IV",
                "OKPOKO V",
                "OKPOKO VI",
                "OSSOMALA",
                "UMUNANKWO/MPUTU",
            ],
            "ONITSHA NORTH": [
                "AMERICAN QUARTERS",
                "G.R.A.",
                "INLAND TOWN I",
                "INLAND TOWN II",
                "INLAND TOWN III",
                "INLAND TOWN IV",
                "INLAND TOWN V",
                "INLAND TOWN VI",
                "INLAND TOWN VII",
                "INLAND TOWN VIII",
                "OGBO UMUONICHA",
                "TRANS NKISI",
                "WATER SIDE CENTRAL I",
                "WATER SIDE CENTRAL II",
                "WOLIWO LAYOUT",
            ],
            "ONITSHA SOUTH": [
                "BRIDGE HEAD I",
                "BRIDGE HEAD II",
                "BRIDGE HEAD III",
                "FEGGE I",
                "FEGGE II",
                "FEGGE III",
                "FEGGE IV",
                "FEGGE V",
                "FEGGE VI",
                "FEGGE VII",
                "ODOAKPU I",
                "ODOAKPU II",
                "ODOAKPU III",
                "ODOAKPU IV",
                "ODOAKPU V",
                "ODOAKPU VI",
                "ODOAKPU VII",
            ],
            "ORUMBA NORTH": [
                "AJALLI I",
                "AJALLI II",
                "AMAETITI",
                "AMAOKPALA/OMEGHO",
                "AWA",
                "AWGBU I",
                "AWGBU II",
                "NANKA I",
                "NANKA II",
                "NDIKELIONWU",
                "NDIOKO / NDI-OKPALAEKE",
                "NDIOKPALAEZE",
                "NDIOWU",
                "NDUKWUENU / OKPEZE",
                "OKO I",
                "OKO II",
                "UFUMA I",
                "UFUMA II",
            ],
            "ORUMBA SOUTH": [
                "AGBUDU",
                "AKPU",
                "ENUGWU UMUOYIA/ONNEH",
                "EZIAGU",
                "EZIRA",
                "IHITE",
                "ISULO",
                "NAWFIJA",
                "OGBOJI",
                "OGBUNKA 1",
                "OGBUNKA 11",
                "OWERRE-EZUKALA1",
                "OWERRE-EZUKALA11",
                "UMUCHUKWU",
                "UMUNZE 11",
                "UMUNZE 111",
                "UMUNZE1",
                "UMUOMAKU",
            ],
            OYI: [
                "AWKUZUZ I",
                "AWKUZUZ II",
                "AWKUZUZ III",
                "AWKUZUZ IV",
                "NKWELLE EZUNAKA I",
                "NKWELLE EZUNAKA II",
                "NTEJE I",
                "NTEJE II",
                "NTEJE III",
                "NTEJE IV",
                "NTEJE V",
                "OGBUNIKE I",
                "OGBUNIKE II",
                "UMUNYA I",
                "UMUNYA II",
            ],
        },
    },
    {
        code: "BA",
        name: "BAUCHI",
        lgas: [
            "ALKALERI",
            "BAUCHI",
            "BOGORO",
            "DANBAM",
            "DARAZO",
            "DASS",
            "GAMAWA",
            "GANJUWA",
            "GIADE",
            "ITAS GADAU",
            "JAMA'ARE",
            "KATAGUM",
            "KIRFI",
            "MISAU",
            "NINGI",
            "SHIRA",
            "T/BALEWA",
            "TORO",
            "WARJI",
            "ZAKI",
        ],
        subs: {
            ALKALERI: [
                "ALKALERI",
                "BIRIN/GIGARA/YANKARI",
                "DAN/KUNGIBAR",
                "FUTUK",
                "GAR",
                "GWANA/MANSUR",
                "GWARAM",
                "MAIMADI",
                "PALI",
                "YALO",
                "YULI/LIM",
            ],
            BAUCHI: [
                "BIRSHI/MIRI",
                "DANDANGO YAMRAT",
                "DAWAKI",
                "GALAMBI GWASKWARAM",
                "HARDO/DAN IYA",
                "KANGERE TIRWUM",
                "KUNDUM/DURUM",
                "MAJIDADI 'A'",
                "MAJIDADI 'B'",
                "MAKAMA SARKIN BAKI",
                "MUN/MUNSAL",
                "ZUNGUR LIMAN KATAGUM",
            ],
            BOGORO: [
                "BOGORO (A)",
                "BOGORO (B)",
                "BOGORO (C)",
                "BOGORO (D)",
                "BOI (A)",
                "BOI (B)",
                "BOI (C)",
                "LUSA (A)",
                "LUSA (B)",
                "LUSA (C)",
            ],
            DANBAM: [
                "DAGAUDA",
                "DAMBAM",
                "GARGAWA",
                "GARUZA",
                "GURBANA",
                "JALAM CENTRAL",
                "JALAM EAST",
                "YAME",
                "YANDA",
                "ZAURA",
            ],
            DARAZO: [
                "DARAZO",
                "GABARIN",
                "GABCIYARI",
                "KONKIYEL",
                "LAGO",
                "LANZAI",
                "PAPA",
                "SADE",
                "TAUYA",
                "WAHU",
                "YAUTARE",
            ],
            DASS: [
                "BAGEL/BAJAR",
                "BARAZA",
                "BUNDOT",
                "BUNUNU CENTRAL",
                "BUNUNU SOUTH",
                "DOTT",
                "DURR",
                "POLCHI",
                "WANDI",
                "ZUMBUL/LUKSHI",
            ],
            GAMAWA: [
                "ALAGARN/ JADORI",
                "GADIYA",
                "GAMAWA",
                "GOLOLO",
                "KAFIN ROMI",
                "KUBDIYA",
                "RAGA",
                "TARMASUWA",
                "TUMBI",
                "UDUBO",
                "ZINDIWA",
            ],
            GANJUWA: [
                "GANJUWA",
                "GUNGURA",
                "KAFIN MADAKI",
                "KARIYA",
                "KUBI EAST",
                "KUBI WEST",
                "MIYA EAST",
                "MIYA WEST",
                "NASARAWA NORTH",
                "NASARAWA SOUTH",
                "YALI",
            ],
            GIADE: [
                "CHINKANI",
                "DOGUWA CENTRAL",
                "DOGUWA SOUTH",
                "GIADE",
                "ISAWA",
                "SABON SARA",
                "UZUM A",
                "UZUM B",
                "ZABI",
                "ZIRAMI",
            ],
            "ITAS GADAU": [
                "ABDALLAWA/MAGARYA",
                "BAMBAL",
                "BILKICHERI",
                "BUZAWA",
                "GADAU",
                "GWARAI",
                "ITAS",
                "KASHURI",
                "MASHEMA",
                "ZUBUKI",
            ],
            "JAMA'ARE": [
                "DOGON JEJI A",
                "DOGON JEJI B",
                "DOGON JEJI C",
                "GALDIMARI",
                "HANAFARI",
                "JAMA'ARE A",
                "JAMA'ARE B",
                "JAMA'ARE C",
                "JAMA'ARE D",
                "JURARA",
            ],
            KATAGUM: [
                "BULKACHUWA/DAGARO",
                "BUSKURI",
                "CHINADE",
                "GAMBAKI/ BIDIR",
                "MADACHI/GANGAI",
                "MADANGALA",
                "MADARA",
                "NASARAWA BAKIN KASUWA",
                "RAGWAM/MAGWONSHI",
                "TSAKUWA KOFAR GABAS",
                "YAYU",
            ],
            KIRFI: [
                "BADARA",
                "BARA",
                "BENI “A”",
                "BENI “B”",
                "DEWU CENTRAL",
                "DEWU EAST",
                "KIRFI",
                "SHANGO",
                "TUBULE",
                "WANKA",
            ],
            MISAU: [
                "AJILIN/GUGULIN",
                "BETI",
                "GWARAM",
                "HARDAWA",
                "JARKASA",
                "KUKADI/GUNDARI",
                "SARMA/AKUYAM",
                "SIRKO",
                "TOFU",
                "ZADAWA",
            ],
            NINGI: [
                "BALMA",
                "BASHE",
                "BURRA/KYATA",
                "DINGIS",
                "JANGU",
                "KUDU/YAMMA",
                "KURMI",
                "NASARU",
                "NINGI",
                "SAMA",
                "TIFFI/GUDA",
            ],
            SHIRA: [
                "ANDUBUN",
                "BELI/GAGIDIBA",
                "BUKUL/BANGIRE",
                "DISINA",
                "FAGGO",
                "KILBORI",
                "SAMBUWAL",
                "SHIRA",
                "TSAFI",
                "TUMFAFI",
                "ZUBO",
            ],
            "T/BALEWA": [
                "BALL",
                "BULA",
                "BUNUNU",
                "DAJIN",
                "DULL",
                "KADAM A",
                "KALDAM B",
                "LERE NORTH",
                "LERE SOUTH",
                "TAPSHIN",
                "WAI",
            ],
            TORO: [
                "JAMA'A ZARANDA",
                "LAME",
                "MARA PALAMA",
                "RAHAMA",
                "RAUTA GEJI",
                "RIBINA",
                "TAMA",
                "TILDEN FULANI",
                "TORO TULAI",
                "WONU",
                "ZALAU RISHI",
            ],
            WARJI: [
                "BAIMA NORTH WEST",
                "BAIMA SOUTH EAST",
                "DAGU EAST",
                "DAGU WEST",
                "GABANGA",
                "KATANGA",
                "RANGA",
                "TIYIN",
                "TUDUN WADA EAST",
                "TUDUN WADA WEST",
            ],
            ZAKI: [
                "ALANGAWARI/KAFIN LARABAWA",
                "BURSALI",
                "GUMAI",
                "KATAGUM",
                "MAINAKO",
                "MAIWA",
                "MAKAWA",
                "MURMUR NORTH",
                "MURMUR SOUTH",
                "SAKWA",
                "TASHENA/GADAI",
            ],
        },
    },
    {
        code: "BY",
        name: "BAYELSA",
        lgas: [
            "BRASS",
            "EKEREMOR",
            "KOLOKUMA/OPOKUMA",
            "NEMBE",
            "OGBIA",
            "SAGBAMA",
            "SOUTHERN IJAW",
            "YENAGOA",
        ],
        subs: {
            BRASS: [
                "BRASS WARD I",
                "BRASS WARD II",
                "CAPEFORMOSA",
                "EWOAMA",
                "KONGHO",
                "MINIBIE",
                "ODIOMA/DIEMA",
                "OGINIBIRI",
                "OKPOAMA",
                "SANGANA",
            ],
            EKEREMOR: [
                "EDUWINI I",
                "EDUWINI II",
                "OPOROMOR I",
                "OPOROMOR II",
                "OPOROMOR III",
                "OPOROMOR IV",
                "OPOROMOR V",
                "OYIAKIRI I",
                "OYIAKIRI II",
                "OYIAKIRI III",
                "OYIAKIRI IV",
                "TARAKIRI",
            ],
            "KOLOKUMA/OPOKUMA": [
                "IGBEDI",
                "KAIAMA",
                "KAIAMA/OLOBIRI",
                "ODI CENTRAL",
                "ODI NORTH",
                "ODI SOUTH",
                "OKOLOBA",
                "OPOKUMA NORTH",
                "OPOKUMA SOUTH",
                "SAMPOU/KALAMA",
                "SEIBOKOROGHA SABAGREIA",
            ],
            NEMBE: [
                "BASSAMBIRI I",
                "BASSAMBIRI II",
                "BASSAMBIRI III",
                "BASSAMBIRI IV",
                "IGBETA-EWOAMA",
                "IKENSI",
                "MINI",
                "OGBOLOMABIRI I",
                "OGBOLOMABIRI II",
                "OGBOLOMABIRI III",
                "OKOROMA I",
                "OKOROMA II",
                "OLUASIRI",
            ],
            OGBIA: [
                "ANYAMA",
                "EMEYAL",
                "IMIRINGI",
                "KOLO",
                "OGBIA I",
                "OKODI",
                "OLOGI",
                "OLOIBIRI",
                "OPUME",
                "OTAKEME",
                "OTUABULA",
                "OTUASEGA",
                "OTUOKPOTI",
            ],
            SAGBAMA: [
                "ADAGBABIRI",
                "AGBERE",
                "AGORO",
                "ANGALABIRI",
                "ASAMABIRI",
                "EBEDEBIRI",
                "ODONI",
                "OFONI I",
                "OFONI II",
                "OSEKWENIKE",
                "OSIAMA",
                "SAGBAMA",
                "TORU-EBENI",
                "TROFANI",
            ],
            "SOUTHERN IJAW": [
                "AMASSOMA I",
                "AMASSOMA II",
                "AMASSOMA III",
                "APOI",
                "CENTRAL BOMO I",
                "CENTRAL BOMO II",
                "EAST BOMO I",
                "EAST BOMO II",
                "FOROPA",
                "KOLUAMA",
                "OLODIAMA I",
                "OLODIAMA II",
                "OPOROMA I",
                "OPOROMA II",
                "OTUAN",
                "UKUBIE",
                "WEST BOMO",
            ],
            YENAGOA: [
                "ATTISSA I",
                "ATTISSA II",
                "ATTISSA III",
                "BISENI  II",
                "BISENI I",
                "EKPETIAMA I",
                "EKPETIAMA II",
                "EPIE  I",
                "EPIE  II",
                "EPIE  III",
                "GBARAIN  III",
                "GBARAIN I",
                "GBARAIN II",
                "OKORDIA",
                "ZARAMA",
            ],
        },
    },
    {
        code: "BE",
        name: "BENUE",
        lgas: [
            "ADO",
            "AGATU",
            "APA",
            "BURUKU",
            "GBOKO",
            "GUMA",
            "GWER EAST",
            "GWER WEST",
            "KATSINALA",
            "KONSHISHA",
            "KWADE",
            "LOGO",
            "MAKURDI",
            "OBI",
            "OGADIBO",
            "OJU",
            "OKPOKWU",
            "OMIMII",
            "OTUKPO",
            "TARKA",
            "UKUM",
            "USHONGO",
            "VANDEKYA",
        ],
        subs: {
            ADO: [
                "AKPOGE/OGBILOLO",
                "APA",
                "EKILE",
                "IGUMALE I",
                "IGUMALE II",
                "IJGBAN",
                "OGEGE",
                "ROYONGO",
                "UKWONYO",
                "ULAYI",
            ],
            AGATU: [
                "EGBA",
                "ENUNGBA",
                "OBAGAJI",
                "ODUGBEHO",
                "OGBAULU",
                "OGWULE KADUNA",
                "OGWULE OGBAULU",
                "OKOKOLO",
                "OSHIGBUDU",
                "USHA",
            ],
            APA: [
                "AKPETE/OJANTELE",
                "AUKE",
                "EDIKWU I",
                "EDIKWU II",
                "IGAH-OKPAYA",
                "IGORO",
                "IKOBI",
                "OBA",
                "OFOKE",
                "OIJI",
                "UGBOKPO",
            ],
            BURUKU: [
                "BINEV",
                "ETULO",
                "MB AYA",
                "MBAADE",
                "MBAAKURA",
                "MBAAPEN",
                "MBAATIRKUAA",
                "MBAAZAGEE",
                "MBAIKYONGO/NYIFON",
                "MBAITYOUGH",
                "MBAKYAAN",
                "MBAYAKA",
                "SHOROV",
            ],
            GBOKO: [
                "GBOKO CENTRAL MKT",
                "GBOKO EAST",
                "GBOKO N/WEST",
                "GBOKO SOUTH",
                "IGYOROV",
                "MBAANKO",
                "MBAAVARAKAA",
                "MBADAM",
                "MBADIM",
                "MBAKPEGH",
                "MBAKWEN",
                "MBATAN",
                "MBATYO",
                "MBATZER",
                "UKPE-KPE",
                "YANDEV NORTH",
                "YANDEV SOUTH",
            ],
            GUMA: [
                "ABINSI",
                "KAAMBE",
                "MBABAI",
                "MBADWEM",
                "MBAWA",
                "MBAYER/YANDEV",
                "NYIEV",
                "NZOROV",
                "SAGHEV",
                "UVIR",
            ],
            "GWER EAST": [
                "AKPACHANYI",
                "ALIADE/MBALAV",
                "GBEMACHA",
                "IKYOGBAJIR",
                "IKYONV",
                "ISHOUGH",
                "MBABUR",
                "MBAIASE/MBAKINE",
                "MBAIKYAAN",
                "MBALOM",
                "MBASOSOMBO",
                "MBAYOM",
                "MBIAKYU",
                "UGEE",
            ],
            "GWER WEST": [
                "AVIHIJIME",
                "GBAAGE/TONGOV",
                "GHAMBE-USHIN",
                "IKYAGHEV",
                "ITYOUGHATEE/INJAHA",
                "MBABUANDE",
                "MBACHOHEN",
                "MBANYAMSHI",
                "MBAPA",
                "MERKYEN",
                "SAGHEV/URUSU",
                "SENGEV",
                "SENGEV/YENGEV",
                "TIJIME",
                "TSAMBE/MBESSEV",
            ],
            KATSINALA: [
                "IKURAV-TIEV I",
                "IKURAV-TIEV II",
                "IWAR",
                "K/ALA/TOWNSHIP",
                "MBACHER",
                "MBAJIR",
                "MBATYULA/MBEREV",
                "MBAYONGO",
                "MICHICHE",
                "TIIR",
                "UTANGE",
                "YOOYO",
            ],
            KONSHISHA: [
                "IKYURAV/MBATWER",
                "MBAGUSA/MBATSER",
                "MBAINARNYAM",
                "MBAKE",
                "MBAKYASE",
                "MBANR",
                "MBATSEN",
                "MBAVAA",
                "MBAWAR",
                "MBAYEGH/MBAIKYEGH",
                "TSEAGARAGBA",
            ],
            KWADE: [
                "ADKPO METROPOLIS",
                "KUMAKWAGH",
                "LIVE I",
                "LIVE II",
                "MBADURA",
                "MBAIKYOR",
                "MBAKETSA",
                "MBAYOO",
                "MENEV",
                "MOON",
                "NBAGBA/MBAIKYAN",
                "TAAV",
                "TONDOV I",
                "TONDOV II",
                "USAR",
            ],
            LOGO: [
                "MBADYUL",
                "MBAGBER",
                "MBATER",
                "MBAVUUR",
                "MBAYAM",
                "NENZEV",
                "TOMBO",
                "TURAN",
                "UKEMBREGA/TSWAREV",
                "YONV",
            ],
            MAKURDI: [
                "AGAN",
                "ANKPA/WADATA",
                "BAR",
                "CENTRAL SOUTH MISSION",
                "CLERKS MKT.",
                "FI IDI",
                "MBALAGH",
                "MODERN MKT",
                "NORTH BANK I",
                "NORTH BANK II",
                "WALLOMAYO",
            ],
            OBI: [
                "ADIKO",
                "AOUM-WEST",
                "IKWOKWU",
                "IRABI",
                "ITOGO",
                "OBARIKE",
                "OBEKO",
                "ODIAPA",
                "OGORE",
                "OKPOKWU",
                "OKWUTUNGBE",
                "ORIHI",
            ],
            OGADIBO: [
                "AI- OODO I",
                "AI- OODO II",
                "AI-OON I",
                "AI-OON II",
                "AI-OON III",
                "EHAJA I",
                "EHAJA II",
                "ITABON I",
                "ITABON II",
                "OLACHAGBAHA",
                "ORORAM I",
                "ORORAM II",
                "ORORAM III",
            ],
            OJU: [
                "ADOKPA",
                "AINU",
                "IBBILA",
                "IDELE",
                "IYECHE",
                "OBORU/OYE",
                "OJU",
                "OKPOKPO",
                "OKWUDU",
                "OWO",
                "UKPA AINU/ETTE",
            ],
            OKPOKWU: [
                "AMEJO",
                "EKE",
                "ICHAMA II",
                "OJIGO",
                "OJOGA",
                "OKONBO",
                "OKPALE/INGLE",
                "OKPOGA CENTRAL",
                "OKPOGA NORTH",
                "OKPOGA SOUTH",
                "OKPOGA WEST",
                "UGBOKOLO",
            ],
            OMIMII: [
                "AGADAGBA",
                "AWUME-EHAJE",
                "AWUME-ICHO",
                "EHATOKPE",
                "IDEKPA",
                "OCHOBO",
                "OGLENU-ICHO",
                "OGLEWU-EHAJE",
                "ONYAGEDE-EHAJE",
                "ONYAGEDE-ICHO",
            ],
            OTUKPO: [
                "ADOKA-EHAJE",
                "ADOKA-ICHO",
                "ALLAN",
                "ENTEKPA",
                "EWULO",
                "OKETE",
                "OTOBI",
                "OTUKPO/CENTRAL",
                "OTUKPO/EAST",
                "OTUKPO/WEST",
                "UGBOJU-EHAJE",
                "UGBOJU-ICHO",
                "UGBOJU-OTAHE",
            ],
            TARKA: [
                "MBAAJIRAKAA",
                "MBAAYO",
                "MBACHAVRIKYONDO",
                "MBAIKYAA",
                "MBAIKYO/MBAYIA",
                "MBAKWAKEM",
                "MBANYAGBER",
                "MBIAGBA",
                "SHITILE",
                "TONGOV",
            ],
            UKUM: [
                "ATEKEYANGE",
                "AZENDESHE",
                "BORIKYO",
                "ITYULUV",
                "KENDEV",
                "KUNDAV",
                "LUMBUN",
                "MBATIAN",
                "MBAYENGE",
                "MBAZUM",
                "TSAAV",
                "UGBAAM",
                "UYAM",
            ],
            USHONGO: [
                "ATIRKYE",
                "IKOV",
                "MBAAKA",
                "MBAANYAAM",
                "MBAAWE",
                "MBAGBA",
                "MBAGBWAZA",
                "MBAKUHA",
                "MBAYEGH",
                "TOWNSHIP",
                "UTANGE",
            ],
            VANDEKYA: [
                "MBADEDE",
                "MBAGBAM",
                "MBAGBERA",
                "MBAJOR",
                "MBAKAANGE",
                "MBAKYAHA",
                "MBANYUMAGBAH",
                "MBATYOUGH",
                "MBAYONGO",
                "NINGEV",
                "TOWNSHIP",
                "TSAMBE",
            ],
        },
    },
    {
        code: "BO",
        name: "BORNO",
        lgas: [
            "ABADAM",
            "ASKIRA UBA",
            "BAMA",
            "BAYO",
            "BIU",
            "CHIBOK",
            "DAMBOA",
            "DIKWA",
            "GUBIO",
            "GUZAMALA",
            "GWOZA",
            "HAWUL",
            "JERE",
            "KAGA",
            "KALA BALGE",
            "KONDUGA",
            "KUKAWA",
            "KWAYA KUSAR",
            "MAFA",
            "MAGUMERI",
            "MAIDUGURI M.C",
            "MARTE",
            "MOBBAR",
            "MONGUNO",
            "NGALA",
            "NGANZI",
            "SHANI",
        ],
        subs: {
            ABADAM: [
                "AREGE",
                "BANWA",
                "FOGUWA",
                "JABULLAM",
                "KUDOKURGU",
                "MALLAM FATORI KESSA",
                "MALLAM KAUNARI",
                "YAU",
                "YAWA KURA",
                "YITUWA",
            ],
            "ASKIRA UBA": [
                "ASKIRA EAST",
                "CHUL/RUMIRGO",
                "DILLE/HUYUM",
                "HUSARA/TAMPUL",
                "KOPA/MULTHAFU",
                "LASSA",
                "MUSSA",
                "NGOHI",
                "NGULDE",
                "UBA",
                "UDA/UVU",
                "WAMDEO/GIWI",
                "ZADAWA/HAUSARI",
            ],
            BAMA: [
                "ANDARA/AJIRI/WULBA",
                "BUDUWA/BULA CHIRABE",
                "DIPCHARI/JERE/DARJAMMAL",
                "GULUMBA/NJUKURI/BATRA",
                "KASUGULA",
                "KUMSHE/NDUGUN",
                "LAWANTI/MALLAMMASTAR/ ABBARAM",
                "MARKA/MALGE/AMCHAKA",
                "MBULIYA/GONIRI/SIRAJA",
                "SABSAW/SOYE/BULONGU",
                "SHEHURI/HAUSARI/MAIRI",
                "WULBARI/NDINE/CHAHILE",
                "YABIRI GANA/YABIRI KURA",
                "ZANGERI KESH/KESH",
            ],
            BAYO: [
                "BALBAYA",
                "BRIYEL",
                "FIKAYEL",
                "GAMADADI",
                "JARA GOL",
                "JARADALI",
                "LIMANTI",
                "TELI",
                "WUYO",
                "ZARA",
            ],
            BIU: [
                "BURATAI",
                "DADIN KOWA",
                "DUGJA",
                "GARUBULA",
                "GUR",
                "KENKEN",
                "MANDARA GIRAU",
                "MIRINGA",
                "SULUMTHLA",
                "YAWI",
                "ZARAWUYAKU",
            ],
            CHIBOK: [
                "GARU",
                "GATAMARWA",
                "KAUTIKARI",
                "KRONGLIM",
                "KRUMBULA",
                "LIKAMA",
                "MBALALA",
                "MBOA - KURA",
                "PEMI",
                "SHIKARKIR",
                "WHUNTHAKU",
            ],
            DAMBOA: [
                "AJIGIN (A)",
                "AJIGIN (B)",
                "AZIR, MULTE, FORFOR",
                "BEGO/YERWA, NGIRNA",
                "DAMBO'A",
                "GUMSURI/MISA/KURBUTU",
                "KAFA MAFI",
                "MULGWAI/KUBCHI",
                "NZUDA/WUYARAM",
                "WAWA KOREDE",
            ],
            DIKWA: [
                "BOBOSHE",
                "DIKWA",
                "GAJIBO",
                "GUJILE/UFAYE",
                "MAGARTA",
                "MALLAM MAJA",
                "MUDU KAZA",
                "MULIYE/JEMURI",
                "NGUDURAM",
                "SOGOMO",
            ],
            GUBIO: [
                "ARDIMINI",
                "DABIRA",
                "FELO",
                "GAMOWO",
                "GAZABURE",
                "GUBIO I",
                "GUBIO II",
                "KINGOWA",
                "NGETRA",
                "ZOWO",
            ],
            GUZAMALA: [
                "ADUWA",
                "GUDUMBALI EAST",
                "GUDUMBALI WEST",
                "GUWORAM",
                "GUZAMALA EAST",
                "GUZAMALA WEST",
                "KINGARWA",
                "MAIRARI",
                "MODURI",
                "WAMIRI",
            ],
            GWOZA: [
                "ASHIGASHIYA",
                "BITA/IZGE",
                "DURE/WARA/WARABE",
                "GAVA AGAPALWA",
                "GUDUF NAGADIYO",
                "GWOZA TOWN GADAMAYO",
                "GWOZA WAKANE BULABULIN",
                "HAMBAGDA LIMANKARA NEW SETTLEMENT",
                "JOHODE/CHIKIDE KUGHUM",
                "KIRAWA JIMINI",
                "KURANA BASSA NGOSHE SAMA’A",
                "NGOSHE",
                "PULKA",
            ],
            HAWUL: [
                "BIILINGWI",
                "DZAR/VINADAM/BIRNI/DLANDI",
                "GWANZANG/PUSDA",
                "HIZHI",
                "KIDA",
                "KWAJAFFA/HANG",
                "KWAYA BURA/TANGARUMTA",
                "MARAMA/KIDANG",
                "PAMA/WHITAMBAYA",
                "PUBA/VIDAU/LOKAJA",
                "SAKWA/HEMA",
                "SHAFFA",
            ],
            JERE: [
                "ALAU",
                "BALE/GALTIMARI",
                "DALA LAWANTI",
                "DUSUMAN",
                "GOMARI",
                "GONGULONG",
                "MAIMUSARI",
                "MAIRI",
                "MASHAMARI",
                "NGUDDA/ADDAMARI",
                "OLD MAIDUGURI",
                "TUBA",
            ],
            KAGA: [
                "AFA/DIG/MAUDORI",
                "BARGOZO",
                "BENISHEIK",
                "DOGOMA/JALORI",
                "DONGO",
                "GALANGI",
                "GUWO",
                "KARAGAWURU",
                "MAINK",
                "MARGUBA",
                "NGAMDU",
                "SHETTIMARI",
                "TOBOLO",
                "WAJIRO/BURGUMA",
                "WASSARAM",
            ],
            "KALA BALGE": [
                "JARAWA",
                "JILBE A",
                "JILBE B",
                "KALA",
                "KUMAGA",
                "MADA",
                "MOHOLO",
                "RANN A",
                "RANN B",
                "SIGAL",
            ],
            KONDUGA: [
                "AUN / CHABBAL",
                "DALORI / WANRI",
                "JEWU / LAMBOA",
                "KAWURI",
                "KELLUMIRI / NGALBI-AMARI YALE",
                "KONDUGA",
                "MAIRAMRI / BAZAMRI / YE;ERI",
                "MALARI / KAIGAMARI/ DALWA EAST",
                "MASBA / DALWA WEST",
                "SANDIYA / NYALERI / YAJIWA",
                "SOJIRI / NGURO-NGURO",
            ],
            KUKAWA: [
                "ALAGARN",
                "BAGA",
                "BUNDUR",
                "DOGOSHI",
                "DORO/DUGURI",
                "KAUWA",
                "KEKEN",
                "KUKAWA",
                "MODUARY/BARWATI",
                "YOYO",
            ],
            "KWAYA KUSAR": [
                "GONDI",
                "GUSI/BILA",
                "GUWAL",
                "KUBUKU",
                "KURBA",
                "KWAYA",
                "PETA",
                "WADA",
                "WAWA",
                "YIRMITHAN",
            ],
            MAFA: [
                "ABARI",
                "ANADUA",
                "GAWA",
                "KOSHEBE",
                "LAJE",
                "LIMANTI",
                "LOSKURI",
                "MA'AFA",
                "MAFA",
                "MASU",
                "MUJIGINE",
                "TAMSUNGAMDUA",
            ],
            MAGUMERI: [
                "AGAMMA",
                "ARDORAM",
                "AYI/YASKU",
                "BORN/YU",
                "FURRAM",
                "GAJIGANNA I",
                "GAJIGANNA II",
                "HOYO/CHINGOWA",
                "KALIZORAM/BANRAM",
                "KARERAM",
                "KUBTI",
                "MAGUMERI",
                "NGUMBALA BAMMA",
            ],
            "MAIDUGURI M.C": [
                "BOLORI I",
                "BOLORI II",
                "BULABULIN",
                "FEZZAN",
                "GAMBORU LIBERTY",
                "GWANGE I",
                "GWANGE II",
                "GWANGE III",
                "HAUSARI / ZANGO",
                "LAMISULA JABBAMARI",
                "LIMANTI",
                "MAFONI",
                "MAISANDARI",
                "SHEHURI NORTH",
                "SHEHURI SOUTH",
            ],
            MARTE: [
                "ALA",
                "ALA LAWANTI",
                "BORSORI",
                "GUMNA",
                "KABULAWA",
                "KIRENWA",
                "KULLI",
                "MARTE",
                "MAWULLI",
                "MUSUNE",
                "NGELEWA",
                "NJINE",
                "ZAGA",
            ],
            MOBBAR: [
                "ASAGA",
                "BOGUM",
                "CHAMBA",
                "DAMASAK",
                "DUJI",
                "GASHAGAR",
                "KARETO",
                "LAYI",
                "ZANNA UMORTI",
                "ZARI",
            ],
            MONGUNO: [
                "DAMAKULI",
                "KAGURAM",
                "KUMALIA",
                "MANDALA",
                "MINTAR",
                "MOFIO",
                "MONGUN",
                "NGURN",
                "SURE",
                "WULO",
                "YELE",
                "ZULUM",
            ],
            NGALA: [
                "FUYE",
                "GAMBORU B",
                "GAMBORU C",
                "LOGUMANE",
                "NDUFU",
                "NGALA",
                "OLD GAMBORU A",
                "SAGIR",
                "TUNKALIA",
                "WARSHELE",
                "WULGO",
                "WURGE",
            ],
            NGANZI: ["GAJIRAM"],
            SHANI: [
                "BARGU/BURASHIKA",
                "BUMA",
                "GASI/SALIFAWA",
                "GORA",
                "GWALASHO",
                "GWASKARA",
                "KOMBO",
                "KUBO",
                "KWABA",
                "SHANI",
                "WALAMA",
            ],
        },
    },
    {
        code: "CR",
        name: "CROSS RIVER",
        lgas: [
            "ABI",
            "AKAMKPA",
            "AKPABUYO",
            "BAKASSI",
            "BEKWARRA",
            "BIASE",
            "BOKI",
            "CALABAR MUNI",
            "CALABAR SOUTH",
            "CHIBOK",
            "ETUNG",
            "IKOM",
            "OBANLIKU",
            "OBUBRA",
            "OBUDU",
            "ODUKPANI",
            "OGOJA",
            "YAKURR",
            "YALA",
        ],
        subs: {
            ABI: [
                "ADADAMA",
                "AFAFANYI (IGONIGONI)",
                "EBOM",
                "EDIBA",
                "EKUREKU I",
                "EKUREKU II",
                "IMABANA I",
                "IMABANA II",
                "ITIGIDI",
                "USUMUTONG",
            ],
            AKAMKPA: [
                "AKAMKPA URBAN",
                "AWI",
                "EKU",
                "IKO",
                "IKPAI",
                "MBARAKOM",
                "OBAN",
                "OJUK NORTH",
                "OJUK SOUTH",
                "UYANGA",
            ],
            AKPABUYO: [
                "ATIMBO EAST",
                "ATIMBO WEST",
                "ENEYO",
                "IDUNDU/AYANGANSE",
                "IKANG CENTRAL",
                "IKANG NORTH",
                "IKANG SOUTH",
                "IKOT EDEM ODO",
                "IKOT EYO",
                "IKOT NAKANDA",
            ],
            BAKASSI: [
                "ABANA",
                "AKPANKANYA",
                "AKWA",
                "AMBAI",
                "AMOTO",
                "ARCHIBONG",
                "ATAI EMA",
                "EFUT INWANG",
                "EKPOT ABIA",
                "ODIONG",
            ],
            BEKWARRA: ["ABUOCHICHE", "AFRIKE OCHAGBE", "AFRIKE OKPECHE"],
            BIASE: [
                "ABAYONG",
                "ADIM",
                "AGWAGUNE/OKURIKE",
                "AKPET/ABINI",
                "BIAKPAN",
                "EHOM",
                "EREI NORTH",
                "ERIEI SOUTH",
                "IKUN/ETON",
                "UMON NORTH",
                "UMON SOUTH",
            ],
            BOKI: [
                "ABO",
                "ALANKWU",
                "BEEBO/BUMAJI",
                "BOJE",
                "BUDA",
                "BUENTSEBE",
                "BUNYIA/OKUBUCHI",
                "EKPASHI",
                "KAKWAGOM/BAWOP",
                "OGEP/OSOKOM",
                "OKU/BORUM/NJUA",
            ],
            "CALABAR MUNI": [
                "WARD EIGHT",
                "WARD FIVE",
                "WARD FOUR",
                "WARD NINE",
                "WARD ONE",
                "WARD SEVEN",
                "WARD SIX",
                "WARD TEN",
                "WARD THREE",
                "WARD TWO",
            ],
            "CALABAR SOUTH": [
                "EIGHT",
                "ELEVEN",
                "FIVE",
                "FOUR",
                "NINE",
                "ONE",
                "SEVEN",
                "SIX",
                "TEN",
                "THREE",
                "TWELVE",
                "TWO",
            ],
            CHIBOK: ["GARU"],
            ETUNG: [
                "ABIA",
                "ABIJANG",
                "AGBOKIM",
                "AJASSOR",
                "BENDEGHE EKIEM",
                "EFFRAYA",
                "ETOMI",
                "ITAKA",
                "MKPOT/ AYUK ABA",
                "NSOFANG",
            ],
            IKOM: [
                "ABANYUM",
                "AKPARABONG",
                "IKOM URBAN 1",
                "IKOM URBAN II",
                "NDE",
                "NNAM",
                "NTA/NSELLE",
                "OFUTOP 11",
                "OFUTOP1",
                "OLULUMO",
                "YALA/ NKUM",
            ],
            OBANLIKU: [
                "BASANG",
                "BEBI",
                "BECHEVE",
                "BENDI I",
                "BENDI II",
                "BISHIRI NORTH",
                "BISHIRI SOUTH",
                "BISU",
                "BUSI",
                "UTANGA",
            ],
            OBUBRA: [
                "ABABENE",
                "APIAPUM",
                "IYAMOYONG",
                "OBUBRA URBAN",
                "OCHON",
                "OFAT",
                "OFODUA",
                "OFUMBONGHA/YALA",
                "OSOPONG I",
                "OSOPONG II",
                "OVONUM",
            ],
            OBUDU: [
                "ALAGE/ UBANG",
                "ANGIABA/BEGIAKA",
                "BEGIADING",
                "IPONG",
                "UKPE",
                "URBAN 1",
                "URBAN 2",
                "UTUGWANG CENTRAL",
                "UTUGWANG NORTH",
            ],
            ODUKPANI: [
                "ADIABO/EFUT",
                "AKAMKPA",
                "CREEK TOWN I",
                "CREEK TOWN II",
                "EKI",
                "EKORI ANAKU",
                "ENIONG",
                "IKONETO",
                "ITO/IDERE/UKWA",
                "OBOMITIAT/MBIABO/EDIONG",
                "ODOT",
                "ODUKPANI CENTRAL",
                "ONIMANKIONG",
            ],
            OGOJA: [
                "EKAJUK I",
                "EKAJUK II",
                "MBUBE EAST I",
                "MBUBE EAST II",
                "MBUBE WEST I",
                "MBUBE WEST II",
                "NKUM IBORO",
                "NKUM IREDE",
                "OGOJA URBAN I",
                "OGOJA URBAN II",
            ],
            YAKURR: [
                "ABANAKPI",
                "AFREKPE/EPENTI",
                "AJERE",
                "ASSIGA",
                "BIKO BIKO",
                "IDOMI",
                "IJEMAN",
                "IJOM",
                "IKPAKAPIT",
                "INYIMA",
                "MKPANI/AGOI",
                "NKPOLO/UKPAWEN",
                "NTAN",
            ],
            YALA: [
                "ECHUMOFANA",
                "GABU",
                "IJIRAGA",
                "NTRIGOM/MFUMA",
                "OKPOMA",
                "OKUKU",
                "WANAKOM",
                "WANIHEM",
                "WANIKADE",
                "YACHE",
                "YAHE",
            ],
        },
    },
    {
        code: "DE",
        name: "DELTA",
        lgas: [
            "ANIOCHA NORTH",
            "ANIOCHA SOUTH",
            "BOMADI",
            "BURUTU",
            "ETHIOPE EAST",
            "ETHIOPE WEST",
            "IKA NORTH EAST",
            "IKA SOUTH",
            "ISOKO NORTH",
            "ISOKO SOUTH",
            "NDOKWA EAST",
            "NDOKWA WEST",
            "OBUDU",
            "OKPE",
            "OSHIMILI NORTH",
            "OSHIMILI SOUTH",
            "PATANI",
            "SAPELE",
            "UDU",
            "UGHELLI NORTH",
            "UGHELLI SOUTH",
            "UKWUANI",
            "UVWIE",
            "WARRI NORTH",
            "WARRI SOUTH",
            "WARRI SOUTH WEST",
        ],
        subs: {
            "ANIOCHA NORTH": [
                "EZI",
                "IDUMUJE UNR",
                "ISSELE AZAGBA",
                "ISSELE UKU 11",
                "ISSELE UKU I",
                "OBOMKPA",
                "ONICHA OLONA",
                "ONICHA UGBO",
                "UKWU-NZU",
            ],
            "ANIOCHA SOUTH": [
                "ABA UNR",
                "EJEME",
                "EWULU ISHEAGU",
                "NSUKWA",
                "OGWASHI UKU I",
                "OGWASHI UKU II",
                "OGWASHI UKU VILLAGE",
                "UBULU OKITI",
                "UBULU UKU I",
                "UBULU UKU II",
                "UBULU UNR",
            ],
            BOMADI: [
                "AKUGBENE  I",
                "AKUGBENE  II",
                "AKUGBENE  III",
                "BOMADI",
                "ESANMA",
                "KALAFIOGBENE / EKATAMEGBENE/ELOHIM CITY",
                "KPAKIAMA",
                "OGBEINAMA/OKOLOBA",
                "OGO-EZE",
                "OGRIAGBENE",
            ],
            BURUTU: [
                "BOLOU-NDORO",
                "NGBILEBIRI I",
                "NGBILEBIRI II",
                "OBOTEBE",
                "OGBOLUBIRI",
                "OGULAGHA",
                "OJOBO",
                "SEIMBIRI",
                "TAMIGBE",
                "TORUGBENE",
                "TUOMO",
            ],
            "ETHIOPE EAST": [
                "ABRAKA I",
                "ABRAKA II",
                "ABRAKA III",
                "AGBON I",
                "AGBON II",
                "AGBON III",
                "AGBON IV",
                "AGBON V",
                "AGBON VI",
                "AGBON VII",
                "AGBON VIII",
            ],
            "ETHIOPE WEST": [
                "JESSE I",
                "JESSE II",
                "JESSE III",
                "JESSE IV",
                "MOSOGAR I",
                "MOSOGAR II",
                "OGHARA I",
                "OGHARA II",
                "OGHARA III",
                "OGHARA IV",
                "OGHARA V",
            ],
            "IKA NORTH EAST": [
                "AKUMAZI",
                "IDUMUESAH",
                "IGBODO",
                "MBIRI",
                "OTOLOKPO",
                "OWA I",
                "OWA II",
                "OWA III",
                "OWA IV",
                "OWA V",
                "OWA VI",
                "UMUNEDE",
                "UTE-OGBEJE",
                "UTE-OKPU",
            ],
            "IKA SOUTH": [
                "ABAVO I",
                "ABAVO II",
                "ABAVO III",
                "AGBOR TOWN I",
                "AGBOR TOWN II",
                "BOJI-BOJI I",
                "BOJI-BOJI II",
                "BOJI-BOJI III",
                "EKUKU-AGBOR",
                "IHUIYASE I",
                "IHUIYASE II",
                "IHUZOMOR/ OZANGOGO",
            ],
            "ISOKO NORTH": [
                "ELLU/OVRODE/OVRODE",
                "EMEVOR",
                "ILUELOGBO",
                "IYEDE I",
                "IYEDE II",
                "OFAGBE",
                "OKPE-ISOKO",
                "OTIBIO",
                "OTOR-OWHE/AKIEWHE",
                "OYEDE",
                "OZORO I",
                "OZORO II",
                "OZORO III",
            ],
            "ISOKO SOUTH": [
                "AVIARA",
                "EMEDE",
                "ENHWE/OKPOLO",
                "EROWA/UMEH",
                "IGBIDE",
                "IRRI I",
                "IRRI II",
                "OLEH I",
                "OLEH II",
                "OLOMORO",
                "UZERE",
            ],
            "NDOKWA EAST": [
                "ABARRA/INYI/ONUABOH",
                "ABOH/AKARAAI",
                "AFOR/OBIKWELE",
                "ASE",
                "ASHAKA",
                "IBEDENI",
                "IBREDE/IGBUKU/ONGBOKOR",
                "OKPAI/UTCHI/BENEKU",
                "ONYAI/ADIAI/UMUOLU/ UTUOKWU",
                "OSSISSA",
            ],
            "NDOKWA WEST": [
                "ABBI I",
                "ABBI II",
                "EMU",
                "OGUME I",
                "OGUME II",
                "ONICHA UKWANI",
                "UTAGBA OGBE",
                "UTAGBA UN I",
                "UTAGBA UN II",
                "UTAGBA UN III",
            ],
            OBUDU: ["UTUGWANG SOUTH"],
            OKPE: [
                "AGHALOKPE",
                "ARHAGBA",
                "MEREJE I",
                "MEREJE II",
                "MEREJE III",
                "OHA I",
                "OHA II",
                "OREROKPE",
                "OVIRI OKPE",
                "UGHOTON",
            ],
            "OSHIMILI NORTH": [
                "AKWUKWU IGBO",
                "EBU",
                "IBUSA I",
                "IBUSA II",
                "IBUSA III",
                "IBUSA IV",
                "IBUSA V",
                "ILLAH",
                "OKPANAM",
                "UKALA",
            ],
            "OSHIMILI SOUTH": [
                "AGU",
                "ANALA / AMAKON",
                "CABLE POINT I",
                "CABLEPOINT II",
                "OGBELE / AKPAKO",
                "OKWE",
                "UGBOMANTA",
                "UMUAJI",
                "UMUEZEI",
                "UMUONAJE",
                "WEST - END",
            ],
            PATANI: [
                "ABARI",
                "AGOLOMA",
                "BOLOU – ANGIAMA",
                "ODORUBU/ADOBUL/BOLOU APELEBIRI",
                "PATANI II",
                "PATANI III",
                "PATNI II",
                "TAWARE/KOLOWARE/AVEN",
                "TORU ANGIAMA",
                "UDUOPHORI",
            ],
            SAPELE: [
                "AMUOKPE",
                "ELUME",
                "OKOKPORO/UGBORHEN",
                "SAPELE URBAN I",
                "SAPELE URBAN II",
                "SAPELE URBAN III",
                "SAPELE URBAN IV",
                "SAPELE URBAN V",
                "SAPELE URBAN VI",
                "SAPELE URBAN VII",
                "SAPELE URBAN VIII",
            ],
            UDU: [
                "ALADJA",
                "EKETE",
                "EMADAJA",
                "OPETE/OKPAKA",
                "ORHUWHORUN",
                "OTOR UDU",
                "OVWIAN I",
                "OVWIAN II",
                "OWHODE",
                "UDU II",
            ],
            "UGHELLI NORTH": [
                "AGBARHA",
                "AGBARHO I",
                "AGBARHO II",
                "EVWRENI",
                "OGOR",
                "OROGUN I",
                "OROGUN II",
                "UGHELLI I",
                "UGHELLI II",
                "UGHELLI III",
                "UWHERU",
            ],
            "UGHELLI SOUTH": [
                "EFFURUN-OTOR",
                "EKAKPAMRE",
                "EWU I",
                "EWU II",
                "EWU III",
                "JEREMI I",
                "JEREMI II",
                "JEREMI III",
                "JEREMI IV",
                "OLOMU I",
                "OLOMU II",
            ],
            UKWUANI: [
                "AKOKU",
                "AMAI",
                "EBEDEI",
                "EZIOKPOR",
                "EZIONUM",
                "OBIARUKU I",
                "OBIARUKU II",
                "UMUEBU",
                "UMUKWATA",
                "UMUTU",
            ],
            UVWIE: [
                "ARMY BARRACKS AREA",
                "EFFURUN I",
                "EFFURUN II",
                "EKPAN  I",
                "EKPAN II",
                "ENERHEN I",
                "ENERHEN II",
                "UGBOMRO/UGBOLOKPOSO",
                "UGBORIKOKO",
                "UGBOROKE",
            ],
            "WARRI NORTH": [
                "EBROHIMI",
                "EGHORO",
                "GBOKODA",
                "KOKO1",
                "KOKO2",
                "OGBINBIRI",
                "OGBUDUGBUDU",
                "OGHEYE",
                "OPUAMA",
                "TSEKELEWU (EGBEMA)",
            ],
            "WARRI SOUTH": [
                "BOWEN",
                "EDJEBA",
                "G.R.A",
                "IGBUDU",
                "OBODO/ OMADINO",
                "ODE-ITSEKIRI",
                "OGUNU/EKUREDE URHOBO",
                "OKERE",
                "OKUMAGBA I",
                "OKUMAGBA II",
                "PESSU",
                "UGBUWANGUE/ EKUREDE ITSEKIRI",
            ],
            "WARRI SOUTH WEST": [
                "WARD  5 UGBORORDO",
                "WARD 1 OGBE-IJOH",
                "WARD 10 OGIDIGBEN",
                "WARD 2 ISABA",
                "WARD 3 OPOROZA",
                "WARD 4 GBARAMATU",
                "WARD 6 AKPIKPA",
                "WARD 7 MADANGHO",
                "WARD 8 ORERE",
                "WARD 9 AJUDAIBO",
            ],
        },
    },
    {
        code: "EB",
        name: "EBONYI",
        lgas: [
            "ABAKALIKI",
            "AFIKPO NORTH",
            "AFIKPO SOUTH",
            "EBONYI",
            "EZZA NORTH",
            "EZZA SOUTH",
            "IKWO",
            "ISHIELU",
            "IVO",
            "IZZI",
            "OHAOZARA",
            "OHAUKWU",
            "ONICHA",
        ],
        subs: {
            ABAKALIKI: [
                "ABAKPA",
                "AMACHI NDEBOR",
                "AMACHI NDEGU",
                "AMAGU ENYIGBA",
                "AMAGU UNUHU",
                "AZUIYIOKWU",
                "AZUIYIUDENE",
                "AZUMINI/AZUGWU",
                "EDDA",
                "IZZI UNUHU",
                "NDIAGU",
                "OKPUITUMO NDIEBOER",
                "OKPUITUMO NDIEGU",
                "TIMBER SHED",
            ],
            "AFIKPO NORTH": [
                "AMATA AKPOHA",
                "AMOGU AKPOHA",
                "EZEKE AMASIRI",
                "IBII/OZIZZA",
                "ITIM",
                "NKPOGHORO",
                "OHAISU \"A'",
                "OHAISU \"B'",
                "POPERI AMASIRI",
                "UGWUEGU",
                "UNWANA 'A'",
                "UNWANA 'B'",
            ],
            "AFIKPO SOUTH": [
                "AMAEKE EKOLI",
                "AMANGWU",
                "AMIGBO",
                "AMIRI EKOLI",
                "AMOSO",
                "EBUNWANA",
                "NDIOKE",
                "NGUZU",
                "OGBU",
                "OSO",
                "OWUTU",
            ],
            EBONYI: [
                "ABAKPA",
                "ABOFIA",
                "AGALEGU",
                "ECHIABA",
                "EGWUDINAGU",
                "ENYIBICHIRI I",
                "ENYIBICHIRI II",
                "KPIRIKPIRI",
                "MBEKE",
                "NDIAGU",
                "NDIEBOR",
                "ONUEBONYI",
                "URBAN NEW LAYOUT",
            ],
            "EZZA NORTH": [
                "AMUDA/AMAWULA",
                "EKKA",
                "IYERE",
                "NDIEGUAZU UMUOGHARA",
                "NKOMORO",
                "OGBOJI",
                "OKPOSI UMUOGHARA",
                "OMEGE UMUEZEOKOHA",
                "ORIUZOR",
                "OSHIEGBE UMUEZEOKOHA",
                "UMUEZEOKA",
            ],
            "EZZA SOUTH": [
                "AMAEZEKWE",
                "AMAGU/NSOKKARA",
                "AMANA",
                "AMEKA",
                "AMUDO/OKAFFIA",
                "AMUZU",
                "ECHARA",
                "EZZAMA",
                "IKWUATOR/IDEMBIA",
                "ONUEKE URBAN",
                "UMUNWAGU/IDEMBIA",
            ],
            IKWO: [
                "AKPANWUDELE",
                "AMAINYIMA",
                "ECHIALIKE",
                "EKKA AWOKE",
                "EKPELU",
                "ENYIBICHIRI",
                "ETTAM",
                "IGBUDU I",
                "IGBUDU II",
                "INYIMAGU I",
                "INYIMAGU II",
                "NDIAGU ECHARA I",
                "NDIAGU ECHARA II",
                "NDIAGU INYIMAGU I",
                "NDIAGU INYIMAGU II",
                "NDUFU ALIKE",
                "NDUFU AMAGU I",
                "NDUFU AMAGU II",
                "NDUFU ECHARA",
                "NOYO",
            ],
            ISHIELU: [
                "AGBA",
                "AMAEZU",
                "AZUINYIBA \"A'",
                "AZUINYIBA \"B'",
                "EZILLO I",
                "EZILLO II",
                "EZZAGU I (OGBOJI)",
                "EZZAGU II NKOMORO)",
                "IYONU",
                "NKALAGU",
                "NKALAHA",
                "NTEZU",
                "OBEAGU",
                "OHOFIA",
                "OKPOTO",
                "UMUHUALI",
            ],
            IVO: [
                "AKAECE UKWU",
                "AMAEZE",
                "AMAGU",
                "AMONYE",
                "IHENTA OGIDI",
                "IYIOJI",
                "NDIOKORO UKWU",
                "NGWONGWO",
                "OBINAGU",
                "OKUE",
                "UMUBO",
            ],
            IZZI: [
                "AGBAJA ANYANWUIGWE",
                "AGBAJA MGBO",
                "AGBAJA OFFIA ONWE",
                "EZZA INYIMAGU IGBUHU",
                "EZZA INYIMAGU IGWELEDOHA",
                "EZZA INYIMAGU IZIOGO",
                "EZZA INYIMAGU NDIAGU",
                "GBEAGU NEI ETTAH",
                "IGBEAGU  NDUOGBU",
                "IGBEAGU III",
                "MGBALAUKWU INYIMAGU I",
                "MGBALAUKWU INYIMAGU II",
                "NDIEZE INYIMAGU MGBABELUZOR",
                "NDIEZE INYIMAGU II NDIABOR ISHIAGU",
            ],
            OHAOZARA: [
                "AMAECHI OKPOSI",
                "ENE-NA-EZERAKU",
                "MGBOM OKPOSI",
                "OBIOZARA",
                "OKPOSI ACHARA",
                "OKPOSI OKWU",
                "UGBOGOLOGO",
                "UHUOTARU",
                "UMUCHIMA",
                "UMUNAGA",
                "UMUOBUNA",
            ],
            OHAUKWU: [
                "EFFIUM I",
                "EFFIUM II",
                "EZZANGBO",
                "ISHINGBO I",
                "ISHINGBO II",
                "NGBO",
                "OKPOSHI I",
                "OKPOSHI II",
                "UMUAGARA/AMAECHI",
                "UMUOGUDU AKPU I",
                "UMUOGUDU AKPU II",
                "UMUOGUDU OSHIA",
                "WIGBEKE I",
                "WIGBEKE II",
                "WIGBEKE III",
            ],
            ONICHA: [
                "ABAOMEGE",
                "AGBABOR ISU",
                "AMANATOR ISU",
                "EBIA OSHIRI",
                "ENUAGU ONICHA",
                "ISI ONICHA",
                "ISINKWO UKAWU",
                "OBEAGU ISU",
                "OGUDU OKWOR OSHIRI",
                "OKUZU UKAWU",
                "UGWU OSHIRI",
                "UMUDOMI ONICHA",
            ],
        },
    },
    {
        code: "ED",
        name: "EDO",
        lgas: [
            "AKOKO EDO",
            "EGOR",
            "ESAN CENTRAL",
            "ESAN NORTH EAST",
            "ESAN SOUTH EAST",
            "ESAN WEST",
            "ETSAKO CENTRAL",
            "ETSAKO EAST",
            "ETSAKO WEST",
            "IGUEBEN",
            "IKPOBA OKHA",
            "OREDO",
            "ORHIONMWON",
            "OVIA NORTH EAST",
            "OVIA SOUTH WEST",
            "OWAN EAST",
            "OWAN WEST",
            "UHUNMWONDE",
        ],
        subs: {
            "AKOKO EDO": [
                "ENWAN/ATTE/IKPESHI/ EGBIGELE",
                "IBILLO/EKPESA/IKIRANILE/ IKIRAN OKE",
                "IGARRA I",
                "IGARRA II",
                "IMOGA/LAMPESE/BEKUMA/ EKPE",
                "MAKEKE/OJAH/DANGBALA/ OJIRAMI",
                "OLOMA/OKPE/IJAJA/ IKAKUMO/ANYANRA",
                "OSOSO",
                "SOMORIKA/OGBA/SASARO/ ONUMU",
                "UNEME NEKHUA/AKPAMA/ AIYETORO/EKPEDO/UNEME OSU",
            ],
            EGOR: [
                "EGOR",
                "EVBAREKE",
                "OGIDA/USE",
                "OKHORO",
                "OLIHA",
                "OTUBU",
                "UGBOWO",
                "USELU I",
                "USELU II",
                "UWELU",
            ],
            "ESAN CENTRAL": [
                "EWU I",
                "EWU II",
                "IKEKATO",
                "OPOJI",
                "OTORUWO I",
                "OTORUWO II",
                "UGBEGUN",
                "UNEAH",
                "UWESSAN I",
                "UWESSAN II",
            ],
            "ESAN NORTH EAST": [
                "AMEDOKHAIN",
                "ARUE",
                "EFANDION",
                "EGBELE",
                "EWOYI",
                "IDUMU OKOJIE",
                "OBEIDU",
                "UBIERUMU",
                "UELEN OKUGBE",
                "UWALOR",
                "UZEA",
            ],
            "ESAN SOUTH EAST": [
                "EMU",
                "EWATTO",
                "EWOHIMI  II",
                "EWOHIMI I",
                "ILLUSHI I",
                "ILLUSHI II",
                "OHORDUA",
                "UBIAJA I",
                "UBIAJA II",
                "UGBOHA",
            ],
            "ESAN WEST": [
                "EGORO/IDOA/UKHUN",
                "EMUADO/EGUARE/EKPOMA",
                "EMUHI/ UKPENU/ UJOELEN",
                "IHUMUDUMU/ IDUMEBO/ IJEMEN/ UKE",
                "ILLEH/EKO-INE",
                "IRUEKPEN",
                "OGWA",
                "UHIELE",
                "UJIOGBA",
                "UROHI",
            ],
            "ETSAKO CENTRAL": [
                "EKPERI I",
                "EKPERI II",
                "EKPERI III",
                "FUGAR I",
                "FUGAR II",
                "FUGAR III",
                "IRAOKHOR",
                "OGBONA",
                "SOUTH UNEME I",
                "SOUTH UNEME II",
            ],
            "ETSAKO EAST": [
                "AGENEBODE",
                "OKPEKPE",
                "OKPELLA I",
                "OKPELLA II",
                "OKPELLA III",
                "OKPELLA IV",
                "THREE IBIES",
                "WANNO I",
                "WANNO II",
                "WEPPA",
            ],
            "ETSAKO WEST": [
                "ANWAIN",
                "AUCHI",
                "AUCHI I",
                "AUCHI II",
                "AUCHI III",
                "AVIGLE",
                "JAGBE",
                "SOUTH IBIE",
                "UZAIRUE NORTH EAST",
                "UZAIRUE NORTH WEST",
                "UZAIRUE SOUTH EAST",
                "UZAIRUE SOUTH WEST",
            ],
            IGUEBEN: [
                "AFUDA/IDUMUOKA",
                "AMAHOR/UGUN",
                "EKEKHEN/IDUMOGO/EGBIKI",
                "EKPON",
                "EWOSSA",
                "IDIGUN/IDUMEDO",
                "OKALO/OKPUJIE",
                "OWU/OKUTA/EGUARE EBELLE",
                "UDO",
                "UHE/IDUMUOGBO/IDUMEKE",
            ],
            "IKPOBA OKHA": [
                "ADUWAWA / EVBOMODU",
                "GORRETTI",
                "IDOGBO",
                "IWOGBAN/UTEH",
                "OBAYANTOR",
                "OGBESON",
                "OLOGBO",
                "OREGBENI",
                "ST. SAVIOUR",
                "UGBEKUN",
            ],
            OREDO: [
                "G.R.A/ETETE",
                "IBIWE/IWEGIE/UGBAGUE",
                "IKPEMA/EGUADASE",
                "NEW BENIN I",
                "NEW BENIN II",
                "OGBE",
                "OGBELAKA/NEKPENEKPE",
                "OKEDO",
                "UNUERU/OGBOKA",
                "URU/IWEHEN/IHOGBE/ICE RD",
                "URUBI/EVBIEMWEN/IWEHEN",
                "UZEBU",
            ],
            ORHIONMWON: [
                "AIBIOKULA I",
                "AIBIOKULA II",
                "EVBOESI",
                "IGBANKE EAST",
                "IGBANKE WEST",
                "IYIOBA",
                "UGBEKA",
                "UGBOKO",
                "UGU",
                "UKPATO",
                "URHONIGBE NORHT",
                "URHONIGBE SOUTH",
            ],
            "OVIA NORTH EAST": [
                "ADOLOR",
                "IGUOSHODIN",
                "ISIUWA",
                "ODUNA",
                "OFUNMWEGBE",
                "OGHEDE",
                "OKADA EAST",
                "OKADA WEST",
                "OKOKHUO",
                "OLUKU",
                "UHEN",
                "UHIERE",
                "UTOKA",
            ],
            "OVIA SOUTH WEST": [
                "IGUOBAZUWA EAST",
                "IGUOBAZUWA WEST",
                "NIKOROGHA",
                "OFUNAMA",
                "ORA",
                "SILUKO",
                "UDO",
                "UGBOGUI",
                "UMAZA",
                "USEN",
            ],
            "OWAN EAST": [
                "EMAI I",
                "EMAI II",
                "IGUE/IKAO",
                "IHIEVBE II",
                "IHIEVEBE I",
                "IVBIADAOBI",
                "IVBIANION",
                "OTUO I",
                "OTUO II",
                "UOKHA/AKE",
                "WARRAKE",
            ],
            "OWAN WEST": [
                "AVBIOSI",
                "EME-ORA",
                "ERUERE",
                "OKPUJE",
                "OZALLA",
                "SABONGIDDA-ORA",
                "SOBE",
                "UHUNMORA",
                "UHUNSE-OSI",
                "UZEBBA I",
                "UZEBBA II",
            ],
            UHUNMWONDE: [
                "EGBEDE",
                "EHOR",
                "IGIEDUMA",
                "IRHUE",
                "ISI NORTH",
                "ISI SOUTH",
                "OHUAN",
                "UHI",
                "UMAGBAE SOUTH",
                "UMAGEA NORTH",
            ],
        },
    },
    {
        code: "EK",
        name: "EKITI",
        lgas: [
            "ADO",
            "EFON",
            "EKITI EAST",
            "EKITI SOUTH WEST",
            "EKITI WEST",
            "EMURE",
            "GBONYIN",
            "IDO OSI",
            "IJERO",
            "IKERE",
            "IKOLE",
            "ILEJEMEJE",
            "IREPODUN IFELODUN",
            "ISE/ORUN",
            "MOBA",
            "OYE",
        ],
        subs: {
            ADO: [
                "ADO ‘A’ IDOFIN",
                "ADO ‘B’ INISA",
                "ADO ‘C’ IDOLOFIN",
                "ADO ‘D’ IJIGBO",
                "ADO ‘E’ IJOKA",
                "ADO ‘F’ OKEYINMI",
                "ADO ‘G’ OKE ILA",
                "ADO ‘H’ EREGURU",
                "ADO ‘I’ DALIMORE",
                "ADO ‘J’ OKESA",
                "ADO ‘K’ IRONA",
                "ADO ‘L’ IGBEHIN",
                "ADO ‘M’ FARM SELTLEMENT",
            ],
            EFON: [
                "EFON I",
                "EFON II",
                "EFON III",
                "EFON IV",
                "EFON IX",
                "EFON V",
                "EFON VI",
                "EFON VII",
                "EFON VIII",
                "EFON X",
            ],
            "EKITI EAST": [
                "ARAROMI OMUO",
                "ILASA I",
                "ILASA II/IIKUN OBA /ARAROMI OKE",
                "ISINBODE",
                "KOTA I",
                "KOTA II",
                "OBADORE I",
                "OBADORE II",
                "OBADORE III",
                "OBADORE IV",
                "OMUO- OKE I",
                "OMUO-OKE II",
            ],
            "EKITI SOUTH WEST": [
                "IGBARA ODO I",
                "IGBARA ODO II",
                "ILAWE I",
                "ILAWE II",
                "ILAWE III",
                "ILAWE IV",
                "ILAWE V",
                "ILAWE VI",
                "ILAWE VII",
                "OGOGTUN II",
                "OGOTUN I",
            ],
            "EKITI WEST": [
                "ARAMOKO I",
                "ARAMOKO II",
                "ARAMOKOIII",
                "ERIJIYAN 1",
                "ERIJIYAN 11",
                "IDO AJINARE",
                "IKOGOSI",
                "IPOLE ILORO",
                "OKEMESI 1",
                "OKEMESI ll",
                "OKEMESI lll",
            ],
            EMURE: [
                "IDAMUDU I",
                "IDAMUDU II",
                "ODO EMURE I",
                "ODO EMURE II",
                "ODO EMURE III",
                "ODO EMURE IV",
                "OGBONTIORO I",
                "OGBONTIORO II",
                "OKE EMURE I",
                "OKE EMURE II",
            ],
            GBONYIN: [
                "AGBADO",
                "AISEGBA I",
                "AISEGBA II",
                "EGBE/IRO",
                "IJAN",
                "ILUOMOBA",
                "IMESI",
                "ODE I",
                "ODE II",
                "ODE III",
            ],
            "IDO OSI": [
                "AYETORO I",
                "AYETORO II",
                "IDO I",
                "IDO II",
                "IFAKI I",
                "IFAKI II",
                "IGBOLE/IFISIN/AAYE",
                "ILOGBO",
                "ORIN/ORA",
                "OSI",
                "USI",
            ],
            IJERO: [
                "EKAMARUN",
                "EKAMETA",
                "IJERO A",
                "IJERO B",
                "IJERO C",
                "IJERO D",
                "IKORO",
                "ILORO A",
                "ILORO/IJURIN",
                "IPOTI",
                "IPOTI B",
                "ODO-OWA",
            ],
            IKERE: [
                "AFAO/KAJOLA",
                "AGBADO/OYO",
                "ARE ARAROMI",
                "ATIBA/AAFIN",
                "IDEMO",
                "ILAPETU/IJAO",
                "ODOSE",
                "OGBONJANA",
                "OKE-OSUN",
                "OKERUKU",
                "UGELE/AROKU",
            ],
            IKOLE: [
                "ARAROMI/ BOLUWADURO",
                "IJESA ISU",
                "IKOLE EAST",
                "IKOLE NORTH",
                "IKOLE SOUTH",
                "IKOLE WEST I",
                "IKOLE WEST II",
                "IPAO/OKE AKO/IRELE",
                "ITAPAJI/ IYEMERO",
                "ODO AYEDUN",
                "ODO AYEDUN/ AYEBODE",
                "OKE AYEDUN",
            ],
            ILEJEMEJE: [
                "EDA ONIYO",
                "EWU",
                "IJESAMODU",
                "ILUDUN I",
                "ILUDUN II",
                "IPERE",
                "IYE I",
                "IYE II",
                "IYE III",
                "OBADA",
            ],
            "IREPODUN IFELODUN": [
                "AFAO",
                "ARE",
                "AWO",
                "IGBEMO",
                "IGEDE I",
                "IGEDEII",
                "IGEDEIII",
                "IROPORA/ESURE/EYIO",
                "IWOROKO",
                "IYIN I",
                "IYIN II",
            ],
            "ISE/ORUN": [
                "ERINWA I",
                "ERINWA II",
                "ODO ISE I",
                "ODO ISE II",
                "ODO ISE III",
                "ORAYE I",
                "ORAYE II",
                "ORAYE III",
                "ORUN I",
                "ORUN II",
            ],
            MOBA: [
                "ERINMOPE I",
                "ERINMOPE II",
                "IGOGO I",
                "IGOGO II",
                "IKUN I",
                "IKUN II",
                "OSAN",
                "OSUN",
                "OTUN I",
                "OTUN II",
                "OTUN III",
            ],
            OYE: [
                "AYEDE NORTH",
                "AYEDE SOUTH",
                "AYEGBAJU",
                "ILUPEJU I",
                "ILUPEJU II",
                "IRE I",
                "IRE II",
                "ISAN/ILAFON/ILEMESO",
                "ITAPA/OSIN",
                "OMU/IJELU",
                "OYE I",
                "OYE II",
            ],
        },
    },
    {
        code: "EN",
        name: "ENUGU",
        lgas: [
            "ANINRI",
            "AWGU",
            "ENUGU EAST",
            "ENUGU NORTH",
            "ENUGU SOUTH",
            "EZEAGU",
            "IGBO EKITI",
            "IGBO EZE NORTH",
            "IGBO EZE SOUTH",
            "ISI UZO",
            "NKANU",
            "NKANU WEST",
            "NSUKKA",
            "OJI RIVER",
            "UDENU",
            "UDI",
            "UZO UWANI",
        ],
        subs: {
            ANINRI: [
                "MPU",
                "NDEABOH",
                "NENWE I",
                "NENWE II",
                "NENWE III",
                "ODUMA I",
                "ODUMA II",
                "ODUMA III",
                "ODUMA IV",
                "OKPANKU",
            ],
            AWGU: [
                "AGBOGUGU",
                "AMOLI/OGUGU/UGBO/OWELLI",
                "ANIKENAN",
                "AWGU I",
                "AWGU II",
                "IHE",
                "ISUAWA/ AGBUDU/ ITUKU",
                "MGBIDI/MAKU",
                "MGBOWO",
                "OBEAGU",
                "OGBAKU",
            ],
            "ENUGU EAST": [
                "ABAKPA I",
                "ABAKPA II",
                "AMORJI NIKE",
                "IBAGWA NIKE/EDEM",
                "MBULUIYIUKWU",
                "MBULUNJODO EAST",
                "MBULUNJODO WEST",
                "MBULUOWEHE",
                "TRANS EKULU",
                "UGWOGO NIKE",
                "UMUCHIGBO",
                "UMUENWENE",
            ],
            "ENUGU NORTH": [
                "ASATA TOWNSHIP",
                "CHINA TOWN",
                "GRA",
                "IHEWUZI",
                "INDEPENDENCE LAYOUT",
                "NEW HAVEN",
                "OGBETE EAST",
                "OGBETE WEST",
                "OGUI NEW LAYOUT",
                "OGUI TOWNSHIP",
                "ONU-ASATA",
                "UDI SIDING/ IVA VALLEY",
                "UMUNEVO",
            ],
            "ENUGU SOUTH": [
                "ACHARA LAYOUT EAST",
                "ACHARA LAYOUT WEST",
                "AKWUKE",
                "AMECHI I",
                "AMECHI II",
                "AWKUNANAW EAST",
                "AWKUNANAW WEST",
                "MARYLAND",
                "OBEAGU I",
                "OBEAGU II",
                "UGWUAJI",
                "UWANI EAST",
                "UWANI WEST",
            ],
            EZEAGU: [
                "AGBA UMANA",
                "AGUOBU (UMUMBA)",
                "AGUOBU OWA I",
                "AGUOBU OWA II",
                "AWHA",
                "IMEZI OWA I",
                "IMEZI OWA II",
                "IWOLLO",
                "MGBAGBU OWA I",
                "MGBAGBU OWA II",
                "OBELEAGU UMANA",
                "OBINFIA",
                "OGHE I",
                "OGHE II",
                "OGHE III",
                "OKPOGHO",
                "OLO/AMAGU/UMULOKPA I",
                "OLO/AMAGU/UMULOKPA II",
                "UMANA NDIAGU",
                "UMUMBA NDIUN",
            ],
            "IGBO EKITI": [
                "AKU I",
                "AKU II",
                "AKU III",
                "AKU IV",
                "AKU V",
                "DIOGBE/UMUNKO",
                "EJUONA/UDUEME",
                "EKWEGBE I",
                "EKWEGBE II",
                "IKOLO OHEGBE",
                "OHODO I",
                "OHODO II",
                "OYOHO/OCHIMA/IDOHA",
                "OZALLA I",
                "OZALLA II",
                "UKEHE I",
                "UKEHE II",
                "UKEHE III",
                "UKEHE IV",
                "UKEHE V",
            ],
            "IGBO EZE NORTH": [
                "ESSODO I",
                "ESSODO II",
                "ESSODO III",
                "ETTE CENTRAL",
                "ETTE I",
                "ETTE II",
                "EZZODO",
                "UMUITODO I",
                "UMUOZZI I",
                "UMUOZZI II",
                "UMUOZZI III",
                "UMUOZZI IV",
                "UMUOZZI IX",
                "UMUOZZI V",
                "UMUOZZI VI",
                "UMUOZZI VII",
                "UMUOZZI VIII",
                "UMUOZZI X",
                "UMUTIODO II",
                "UMUUITODO III",
            ],
            "IGBO EZE SOUTH": [
                "ALOR-AGU",
                "AMEBO/HAUSA/YORUBA",
                "ECHARA",
                "EZEMA",
                "IHEAKA LIKKE/AKUTARA",
                "IHEAKA UGO/AKOYI",
                "IHEAKPU AJUONA",
                "IHEAKPU EZZI NGWU",
                "ITCHI UWANI I",
                "ITCHI UWANI II",
                "NKALAGU OBUKPA",
                "OVOKO AJUONA",
                "OVOKO UMULOLO",
                "UHUNWERRE",
                "UMELO OVOKO AGU",
                "UNADU",
            ],
            "ISI UZO": [
                "EHA AMUFU I",
                "EHA AMUFU II",
                "EHA AMUFU III",
                "EHA AMUFU IV",
                "MBU I",
                "MBU II",
                "NEKE I",
                "NEKE II",
                "NKEM I",
                "NKEM II",
                "UMUALOR",
            ],
            NKANU: [
                "AKPAWFU/ISI-ENU/AMAGNZE",
                "AMANKANU/OGBAHU",
                "AMECHI/IDODO/ORUKUI",
                "IHUOKPARA",
                "MBURUMBU",
                "NARA I",
                "NARA II",
                "NKEREFI I",
                "NKEREFI II",
                "NMEH",
                "OHUANI/ONICHAAGU/ AMAUNZE",
                "OWO",
                "UGBAWKA I",
                "UGBAWKA II",
            ],
            "NKANU WEST": [
                "AGBANI",
                "AKEGBE UGWU",
                "AKPUGO I",
                "AKPUGO II",
                "AKPUGO III",
                "AKPUGO IV",
                "AKPUGO V",
                "AMODU",
                "AMURRI",
                "IBITE AKEGBE",
                "OBE",
                "OBUOFFIA",
                "OZALLA",
                "UMUEZE",
            ],
            NSUKKA: [
                "AGBAME/UMABOR",
                "AKAIBUTE",
                "AKPA/OZZI",
                "ALOR UN",
                "EDE-NTA",
                "EDE-UKWU",
                "EDEM-ANI",
                "EHA-NDIAGU",
                "EHA-UN",
                "EJUONA/UWANI",
                "IBAGWANI/IBAGWA",
                "IBEKU",
                "IDI/OGBOZALA",
                "IHE",
                "MKPUNAN",
                "NRU",
                "OBIMO/IKWOKA",
                "OBUKPA",
                "OKPUJE/OKUTU/ANUK",
                "OWERE/UMUOYO",
            ],
            "OJI RIVER": [
                "ACHIAGU I",
                "ACHIAGU II",
                "ACHIAGU III",
                "ACHIUN I",
                "ACHIUN II",
                "ACHIUN III",
                "ACHIUN IV",
                "AKPUGOEZE",
                "AWLAW",
                "INYI I",
                "INYI II",
                "INYI III",
                "INYI IV",
                "OJI-RIVER I",
                "OJI-RIVER II",
                "OJI-RIVER III",
                "OJI-RIVER IV",
                "UGWUOBA I",
                "UGWUOBA II",
                "UGWUOBA III",
            ],
            UDENU: [
                "AMALA",
                "EZIMO",
                "IMILIKE",
                "OBOLLO-AFOR",
                "OBOLLO-EKE",
                "OBOLLO-ETITI",
                "OGBODU-ABA",
                "ORBA I",
                "ORBA II",
                "UMUNEDEM",
            ],
            UDI: [
                "ABIA",
                "ABOR",
                "AFFA/PGHU/IKON",
                "AKPAKWUME/NZE",
                "AMOKWE",
                "AWHUM UKANA",
                "EBE",
                "EGEDE/UMUOKA",
                "EKE",
                "NACHI",
                "NGWO-ASAA",
                "NGWO-UN",
                "NSUDE",
                "OBINAGU",
                "OBIOMA",
                "OKPATU",
                "UDI/AGBUDU",
                "UMUABI",
                "UMUAGA",
                "UMULUMGBE",
            ],
            "UZO UWANI": [
                "ABBI",
                "ADABA NKUME",
                "ADANI",
                "AKPUGO",
                "IGGA/ASABA",
                "NIMBO I",
                "NIMBO II",
                "NKPOLOGU",
                "NROBO",
                "OGURUGU",
                "OJJOR",
                "UGBENE I",
                "UGBENE II",
                "UKPATA",
                "UMULOKPA",
                "UVURU",
            ],
        },
    },
    {
        code: "FC",
        name: "FCT",
        lgas: [
            "ABUJA MUNICIPAL AREA COUNCIL (AMAC)",
            "ABAJI AREA COUNCIL",
            "BWARI AREA COUNCIL",
            "GWAGWALADA AREA COUNCIL",
            "KUJE AREA COUNCIL",
            "KWALI AREA COUNCIL",
        ],
        subs: {
            "ABUJA MUNICIPAL AREA COUNCIL (AMAC)": [
                "City Centre",
                "Garki",
                "Gui",
                "Gwagwa",
                "Gwarinpa",
                "Jiwa",
                "Kabusa",
                "Karshi",
                "Karu",
                "Nyanya",
                "Orozo",
                "WARD",
                "Wuse",
            ],
            "ABAJI AREA COUNCIL": [
                "Abaji Central",
                "Abaji North East",
                "Abaji South East",
                "Agyana/ Pandagi",
                "Alu/ Mamagi",
                "Gawu",
                "Gurdi",
                "Nuku",
                "Rimba Ebagi",
                "Yaba",
            ],
            "BWARI AREA COUNCIL": [
                "Bwari Central",
                "Byazhin",
                "Dutsen Alhaji",
                "Igu",
                "Kawu",
                "Kubwa",
                "Kuduru",
                "Shere",
                "Ushafa",
                "Usuma",
            ],
            "GWAGWALADA AREA COUNCIL": [
                "Dobi Ward",
                "Gwagwalada Central Ward",
                "Gwako Ward",
                "Ibwa Ward",
                "Ikwa Ward",
                "Kutunku Ward",
                "Paiko Ward",
                "Staff Quarters Ward",
                "Tungan Maje Ward",
                "WARD",
                "Zuba Ward",
            ],
            "KUJE AREA COUNCIL": [
                "Chibiri",
                "Gaube",
                "Gudun Karya",
                "Gwargwada",
                "Kabi",
                "Kuje Central",
                "Kujekwa",
                "Kwaku",
                "Rubochi",
                "WARD",
                "Yenche",
            ],
            "KWALI AREA COUNCIL": [
                "Ashara",
                "Dafa",
                "Gumbo",
                "Kilankwa",
                "Kundu",
                "Kwali Central Ward",
                "Pai",
                "Wako",
                "WARD",
                "Yangoji",
                "Yebu",
            ],
        },
    },
    {
        code: "GO",
        name: "GOMBE",
        lgas: [
            "AKKO",
            "BALANGA",
            "BILLIRI",
            "DUKKU",
            "FUNAKAYE",
            "GOMBE",
            "KALTUNGO",
            "KWAMI",
            "NAFADA",
            "SHONGOM",
            "YAMALTU",
        ],
        subs: {
            AKKO: [
                "AKKO",
                "GARKO",
                "KALSHINGI",
                "KASHERE",
                "KUMO CENTRAL",
                "KUMO EAST",
                "KUMO NORTH",
                "KUMO WEST",
                "PINDIGA",
                "TUKULMA",
                "TUMU",
            ],
            BALANGA: [
                "BAMBAM",
                "BANGU/DALAWAJA/ WALA LUNGUDA",
                "DADIYA",
                "GELENGU/BALANGA",
                "KINDIYO",
                "KULANI/DEGRI/ SIKKAM",
                "MWONA",
                "NYUWAR/JESSU",
                "SWA/REFELE/WALA WAJA",
                "TALASSE/DONG/ REME",
            ],
            BILLIRI: [
                "BANGANJE NORTH",
                "BANGANJE SOUTH",
                "BARE",
                "BILLIRI NORTH",
                "BILLIRI SOUTH",
                "KALMAI",
                "TAL",
                "TANGLANG",
                "TODI",
                "TUDU KWAYA",
            ],
            DUKKU: [
                "GOMBE ABBA",
                "HASHIDU",
                "JAMARI",
                "KUNDE",
                "LAFIYA",
                "MALALA",
                "WAZIRI NORTH",
                "WAZIRI SOUTH/CENTRAL",
                "WURO TALE",
                "ZANGE",
                "ZAUNE",
            ],
            FUNAKAYE: [
                "ASHAKA/MAGABA",
                "BAGE",
                "BAJOGA EAST",
                "BAJOGA WEST",
                "BODOR/TILDE",
                "JILLAHI",
                "KUPTO",
                "RIBADU",
                "TONGO",
                "WAWA/WAKALTU",
            ],
            GOMBE: [
                "AJIYA",
                "BAJOGA",
                "BOLARI EAST",
                "BOLARI WEST",
                "DAWAKI",
                "HERWAGANA",
                "JEKADAFARI",
                "KUMBIYA KUMBIYA",
                "NASARAWO",
                "PANTAMI",
                "SHAMAKI",
            ],
            KALTUNGO: [
                "AWAK",
                "BULE KALTIN",
                "KALTUNGO EAST",
                "KALTUNGO WEST",
                "KAMO",
                "TULA BAULE",
                "TULA WANGE",
                "TULA YIRI",
                "TUNGO",
                "TURE",
            ],
            KWAMI: [
                "BOJUDE",
                "DABAN FULANI",
                "DOHO",
                "DUKUL",
                "GADAM",
                "JURARA",
                "KOMFULATA",
                "KWAMI",
                "MALAM SIDI",
                "MALLERI",
            ],
            NAFADA: [
                "BARWO WINDE",
                "BARWO/NASSARAWO",
                "BIRIN BOLEWA",
                "BIRIN FULANI EAST",
                "BIRIN FULANI WEST",
                "GUDUKKU",
                "JIGAWA",
                "NAFADA CENTRAL",
                "NAFADA EAST",
                "NAFADA WEST",
            ],
            SHONGOM: [
                "BANGUNJI",
                "BOH",
                "BURAK",
                "FILIYA",
                "GUNDALE",
                "GWANDUM",
                "KULISHIN",
                "KUSHI",
                "LALAIPIDO",
                "LAPAN",
            ],
            YAMALTU: [
                "DEBA",
                "DIFA/LUBO/KINAFA",
                "GWANI/SHINGA/ WADE",
                "HINNA",
                "JAGALI NORTH",
                "JAGALI SOUTH",
                "KANAWA/WAJARI",
                "KURI/LAN/LAMBAM",
                "KWADON/LIJI/KURBA",
                "NN/KUNUWAL/WURO BIRDEKA",
                "ZAMBUK/KWALI",
            ],
        },
    },
    {
        code: "IM",
        name: "IMO",
        lgas: [
            "ABOH MBAISE",
            "EHIME MBANO",
            "EZINHITTE MBAISE",
            "IDEATO NORTH",
            "IDEATOR SOUTH",
            "IHITTE UBOMA",
            "IKEDURU",
            "ISIALA MBANO",
            "ISU",
            "MBAISE",
            "MBAITOLI",
            "NGOR OKPALA",
            "NJABA",
            "NKWERRE",
            "NWANGELE",
            "OBOWO",
            "OGUTA",
            "OHAJI/EGBEME",
            "OKIGWE",
            "ONUIMO",
            "ORLU",
            "ORSU",
            "ORU EAST",
            "ORU WEST",
            "OWERRI MUNICIPAL",
            "OWERRI NORTH",
            "OWERRI WEST",
        ],
        subs: {
            "ABOH MBAISE": [
                "AMUZU",
                "ENYIOGUGU",
                "IBEKU",
                "LAGWA",
                "LORJI",
                "MBUTU",
                "NGURU-AHIATO",
                "NGURU-NWAEKE",
                "NGURU-NWANKWO",
                "UMUHU",
                "UVURU I",
                "UVURU II",
            ],
            "EHIME MBANO": [
                "AGBAJA",
                "NZEREM/IKPEM",
                "NZU 'A' IKPE",
                "NZU 'B' IHITTE",
                "UMUALUMAKU/UMUIHIM",
                "UMUEZE I",
                "UMUEZE II / UMUELEKE",
                "UMUEZEALA",
                "UMUKABIA",
                "UMUNAKANU",
                "UMUNUMO",
            ],
            "EZINHITTE MBAISE": [
                "AMUMARA",
                "EZIUDO",
                "IFE/CHOKONEZE/AKPODIN",
                "IHITTE",
                "ITU",
                "OBOAMA/UMUNAMA",
                "OKPOFE/EZEGBOGU",
                "ONICHA I",
                "ONICHA II",
                "ONICHA III",
                "ONICHA IV",
                "UDO NA OBIZI",
            ],
            "IDEATO NORTH": [
                "AKPULU",
                "AKWU OWERRE",
                "EZEMAZU/OZU",
                "ISIOKPO",
                "IZUOGU I",
                "IZUOGU II",
                "NDIHEME ARONDIZUGO",
                "NDIMOKO",
                "OBODOUKWU",
                "OSINA",
                "OZUAKOLI/UMUAGI",
                "UMUOKWARA/UMUEZEAGA",
                "UMUOPIA/UMUKEGWU",
                "UZII/UMUALOMA",
            ],
            "IDEATOR SOUTH": [
                "AMANATOR/UMUESHI",
                "DIKENAFAI",
                "ISIEKENESI II",
                "NTUEKE",
                "OBIOHIA",
                "OGBOKO I",
                "OGBOKO II",
                "UGBELLE",
                "UMUAKAM/UMUAGO",
                "UMUCHIMA",
                "UMUMAISIAKU",
                "UMUOBOM",
            ],
            "IHITTE UBOMA": [
                "ABUEKE",
                "AMAIYI",
                "AMAKOHIA",
                "ATONERIM",
                "AWUCHINUMO",
                "DIMNEZE",
                "IKPEREJERE",
                "OKATA",
                "UMUEZEGWU",
                "UMUIHI",
            ],
            IKEDURU: [
                "AKABO",
                "AMAIMO",
                "AMAKOHIA",
                "AMATTA",
                "ATTA I",
                "ATTA II",
                "AVUVU",
                "IHO",
                "INYISHI/UMUDIM",
                "NGUGO/IKEMBARA",
                "UGIRIKE/OKWU/EZIAMA",
                "UZOAGBA",
            ],
            "ISIALA MBANO": [
                "AMARAKU",
                "AMAUZARI",
                "IBEME",
                "OBOLLO",
                "OGBOR",
                "OSUACHARA",
                "OSUAMA ANARA",
                "OSUOWERRI I",
                "OSUOWERRI II",
                "UGIRI OKA",
                "UMUNKWO",
                "UMUOZU",
            ],
            ISU: [
                "AMANDUGBA I",
                "AMANDUGBA II",
                "AMURIE OMANZE I",
                "AMURIE OMANZE II",
                "EKWE I",
                "EKWE II",
                "ISUNJABA I",
                "ISUNJABA II",
                "ISUNJABA III",
                "UMUNDUGBA I",
                "UMUNDUGBA II",
            ],
            MBAISE: [
                "AMUZI/IHENWORIE",
                "MPAM",
                "NNARAM BIA",
                "OBOHIA/ EKWERAZU",
                "OGBE",
                "OGBOR/UMUEZE",
                "OKIRIKA NWEKE",
                "OKIRIKA NWENKWO",
                "OPARANADIM",
                "ORUNA LUDE",
                "OTULU/AGUNEZE",
                "UMUNUMO/UMUCHIEZE",
            ],
            MBAITOLI: [
                "AFARA/EZIAMA",
                "AMAIKE MBIERI",
                "EZINIHITTE MBIERI",
                "IFAKALA",
                "OGBAKU",
                "OGWA I",
                "OGWA II",
                "ORODO A",
                "ORODO B",
                "UBOMIRI",
                "UMUNOHA/AZARA",
                "UMUNWOHA/UMUAGWU",
            ],
            "NGOR OKPALA": [
                "AMALA/ALULU/ OBOKWE/ OBURU/NTU",
                "ELELEM/OBIKE",
                "EZIAMA/OKPALA",
                "IMERIENWE",
                "LOGARA/ UMUOHIAGU",
                "NGOR/IHITTE/ UMUKABIA",
                "NGURU/UMUOWA",
                "OBIANGWU",
                "OHEKELEM/ NNEORIE",
                "OZUZU",
                "UMUHU",
            ],
            NJABA: [
                "AMUCHA I",
                "AMUCHA II",
                "ATTA I",
                "ATTA II",
                "ATTA III",
                "NKUME",
                "OKWUDOR",
                "UMUAKA I",
                "UMUAKA II",
                "UMUAKA III",
                "UMUAKA IV",
            ],
            NKWERRE: [
                "AMAOKPARA",
                "EZIAMA-OBAIRE",
                "NKWERE URBAN",
                "NNANANO",
                "ONUSA",
                "OWERRE-NKWORJI I",
                "OWERRE-NKWORJI II",
                "UMUDI/UMWALA",
                "UMUKO",
                "UMUNOBO/UMUNACHI",
            ],
            NWANGELE: [
                "ABAJAH I",
                "ABAJAH II",
                "ABBA",
                "AMAIGBO I",
                "AMAIGBO II",
                "AMAIGBO III",
                "AMAIGBO IV",
                "AMAIGBO V",
                "DIM NA NUME",
                "KARA NA ORLU",
                "UMUOZU",
            ],
            OBOWO: [
                "ALIKE",
                "AMANZE/ UMUNGWA",
                "AMUZI",
                "AVUTU",
                "EHUME",
                "ODEN KUME/UMUOSOCHIE",
                "OKENALOGHO",
                "OKWUOHIA",
                "UMUARIAM/ACHARA",
                "UMUNACHI",
            ],
            OGUTA: [
                "AWA",
                "EGWE/EGBUOMA",
                "IZOMBE",
                "MGBALA/UBA",
                "NDIULOUKWU/   UMUOWERRI",
                "OBUDI/ARO",
                "OGUTA A",
                "OGUTA B",
                "ORU",
                "OSEMOTO/  ENUIGBO",
                "UWAORIE",
            ],
            "OHAJI/EGBEME": [
                "ASSA/OBILE",
                "AWARA/IKWEREDE",
                "EGBEMA ‘A’",
                "EGBEMA ‘B’",
                "EGBEMA ‘C’",
                "EGBEMA ‘D’",
                "EGBEMA ‘E’",
                "EKWUATO",
                "OBITI/MGBISHI",
                "OHOBA",
                "UMUAGWO",
                "UMUAPU",
            ],
            OKIGWE: [
                "AGBOBU",
                "AKU",
                "AMURO",
                "EZINACHI",
                "IHUBE",
                "NDIMOKO/OFEIMO",
                "OGII",
                "OKIGWE I",
                "OKIGWE II",
                "UMUALUMOKE",
                "UMULOLO",
            ],
            ONUIMO: [
                "ABOH/OKOHIA",
                "EZELU",
                "EZIAMA",
                "OFEAHIA",
                "OKWELLE I",
                "OKWELLE II",
                "OWERRE OKWE",
                "OZIMO/ UMUANUMEZE",
                "UMUCHEKE",
                "UMUNNA",
            ],
            ORLU: [
                "AMAIFEKE",
                "EBENESE/UMUEZE/NNACHI IHIOMA",
                "EZIACHI/AMAIKE",
                "IHITTE OWERRE",
                "OGBERURU/OBIBI",
                "OHAEKE OKPORO",
                "OHAFOR OKPORO/UMUTANZE",
                "OKWUABALA IHIOMA",
                "ORLU/MGBEE/GOVT.STATION",
                "OWERRR-EBEIRI",
                "UMUDIOKA",
                "UMUNA",
                "UMUZIKE/ UMUOWA",
            ],
            ORSU: [
                "AMARURU",
                "ASSAH UBIRIELEM",
                "EBENATOR",
                "EZIAWA",
                "IHITE NANSA",
                "OKWUAMARAIHE I",
                "OKWUAMARAIHE II",
                "OKWUETITI",
                "OKWUFURUAKU",
                "ORSU IHITTEUKWA",
                "UMUHU OKABIA",
            ],
            "ORU EAST": [
                "AKATTA",
                "AKUMA",
                "AMAGU",
                "AMIRI I",
                "AMIRI II",
                "AWO-OMAMMA I",
                "AWO-OMAMMA II",
                "AWO-OMAMMA III",
                "AWO-OMAMMA IV",
                "OMUMA",
            ],
            "ORU WEST": [
                "AJI",
                "AMAOFOU",
                "IBIASOEGBE",
                "MGBIDI I SECONDARY SCHOOL",
                "MGBIDI II",
                "NEMPI/ELEH",
                "OHAKPU",
                "OTULU",
                "OZARA",
                "UBULU",
            ],
            "OWERRI MUNICIPAL": [
                "ALADINMA I",
                "ALADINMA II",
                "AZUZI I",
                "AZUZI II",
                "AZUZI III",
                "AZUZI IV",
                "GRA",
                "IKENEGBU I",
                "IKENEGBU II",
                "NEW OWERRI I",
                "NEW OWERRI II",
            ],
            "OWERRI NORTH": [
                "AGBALA/OBUBE/ ULAKWO",
                "AWAKA/IHITTE-OGADA",
                "EGBU",
                "EMEKUKU I",
                "EMEKUKU II",
                "EMII",
                "IHITTA-OHA",
                "NAZE",
                "OBIBI URATTA I",
                "OBIBI URATTA II",
                "OBIBIEZENA",
                "ORJI",
            ],
            "OWERRI WEST": [
                "AMAKOHIA-UBI/ NDEGWU/ OHII",
                "AVU/OFOROLA",
                "EMEABIAM/OKOROCHI",
                "EZIOBODO",
                "IHIAGWA",
                "IRETE/OROGWE",
                "NEKEDE",
                "OBINZE",
                "OKUKU",
                "UMUGUMA",
            ],
        },
    },
    {
        code: "JI",
        name: "JIGAWA",
        lgas: [
            "AUYO",
            "BABURA",
            "BIRNIN KUDU",
            "BIRNIWA",
            "BUJI",
            "DUTSE",
            "GAGARAWA",
            "GARKI",
            "GUMEL",
            "GURI",
            "GWARAM",
            "GWIWA",
            "HADEJIA",
            "JAHUN",
            "KAFIN HAUSA",
            "KAUGAMA",
            "KAZAURE",
            "KIRIKASAMMA",
            "KIYAWA",
            "MAIGATARI",
            "MALAM MADORI",
            "MIGA",
            "RINGIM",
            "RONI",
            "SULETANKARKAR",
            "TAURA",
            "YANKWASHI",
        ],
        subs: {
            AUYO: [
                "AUYAKAWA",
                "AUYO",
                "AYAMA",
                "AYAN",
                "GAMAFOI",
                "GAMSARKA",
                "GATAFA",
                "KAFUR",
                "TSINDIR",
                "UNIK",
            ],
            BABURA: [
                "BATALI",
                "DORAWA",
                "GARU",
                "GASAKOLI",
                "INSHARUWA",
                "JIGAWA",
                "KANYA",
                "KUZUNZUMI",
                "KYAMBO",
                "TAKWASA",
            ],
            "BIRNIN KUDU": [
                "BIRNIN KUDU",
                "KANGIRE",
                "KANTOGA",
                "KIYAKO",
                "KWANGWARA",
                "LAFIYA",
                "SUNDUMINA",
                "SURKO",
                "UNGUWAR 'YA",
                "WURN",
                "YALWAN DAMAI",
            ],
            BIRNIWA: [
                "BATU",
                "BIRNIWA",
                "DANGWULERI",
                "DIGINSA",
                "FAGI",
                "KACHALLARI",
                "KARANKA",
                "KAZURA",
                "MACHINAMARI",
                "MATAMU",
                "NGUWA",
            ],
            BUJI: [
                "AHOTO",
                "BUJI",
                "CHURBUN",
                "FALGERI",
                "GANTSA",
                "KAWAYA",
                "KUKUMA",
                "LELEN KUDU",
                "MADABE",
                "YAYARIN TUKUR",
            ],
            DUTSE: [
                "ABAYA",
                "CHAMO",
                "DUNDUBUS",
                "DURU",
                "JIGAWAR TSADA",
                "KACHI",
                "KARNAYA",
                "KUDAI",
                "LIMAWA",
                "MADOBI",
                "SAKWAYA",
            ],
            GAGARAWA: [
                "GAGARAWA GARI",
                "GAGARAWA TAHSA",
                "GARIN CHIROMA",
                "KORE BALATU",
                "MADAKA",
                "MAI ADUWA",
                "MAI KILILI",
                "MEDU",
                "YALAWA",
                "ZARADA",
            ],
            GARKI: [
                "BUDURU",
                "DOKO",
                "GARKI",
                "GWARZON GARKI",
                "JERIMA",
                "KANYA",
                "KARKO",
                "KORE",
                "MUKU",
                "RAFIN MARKE",
                "SIYORI",
            ],
            GUMEL: [
                "BAIKARYA",
                "DAN AMA",
                "DANTANMA",
                "GALAGAMMA",
                "GARIN A. BARKA",
                "GARIN GAMBO",
                "GUSAU",
                "HAMMADO",
                "K/AREWA",
                "KIYAMMA",
                "ZANGO",
            ],
            GURI: [
                "ABUNABO",
                "ADIYANI",
                "DAWA",
                "GARBAGAL",
                "GURI",
                "KADIRA",
                "LAFIYA",
                "MARGADU",
                "MATARA BABBA",
                "MUSARI",
            ],
            GWARAM: [
                "BASIRKA",
                "DINGAYA",
                "FAGAM",
                "FARIN DUTSE",
                "GWARAM TSOHUWA",
                "KILA",
                "KWANDIKO",
                "MARUTA",
                "SARA",
                "TSANGARWA",
                "ZANDAM NAGOGO",
            ],
            GWIWA: [
                "BUNTUSU",
                "DABI",
                "DARINA",
                "F/YAMMA",
                "GUNTAI",
                "GWIWA",
                "KORAYEL",
                "RORAU",
                "SHEFE",
                "YOLA",
                "ZAUMAR SAINAWA",
            ],
            HADEJIA: [
                "ATAFI",
                "DUBANTU",
                "GAGULMARI",
                "K/KOFAR",
                "K/KUDA",
                "MAJEMA",
                "MATSARO",
                "RUMFA",
                "SABON GARI",
                "YAN KOLI",
                "YAYRI",
            ],
            JAHUN: [
                "AUJARA",
                "GANGAWA",
                "GAUZA TAZARA",
                "GUNKU",
                "HARBO SABUWA",
                "HARBO TSOHUWA",
                "IDADU TSOHUWA",
                "JABARNA",
                "JAHUN",
                "KALE",
                "KANWA",
            ],
            "KAFIN HAUSA": [
                "BALANGU",
                "DUMADUMIN TOKA",
                "GAFAYA",
                "JABO",
                "KAFIN HAUSA",
                "KAZALEWA",
                "MAJAWA",
                "MEZAN",
                "RUBA",
                "SARAWA",
                "ZAGO",
            ],
            KAUGAMA: [
                "ARBUS",
                "ASKANDU",
                "DABUWARAN",
                "DAKAIYAWA",
                "HADIN",
                "JA'E",
                "JARKASA",
                "KAUGAMA",
                "MARKA",
                "U/JIBRIN",
                "YALO",
            ],
            KAZAURE: [
                "BA'AUZINI",
                "DABA",
                "DABAZA",
                "DANDI",
                "GADA",
                "KANTI",
                "MARADAWA",
                "SABARU",
                "UNG. AREWA",
                "UNG. GABAS",
                "UNG. YAMMA",
            ],
            KIRIKASAMMA: [
                "BATURIYA",
                "BULUNCHAI",
                "DOLERI",
                "FANDOM",
                "GAYIN",
                "KIRIKASAMMA",
                "MADACHI",
                "MARMA",
                "TARBU",
                "TASHEGUWA",
            ],
            KIYAWA: [
                "ABALAGO",
                "ANDAZA",
                "FAKE",
                "GARKO",
                "GURDUBA",
                "KATANGA",
                "KATUKA",
                "KIYAWA",
                "KWANDA",
                "MAJE",
                "TSURMA",
            ],
            MAIGATARI: [
                "BALARABE",
                "DANKUMBO",
                "FULATA",
                "GALADI",
                "JAJERI",
                "KUKA YASKU",
                "MADANA",
                "MAIGATARI AREWA",
                "MAIGATARI KUDU",
                "MATOYA",
                "TURBUS",
            ],
            "MALAM MADORI": [
                "ARKI",
                "DUNARI",
                "FATEKA",
                "GARUN GABAS",
                "MAIRAKUMI",
                "MAKADDARI",
                "MALAM MADORI",
                "SHAYYA",
                "TAGWARO",
                "TASHENA",
                "TONIKUTARA",
            ],
            MIGA: [
                "DANGYATIN",
                "GARBO",
                "HANSTU",
                "KOYA",
                "MIGA",
                "SABON GARI",
                "SANSANI",
                "TSAKUWAWA",
                "YANDUNA",
                "ZAREKU",
            ],
            RINGIM: [
                "CHAI-CHAI",
                "DABI",
                "KAFIN BABUSHE",
                "KARSHI",
                "KAURAMA",
                "RINGIM",
                "SANKARA",
                "SITILIMAWA",
                "TOFA",
                "YAN DUTSE",
            ],
            RONI: [
                "AMARYAWA",
                "BATAGUMI",
                "DANSURE",
                "FARA",
                "GORA",
                "KWAITA",
                "RONI",
                "SANKAU",
                "TUNAS",
                "YAN ZAKI",
                "ZUGAI",
            ],
            SULETANKARKAR: [
                "ALBASU",
                "AMANGA",
                "DANGWANKI",
                "DANLADI",
                "DANZOMO",
                "JEKE",
                "SHABARU",
                "SULE TANKARKAR",
                "TAKATSABA",
                "YANDAMO",
            ],
            TAURA: [
                "AJAURA",
                "CHAKWAIKWAIWA",
                "CHUKUTO",
                "GUJUNGU",
                "KIRI",
                "KWALAM",
                "MAJE",
                "MAJIYA",
                "S/GARIN 'YA 'YA",
                "TAURA",
            ],
            YANKWASHI: [
                "ACHILAFIYA",
                "BELAS",
                "DAWON GAWO",
                "GURJIYA",
                "GWARTA",
                "KARKARNA",
                "KUDA",
                "RINGIM",
                "YANKWASHI",
                "ZUGUMBA",
            ],
        },
    },
    {
        code: "KD",
        name: "KADUNA",
        lgas: [
            "BIRNIN GWARI",
            "CHIKUN",
            "GIWA",
            "IGABI",
            "IKARA",
            "JABA",
            "JEMA'A",
            "KABAU",
            "KACHIA",
            "KADUNA NORTH",
            "KADUNA SOUTH",
            "KAGARKO",
            "KAJURU",
            "KAURA",
            "KAURU",
            "KUDAN",
            "LERE",
            "MAKARFI",
            "SABON GARI",
            "SANGA",
            "SOBA",
            "ZANGON KATAF",
            "ZARIA",
        ],
        subs: {
            "BIRNIN GWARI": [
                "DOGONDAWA",
                "GAYAM",
                "KAKANGI",
                "KAZAGE",
                "KUTEMESHI",
                "KUYELLO",
                "MAGAJINGARI I",
                "MAGAJINGARI II",
                "MAGAJINGARI III",
                "RANDAGI",
                "TABANNI",
            ],
            CHIKUN: [
                "CHIKUN",
                "GWAGWADA",
                "KAKAU",
                "KUJAMA",
                "KUNAI",
                "KURIGA",
                "NARAYI",
                "RIDO",
                "SABON TASHA",
                "TRIKANIYA",
                "UNGWAYELWA",
            ],
            GIWA: [
                "DANMAHAWAYI",
                "GALADIMAWA",
                "GANGARA",
                "GIWA",
                "IDASU",
                "KADAGE",
                "KAKANGI",
                "KIDANDAN",
                "PANHAUYA",
                "SHIKA",
                "YAKAWADA",
            ],
            IGABI: [
                "AFAKA",
                "BIRININ YERO",
                "GADAN GAYAN",
                "GWARAJI",
                "IGABI",
                "KERAWA",
                "KWARAU",
                "RIGACHIKUN",
                "RIGASA",
                "SABON BIRNIN DAJI",
                "TURUNKU",
                "ZANGON AYA",
            ],
            IKARA: [
                "AUCHAN",
                "IKARA",
                "JAMFALAN",
                "KURMIN KOGI",
                "KUYA",
                "PAKI",
                "PALA",
                "RUMI",
                "SAULAWA",
                "SAYA-SAYA",
            ],
            JABA: [
                "CHORI",
                "DADDU",
                "DURA BITARO",
                "FADA",
                "FAI",
                "NDUYA",
                "NK",
                "SAB-ZURO",
                "SAMBAN",
                "SAN-CHEM",
            ],
            "JEMA'A": [
                "ASSO",
                "ATUKU",
                "BADDE",
                "GIDAN WAYA",
                "GODOGODO",
                "JAGINDI",
                "KAFANCHAN A",
                "KAFANCHAN B",
                "KANINKON",
                "MAIZIGO",
                "TAGOMA",
                "TAKAU",
            ],
            KABAU: [
                "ANCHAU",
                "DAMAU",
                "DUSTENWAI",
                "HASKIYA",
                "KARGI",
                "KARREH",
                "KUBAU",
                "MAH",
                "PNNBEGUA",
                "ZABI",
                "ZUNTU",
            ],
            KACHIA: [
                "AGUNU",
                "ANKWA",
                "AWON",
                "BISHINI",
                "DOKA",
                "GIDAN TAGWAI",
                "GUMEL",
                "KACHIA URBAN",
                "KATARI",
                "KURMIN MUSA",
                "KWATURU",
                "SABON SARKI",
            ],
            "KADUNA NORTH": [
                "BADARAWA",
                "GABASAWA",
                "GAJI",
                "HAYIN BANKI",
                "KABALA COSTAIN/DOKA",
                "KAWO",
                "MAIBURJI",
                "SHABA",
                "UNGWAN SHANU",
                "UNGWAR DOSA",
                "UNGWAR LIMAN",
                "UNGWAR SARKI",
            ],
            "KADUNA SOUTH": [
                "BADIKKO",
                "BARNAWA",
                "KAKURI GWARI",
                "KAKURI HAUSA",
                "MAKERA",
                "SABON GARI NORTH",
                "SABON GARI SOUTH",
                "TELEVISION",
                "TUDUN NUPAWA",
                "TUDUN WADA NORTH",
                "TUDUN WADA SOUTH",
                "TUDUN WADA WEST",
                "UNGUWAN SANUSI",
            ],
            KAGARKO: [
                "ARIBI",
                "IDDAH",
                "JERE NORTH",
                "JERE SOUTH",
                "KAGARKO NORTH",
                "KAGARKO SOUTH",
                "KATUGAL",
                "KUKUI",
                "KURMIN JIBRIN",
                "KUSHE",
            ],
            KAJURU: [
                "AFOGO",
                "BUDA",
                "IDON",
                "KAJURU",
                "KALLAH",
                "KASUWAN",
                "KUFANA",
                "MAGANI",
                "RIMAU",
                "TANTATU",
            ],
            KAURA: [
                "BADURUMSAMA",
                "BITAL",
                "DAMAKASUWA",
                "DAWAKI",
                "GESHERE",
                "KAMARU",
                "KAURU EAST",
                "KAURU WEST",
                "KWASSAM",
                "MAKAMI",
                "PARI",
            ],
            KAURU: [
                "BADURUMSAMA",
                "BITAL",
                "DAMAKASUWA",
                "DAWAKI",
                "GESHERE",
                "KAMARU",
                "KAURU EAST",
                "KAURU WEST",
                "KWASSAM",
                "MAKAMI",
                "PARI",
            ],
            KUDAN: [
                "DOKA",
                "GARU",
                "HUNKUYI",
                "KAURAN WALI NORTH",
                "KAURAN WALI SOUTH",
                "KUDAN",
                "LIKORO",
                "S/ GARIN HUNKUYI",
                "TABANSANI",
                "ZABI",
            ],
            LERE: [
                "ABADAWA",
                "DAN ALHAJI",
                "GARU",
                "GURE/KHUGU",
                "KAYARDA",
                "LAZURU",
                "LERE",
                "RAMIN KURA",
                "SABONBIRNI",
                "SAMINAKA",
                "YARKASUWA",
            ],
            MAKARFI: [
                "DANDAMISA",
                "DANGUZIRI",
                "GAZARA",
                "GIMI",
                "GUBUCHI",
                "GWANKI",
                "MAKARFI",
                "MEYERE",
                "NASSARAWAN DOYA",
                "TUDUN WADA",
            ],
            "SABON GARI": [
                "BASAWA",
                "BOMO",
                "CHIKAJI",
                "DOGARAWA",
                "HANWA",
                "JAMA’A",
                "JUSHI",
                "MUCHIYA",
                "SAMARU",
                "UNGUWAN GABAS",
                "ZABI",
            ],
            SANGA: [
                "ABORO",
                "ARAK",
                "AYU",
                "BOKANA",
                "FADAN KARSHI",
                "GWANTU",
                "NANDU",
                "NINZO NORTH",
                "NINZO SOUTH",
                "NINZO WEST",
                "WASA STATION",
            ],
            SOBA: [
                "DAN WATA",
                "GAMAGIRA",
                "GARUN GWANKI",
                "GIMBA",
                "KINKIBA",
                "KWASSALLO",
                "MAIGANA",
                "RAHAMA",
                "RICHIFA",
                "SOBA",
                "TURAWA",
            ],
            "ZANGON KATAF": [
                "GIDANJATAU",
                "GORA",
                "KAMANTAN",
                "KANURUIKULU",
                "MADAKIYA",
                "UNGWANGAIYA",
                "UNGWANRIMI",
                "ZAMANDABO",
                "ZONKWA",
                "ZONZON",
            ],
            ZARIA: [
                "DAMBO",
                "DUTSEN ABBA",
                "GYALLESU",
                "KAURA",
                "KUFENA",
                "KWARBAI “A”",
                "KWARBAI “B”",
                "LIMANCIN KONA",
                "TUDUN WADA",
                "TUKUR-TUKUR",
                "UNG. JUMA",
                "UNGFATIKA",
                "WUCICIRI",
            ],
        },
    },
    {
        code: "KN",
        name: "KANO",
        lgas: [
            "AJINGI",
            "ALBASU",
            "BAGWAI",
            "BATTA",
            "BEBEJI",
            "BICHI",
            "BUNKURE",
            "DAKATA",
            "DALA",
            "DAWAKIN TOFA",
            "DOGUWA",
            "FAGGE",
            "GABASAWA",
            "GAMA",
            "GARKO",
            "GAWUNA",
            "GAYA",
            "GEZAWA",
            "GIGINYU",
            "GURUN MALLAM",
            "GWAGWARWA",
            "GWALE",
            "GWARZO",
            "HOTORO NORTH",
            "HOTORO SOUTH",
            "KABO",
            "KAN MUNICIPAL",
            "KARAYE",
            "KAURA GOJE",
            "KAWAJI",
            "KIBIYA",
            "KIRU",
            "KUDU",
            "KUMBOTSO",
            "KUNCHI",
            "KURA",
            "MADOBI",
            "MAKODA",
            "MINIJIBIR",
            "RANO",
            "RIMIN",
            "ROGO",
            "SHANN",
            "SUMAILA",
            "TAKAI",
            "TARAUNI",
            "TOFA",
            "TSANYAWA",
            "TUDUN MURTALA",
            "TUDUN WADA",
            "TUNDUN WADA",
            "UNGOGO",
            "WARAWA",
            "WUDIL",
        ],
        subs: {
            AJINGI: [
                "AJINGI",
                "BALARE",
                "CHULA",
                "DABIN KANAWA",
                "DUNDUN",
                "GAFASA",
                "GURDUBA",
                "KUNKURAWA",
                "TORANKE",
                "UNGUWAR BAI",
            ],
            ALBASU: [
                "ALBASU CENTRAL",
                "BATAIYA",
                "CHAMARANA",
                "DAHO",
                "FANDA",
                "FARAGAI",
                "GAGARAME",
                "HUNGU",
                "SAYA-SAYA",
                "TSANGAYA",
            ],
            BAGWAI: [
                "BAGWAI",
                "DANGADA",
                "GADANYA",
                "GOGORI",
                "KIYAWA",
                "KWAJALI",
                "RIMIN DAKO",
                "ROMO",
                "SARE SARE",
                "WURO BAGGA",
            ],
            BATTA: [
                "AJUMAWA",
                "DAN BATTA EAST",
                "DAN BATTA WEST",
                "FAGWALAWA",
                "GORIN MAJE",
                "GWANDA",
                "GWARABJAWA",
                "KORE",
                "SAIDAWA",
                "SANSAN",
            ],
            BEBEJI: [
                "ANADARIYA",
                "BAGUDA",
                "BEBEJI",
                "DAMAU",
                "DURMAWA",
                "GARGAI",
                "GWARMAI",
                "KOFA",
                "KUKI",
                "RAHAMA",
                "RANKA",
                "RANTAN",
                "TARIWA",
                "WAK",
            ],
            BICHI: [
                "BADUME",
                "BICHI",
                "DANZABUWA",
                "FAGOLO",
                "KAU-KAU",
                "KWAMARAWA",
                "KYALLI",
                "MUNTSIRA",
                "SAYE",
                "WAIRE",
                "YALLAMI",
            ],
            BUNKURE: [
                "BARKUM",
                "BON",
                "BUNKURE",
                "CHIRIN",
                "GAFAN",
                "GURJIYA",
                "GWAMMA",
                "KULLUWA",
                "KUMURYA",
                "SANDA",
            ],
            DAKATA: ["DAKATA"],
            DALA: [
                "ADAKAWA",
                "BAKIN RUWA",
                "DALA",
                "DOGON NAMA",
                "GOBIRAWA",
                "GWAMMAJA",
                "KABUWAYA",
                "KANTUDU",
                "KOFAR MAZUGAL",
                "KOFAR RUWA",
                "MADIGAWA",
                "YALWA",
            ],
            "DAWAKIN TOFA": [
                "DANGUGUWA",
                "DAWAKI EAST",
                "DAWAKI WEST",
                "DAWANAU",
                "GANDUJE",
                "GARGARI",
                "JALLI",
                "KWA",
                "MARKE",
                "TATTARAWA",
                "TUMFAFI",
            ],
            DOGUWA: [
                "D/KAWO",
                "DARIYA",
                "DOGUWA",
                "FALGORE",
                "MARAKU",
                "RAGADA",
                "RIRUWAI",
                "TAGWAYE",
                "U/NATSOHUWA",
                "ZAINABI",
            ],
            FAGGE: [
                "FAGGE A",
                "FAGGE B",
                "FAGGE C",
                "FAGGE D",
                "FAGGE E",
                "KWACHIRI",
                "RIJIYAR LEMO",
                "SABON GARI EAST",
                "SABON GARI WEST",
                "YAMMATA",
            ],
            GABASAWA: [
                "G/DANGA",
                "GABASAWA",
                "JODA",
                "KARMAMI",
                "MEKIYA",
                "TARAUNI",
                "YAUTA/AREWA",
                "YAUTA/KUDU",
                "YUNBU",
                "ZAKIRAI",
                "ZUGACHI",
            ],
            GAMA: ["GAMA"],
            GARKO: [
                "DANDAGO",
                "DISO",
                "DORAYI",
                "GALADANCHI",
                "GORON DUTSE",
                "GWALE",
                "GYARANYA",
                "KABUGA",
                "MANDAWARI",
                "SANI MAINAGGE",
            ],
            GAWUNA: ["GAWUNA"],
            GAYA: [
                "BALAN",
                "GAMARYA",
                "GAMOJI",
                "GAYA AREWA",
                "GAYA KUDU",
                "KADEMI",
                "KAZURAWA",
                "MAIMAKAWA",
                "SHAGOGO",
                "WUDILAWA",
            ],
            GEZAWA: [
                "BABAWA",
                "GAWO",
                "GEZAWA",
                "JOGANA",
                "KETAWA",
                "MESAR TUDU",
                "SARARIN GEZAWA",
                "TSAMIYA BABBA",
                "TUMBAU",
                "WANGARA",
                "ZANGO",
            ],
            GIGINYU: ["GIGINYU"],
            "GURUN MALLAM": [
                "CHIROMAWA",
                "D/SALLAU",
                "FANKURUN",
                "G/BABBA",
                "G/MALLAM",
                "JOBAWA",
                "KADAWA",
                "MAKWARO",
                "Y/YADAKWARI",
                "YADAKWARI",
            ],
            GWAGWARWA: ["GWAGWARWA"],
            GWALE: [
                "DANDAGO",
                "DISO",
                "DORAYI",
                "GALADANCHI",
                "GORON DUTSE",
                "GWALE",
                "GYARANYA",
                "KABUGA",
                "MANDAWARI",
                "SANI MAINAGGE",
            ],
            GWARZO: [
                "GETSO",
                "GWARZO",
                "JAMA'A",
                "KARA",
                "KUTAMA",
                "LAKWAYA",
                "MADADI",
                "MAINIKA",
                "SABON BIRNI",
                "UNGUWAR TUDU",
            ],
            "HOTORO NORTH": ["HOTORO NORTH"],
            "HOTORO SOUTH": ["HOTORO SOUTH"],
            KABO: [
                "DUGABAU",
                "DURUN",
                "GAMMO",
                "GARO",
                "GODIYA",
                "GUDE",
                "HAUWADE",
                "KABO",
                "KANWA",
                "MASANAWA",
            ],
            "KAN MUNICIPAL": [
                "CHEDI",
                "DANAGUNDI",
                "GANDU",
                "JAKARA",
                "KANKAROFI",
                "SHAHUCHI",
                "SHARADA",
                "SHESHE",
                "TUDUN NUFAWA",
                "TUDUN WAZIRCH",
                "YAKASAI",
                "ZAITAWA",
                "ZANGO",
            ],
            KARAYE: [
                "DAURA",
                "KAFIN DAFGA",
                "KARAYE",
                "KURUGU",
                "KWANYAWA",
                "TUDUN KAYA",
                "TURAWA",
                "UNGUWAR HAJI",
                "YAMMEDI",
                "YOLA",
            ],
            "KAURA GOJE": ["KAURA GOJE"],
            KAWAJI: ["KAWAJI"],
            KIBIYA: [
                "DURBA",
                "FAMMAR",
                "FASSI",
                "KADIGAWA",
                "KAHU",
                "KIBIYA I",
                "KIBIYA II",
                "NARIYA",
                "TARAI",
                "UNGUWAR GAI",
            ],
            KIRU: [
                "BA'AWA",
                "BADAFI",
                "BARGONI",
                "BAUDA",
                "DANGORA",
                "DANSOSHIYA",
                "DASHI",
                "GALADIMAWA",
                "KIRU",
                "KOGO",
                "MARAKU",
                "TSAUDAWA",
                "YAKO",
                "YALWA",
                "ZUWO",
            ],
            KUDU: [
                "DABAR KWARI",
                "DANBAGINA",
                "DAWAKI",
                "DAWAKIJI",
                "DOSAN",
                "GAN",
                "GURJIYA",
                "JIDO",
                "TAMBURAWA",
                "TSAKUWA",
                "UNGUWAR DUNIYA",
                "YANBARAU",
                "YANKATSARI",
                "YARGAYA",
                "ZOGARAWA",
            ],
            KUMBOTSO: [
                "CHALLAWA",
                "CHIRANCHI",
                "DANBARE",
                "DANMALIKI",
                "GURUNGAWA",
                "KUMBOTSO",
                "KUREKEN SANI",
                "MARIRI",
                "NAIBAWA",
                "PANSHEKARA",
                "UNGUWAR RIMI",
            ],
            KUNCHI: [
                "BUMAI",
                "GARIN SHEME",
                "GWARMAI",
                "KASUWAR KUKA",
                "KUNCHI",
                "MATAN FADA",
                "RIDAWA",
                "SHAMAKAWA",
                "SHUWAKI",
                "YANDADI",
            ],
            KURA: [
                "DALILI",
                "DAN HASSAN",
                "DUKAWA",
                "GUNDUTSE",
                "KARFI",
                "KOSAWA",
                "KURUNSUMAU",
                "RUGAR DUKA",
                "SARKIN KURA",
                "TANAWA",
            ],
            MADOBI: [
                "BURJI",
                "CINKOSO",
                "GALINJA",
                "GORA",
                "KAFIN AGUR",
                "KANWA",
                "KAURAN MATA",
                "KUBARACI",
                "KWANKWASO",
                "MADOBI",
                "RIKADAWA",
                "YAKUN",
            ],
            MAKODA: [
                "BABBAR RIGA",
                "DURMA",
                "JIBGA",
                "KADANDANI",
                "KOGUNA",
                "KOREN TABO",
                "MAITSIDAU",
                "MAKODA",
                "SATAME",
                "TANGAJI",
                "WAILARE",
            ],
            MINIJIBIR: [
                "AZURE",
                "GANDURWAWA",
                "KANTAMA",
                "KUNYA",
                "KURU",
                "KWARKIYA",
                "MINJIBIR",
                "SARBI",
                "TSAKIYA",
                "TSAKUWA",
                "WASAI",
            ],
            RANO: [
                "DAWAKI",
                "LAUSU",
                "MADACHI",
                "RAN",
                "RURUM S/GARI",
                "RURUM T/GARI",
                "SAJI",
                "YALWA",
                "ZINYAU",
                "ZURGU",
            ],
            RIMIN: [
                "BUTU-BUTU",
                "DAWAKIN GULU",
                "DOKA-DAWA",
                "DUGURAWA",
                "GULU",
                "JILI",
                "KAROFIN YASHI",
                "RIMIN GADO",
                "SAKARATSA",
                "TAMAWA",
                "YALWAN DANZIYAL",
                "ZANGON DAN ABDU",
            ],
            ROGO: [
                "BELI",
                "FALGORE",
                "FULATAN",
                "GWANGWAN",
                "JAJAYE",
                "ROGO RUMA",
                "ROGO SABON GARI",
                "RUWAN BAGO",
                "ZAREWA",
                "ZOZA",
            ],
            SHANN: [
                "ALAJAWA",
                "DUTSEN BAKOSHI",
                "FARURUWA",
                "GORON DUTSE",
                "KADAMU",
                "KOKIYA",
                "LENI",
                "SHAKOGI",
                "SHANN",
                "TSAURE",
            ],
            SUMAILA: [
                "GALA",
                "GANI",
                "GARFA",
                "GEDIYA",
                "KANAWA",
                "MAGAMI",
                "MASU",
                "RIMI",
                "RUMO",
                "SITTI",
                "SUMAILA",
            ],
            TAKAI: [
                "BAGWARO",
                "DURBUNDE",
                "FAJEWA",
                "FALALI",
                "FARURUWA",
                "KACHKO",
                "KARFI",
                "KUKA",
                "TAKAI",
                "ZUGA",
            ],
            TARAUNI: [
                "BABBANGIJ",
                "DARMANAWA",
                "DAURAWA",
                "GYADIGYADI AREWA",
                "GYADIGYADI KUDU",
                "HOTORO NNPC",
                "KAUYEN ALU",
                "TARAUNI",
                "UNGUWA UKU",
                "UNGUWAR GAN",
            ],
            TOFA: [
                "DINDERE",
                "DOKA",
                "GAJIDA",
                "GINSAWA",
                "JANGUZA",
                "JAUBEN KUDU",
                "KWAMI",
                "LAMBU",
                "LANGEL",
                "TOFA",
                "UNGUWAR RIMI",
                "WANGARA",
                "YALWA KARAMA",
                "YANKO",
                "YARIMAWA",
            ],
            TSANYAWA: [
                "DADDARAWA",
                "DUMBULUM",
                "GOZARKI",
                "GURUN",
                "KABAGIWA",
                "TATSAN",
                "TSANYAWA",
                "YANGANAU",
                "YANKAMAYE",
                "ZAROGI",
            ],
            "TUDUN MURTALA": ["TUDUN MURTALA"],
            "TUDUN WADA": ["TUDUN WADA"],
            "TUNDUN WADA": [
                "BABURI",
                "BURUM BURUM",
                "DALAWA",
                "JAN DUTSE",
                "JIJA",
                "KAREFA",
                "NATA'ALA",
                "SABON GARI",
                "SHUWAKI",
                "TSOHON GARI",
                "YAR YASA",
            ],
            UNGOGO: [
                "BACHIRAWA",
                "GAYAWA",
                "KADAWA",
                "KARO",
                "PANISAU",
                "RANGAZA",
                "RIJIYAR ZAKI",
                "TUDUN NUFAWA",
                "UNGOGO",
                "YADAKUNYA",
                "ZANGO",
            ],
            WARAWA: [
                "AMARAWA",
                "DANLASAN",
                "GARINDAU",
                "GOGEL",
                "IMAWA",
                "J/GALADIMA",
                "JEMAGU",
                "JIGAWA",
                "KATARKAWA",
                "MADARIN MATA",
                "T/GABAS",
                "TANAGAR",
                "WARAWA",
                "YANDALLA",
                "YANGIZO",
            ],
            WUDIL: [
                "ACHIKA",
                "DAGUMAWA",
                "DAN KAZA",
                "DARKI",
                "INDABO",
                "KAUSANI",
                "LAJAWA",
                "SABON GARI",
                "UTAI",
                "WUDIL",
            ],
        },
    },
    {
        code: "KT",
        name: "KATSINA",
        lgas: [
            "BATAGARAWA",
            "BATSASRI",
            "BAURE",
            "BINDAWA",
            "BOKORI",
            "CHARANCHI",
            "DANDUME",
            "DANJA",
            "DANMUSA",
            "DAURA",
            "DUTSI",
            "DUTSINMA",
            "FASKARI",
            "FUNYUA",
            "INGAWA",
            "JIBIA",
            "KAFUR",
            "KAITA",
            "KAKIA",
            "KANKARA",
            "KATSINA",
            "KURFI",
            "KUSADA",
            "MAIADUA",
            "MALUMFASHI",
            "MANI",
            "MASHI",
            "MATAZU",
            "MUSAWA",
            "RIMI",
            "SABUA",
            "SAFANA",
            "SANDAMU",
            "ZANGO",
        ],
        subs: {
            BATAGARAWA: [
                "AJIWA",
                "BAKIYAWA",
                "BARAWA",
                "BATAGARAWA'A",
                "BATAGARAWA'B",
                "DANDAGORO",
                "JIN",
                "KAYAUKI",
                "TSANNI",
                "YARGAMJI",
            ],
            BATSASRI: [
                "ABADAU/KAGARA",
                "BATSARI",
                "DANALHAJI/YANGAYYA",
                "DARINI/MAGAJI ABU",
                "KANDAWA",
                "KARARE",
                "MADOGARA",
                "MANAWA",
                "RUMA",
                "WAGIN",
                "YAUYAU/MALLAMAWA",
            ],
            BAURE: [
                "AGALA/DANKUM",
                "BABBAN MUTUM",
                "BAURE",
                "GARKI",
                "HUI",
                "KAGARA/FASKI",
                "MAI BARA",
                "MUDURI",
                "TARAMNAWA/BARE",
                "UNGUWAR RAI",
                "YANDUNA",
                "YANMAULU",
            ],
            BINDAWA: [
                "BAURE",
                "BINDAWA",
                "DORO",
                "FARU",
                "GAIWA",
                "GIREMAWA",
                "JIBAWA",
                "KAMRI",
                "SHIBDAWA",
                "TAMA/DAYE",
                "YANGORA",
            ],
            BOKORI: [
                "BAKORI ‘A’",
                "BAKORI ‘B’",
                "BARDE/KWANTAKWARAN",
                "DAWAN MUSA",
                "GUGA",
                "JARGABA",
                "KABOMO",
                "KAKUMI",
                "KANDARAWA",
                "KURAMI/YANKWANI",
                "TSIGA",
            ],
            CHARANCHI: [
                "BANYE",
                "CHARANCHI",
                "DOKA",
                "GANUWA",
                "KODA",
                "KURAYE",
                "M/WAYYA",
                "RADDA",
                "SAFANA",
                "TSAKATSA",
            ],
            DANDUME: [
                "DANDUME ‘A’",
                "DANDUME ‘B’",
                "DANTANKARI",
                "MAGAJI WANDO ‘A’",
                "MAGAJI WANDO ‘B’",
                "MAHUTA ‘A’",
                "MAHUTA ‘B’",
                "MAHUTA ‘C’",
                "NASARAWA",
                "TUMBURKAI ‘A’",
                "TUMBURKAI ‘B’",
            ],
            DANJA: [
                "DABAI",
                "DANJA A",
                "DANJA B",
                "JIBA",
                "KAHUTU A",
                "KAHUTU B",
                "TANDAMA",
                "TSANGAMA WA",
                "YAKAJI  A",
                "YAKAJI B",
            ],
            DANMUSA: [
                "DAN - ALKIMA",
                "DAN ALI",
                "DAN MUSA B",
                "DANDIRE A",
                "DANDIRE B",
                "DANMUSA A",
                "MAIDABIN A",
                "MAIDABIN B",
                "MARA",
                "YANTUMAKI A",
                "YANTUMAKI B",
            ],
            DAURA: [
                "KUSUGU",
                "MADOBI A",
                "MADOBI B",
                "MAZOJI A",
                "MAZOJI B",
                "SABONGARI",
                "SARKIN YAARA A",
                "SARKIN YARA B",
                "TUDUN WADA",
                "UBANDAWAKI A",
                "UBANDAWAKI B",
            ],
            DUTSI: [
                "DAN’AUNAI",
                "DUTSI ‘A’",
                "DUTSI ‘B’",
                "KAYAWA",
                "RUWAN KAYA ‘A’",
                "RUWAN KAYA ‘B’",
                "SIRIKA ‘A’",
                "SIRIKA ‘B’",
                "YAMEL ‘A’",
                "YAMEL ‘B’",
            ],
            DUTSINMA: [
                "BAGAGADI",
                "DABAWA",
                "DUTSINMA A",
                "DUTSINMA B",
                "KAROFI  B",
                "KAROFI A",
                "KUKI  A",
                "KUKI  B",
                "KUTAWA",
                "MAKERA",
                "SHEMA",
            ],
            FASKARI: [
                "DAUDAWA",
                "FASKARI",
                "MAIGORA",
                "MAIRUWA",
                "RUWAN GODIYA",
                "SABONLAYI",
                "SHEME",
                "TAFOKI",
                "YANKARA",
                "YAR MALAMAI",
            ],
            FUNYUA: [
                "DANDUTSE",
                "DIKKE",
                "GOYA",
                "MAI GAMJI",
                "MAKERA",
                "MASKA",
                "SABON GARI",
                "TUDUN IYA",
                "UNG. IBRAHIM",
                "UNG. MUSA",
                "UNG. RABIU",
            ],
            INGAWA: [
                "AGAYAWA",
                "BARERUWA/RURUMA",
                "BIDORE/YAYA",
                "DARA",
                "DAUNAKA/B. KWARI",
                "DUGUL",
                "INGAWA",
                "JOBE/KANDAWA",
                "KARFESI/YANKAURA",
                "MANMAWA",
                "YANDOMA",
            ],
            JIBIA: [
                "BUGAJE",
                "FARFARU",
                "FARU",
                "GANGARA",
                "GURBIN BAURE",
                "JIBIA A",
                "JIBIA B",
                "KUSA",
                "MAGAMA/MAZANYA",
                "RIKO",
                "YANGAYYA",
            ],
            KAFUR: [
                "DANTUTURE",
                "DUTSEN-KURA/KANYA",
                "GAMZAGO",
                "GOZAKI",
                "KAFUR",
                "MAHUTA",
                "MASARI",
                "RUGOJI/YARTALATA",
                "SABUWAR KASA",
                "YARI-BORI",
            ],
            KAITA: [
                "ABDALLAWA",
                "BA'AWA",
                "DANKABA",
                "DANKAMA",
                "GAFIA",
                "GIRKA",
                "KAITA",
                "MATSAI",
                "YANDAKI",
                "YANHOHO",
            ],
            KAKIA: [
                "FAKUWA/KAFINDANGI",
                "GACHI",
                "GALADIMAA",
                "GALADIMAB",
                "KAFINSOLI",
                "KUNDURU/GYAZA",
                "RIMAYE",
                "SUKUNTUNI",
                "TAFASHIYA/NASARAWA",
                "TSA/MAGAM",
            ],
            KANKARA: [
                "BURDUGAU",
                "DANMAIDAKI",
                "DANMURABU",
                "GARAGI",
                "GATAKAWA/S/GARI MABAI",
                "HURYA",
                "KANKARA A&B",
                "KUKASHEKA",
                "PAUWA A&B",
                "WAWARKAZA",
                "ZANGO/ ZABARO",
            ],
            KATSINA: [
                "KANGIWA",
                "SHINKAFI “A”",
                "SHINKAFI “B”",
                "WAKILIN AREWA I",
                "WAKILIN AREWA II",
                "WAKILIN GABAS I",
                "WAKILIN GABAS II",
                "WAKILIN KUDU I",
                "WAKILIN KUDU II",
                "WAKILIN KUDU III",
                "WAKILIN YAMMA I",
                "WAKILIN YAMMA II",
            ],
            KURFI: [
                "BARKIYA",
                "BIRCHI",
                "KURFI (A)",
                "KURFI (B)",
                "RAWAYAU (A)",
                "RAWAYAU (B)",
                "TSAURI (A)",
                "TSAURI (B)",
                "WURMA (A)",
                "WURMA (B)",
            ],
            KUSADA: [
                "BAURANYA’A",
                "BAURANYA’B",
                "BOKO",
                "DIDINNI",
                "KAIKAI",
                "KOFA",
                "KUSADA",
                "MAWASHI",
                "YASHE’A",
                "YASHE’B",
            ],
            MAIADUA: [
                "BUMBUM 'A'",
                "BUMBUM 'B'",
                "DANYASHE",
                "KOZA",
                "MAI'ADUA ,B,",
                "MAI'KONI 'B'",
                "MAIADUA 'A'",
                "MAIADUA 'C'",
                "MAIKONI 'A'",
                "NATSALLE",
            ],
            MALUMFASHI: [
                "BORINDAWA",
                "DANSARAI",
                "DAYI",
                "GORAN DANSAKA",
                "KARFI",
                "MAKAURACHI",
                "MALUMFASHI A",
                "MALUMFASHI B",
                "NA – ALMA",
                "RUWANSANYI",
                "YABA",
                "YAMMAMA",
            ],
            MANI: [
                "BAGIWA",
                "BUJAWA/GEWAYAU",
                "DUWAN/MAKAU",
                "HAMCHETA",
                "JANI",
                "KWATTA",
                "MACHIKA",
                "MAGAMI",
                "MANI",
                "MUDURU",
                "TSAGEM/TAKUSHEYI",
            ],
            MASHI: [
                "BAMBLE",
                "DOGURU A",
                "DOGURU B",
                "GALLU",
                "JIGAWA",
                "KARAU",
                "MASHI",
                "SABUWAR RIJIYA",
                "SONKAYA",
                "TAMILO A",
                "TAMILO B",
            ],
            MATAZU: [
                "DISSI",
                "GWARJO",
                "KAARADUWA",
                "KOGARI",
                "MATAZU 'A'",
                "MATAZU 'B'",
                "MAZOJI 'A'",
                "MAZOJI 'B'",
                "RINJIN IDI",
                "SAYAYA",
            ],
            MUSAWA: [
                "DANGANI",
                "DANJAKU KARACHI",
                "GARU",
                "GINGIN",
                "JIKAMSHI",
                "KIRA",
                "KURKUJAN A",
                "KURKUJAN B",
                "MUSAWA",
                "TABANNI YARDAU",
                "TUGE",
            ],
            RIMI: [
                "ABUKUR",
                "FARDAMI",
                "KADANDANI",
                "MAJEN GOBIR",
                "MAKURDA",
                "MASABO/KURABAU",
                "REMAWA IYATAWA",
                "RIMI",
                "SABON GARIN ALARAINI",
                "TSAGERO",
            ],
            SABUA: [
                "DAMARI",
                "DUGUN MUAZU",
                "GAMJI",
                "GAZARI",
                "MACHIKA",
                "MAIBAKKO",
                "RAFIN IWA",
                "SABUA A",
                "SABUA B",
                "SAYAU",
            ],
            SAFANA: [
                "BABBAN DUHU 'A'",
                "BABBAN DUHU 'B'",
                "BAURE 'A'",
                "BAURE 'B'",
                "RUNKA 'A'",
                "RUNKA 'B'",
                "SAFANA",
                "TSASKIYA",
                "ZAKKA 'A'",
                "ZAKKA 'B'",
            ],
            SANDAMU: [
                "DANEJI 'A'",
                "DANEJI 'B'",
                "FAGO 'A'",
                "FAGO 'B'",
                "KAGARE",
                "KARKARKU",
                "KATSAYAL",
                "KWASARAWA",
                "RADE 'A'",
                "RADE 'B'",
                "SANDAMU",
            ],
            ZANGO: [
                "DARGAGE",
                "GARNI",
                "GWAMBA",
                "KANDA",
                "KAWARIN KUDI",
                "KAWARIN MALAMAI",
                "ROGOGO",
                "SARA",
                "YARDAJE",
                "ZANGO",
            ],
        },
    },
    {
        code: "KE",
        name: "KEBBI",
        lgas: [
            "ALIERO",
            "AREWA",
            "ARGUNGU",
            "AUGIE",
            "BAGUDO",
            "BIRNIN KEBBI",
            "BUNZA",
            "DANDI",
            "FAKAI",
            "GWANDU",
            "JEGA",
            "KALGO",
            "KOKO BESSE",
            "MAIYAMA",
            "NGASKI",
            "SAKABA",
            "SHANGA",
            "SURU",
            "WASAGU DANKO",
            "YAURI",
            "ZURU",
        ],
        subs: {
            ALIERO: [
                "DANGALADIMA I",
                "DANGALADIMA II",
                "DANWARAI",
                "JIGA BIRNI",
                "JIGA MAKERA",
                "KASHIN ZAMA",
                "RAFIN BAUNA",
                "SABIYEL",
                "SHIYAR FADA I",
                "SHIYAR FADA II",
            ],
            AREWA: [
                "BUI",
                "CHIBIKE",
                "DAURA/SAK/JARKUKA",
                "FALDE",
                "FESKE/JEFFEJI",
                "GORUN DIKKO",
                "GUMUNDAI/RAFIN TSAKA",
                "KANGIWA",
                "LAIMA/JANTULLU",
                "SARKA/DANTSOHO",
                "YELDU",
            ],
            ARGUNGU: [
                "ALWASA/GOTOMO",
                "DIKKO",
                "FELANDE",
                "GALADIMA",
                "GULMA",
                "GWAZANGE",
                "KOKANI NORTH",
                "KOKANI SOUTH",
                "LAILABA/NATSINI",
                "SAUWA/KAURA SANI",
                "TUNGAR ZAZZAGAWA",
            ],
            AUGIE: [
                "AUGIE NORTH",
                "AUGIE SOUTH",
                "BAGAYE/MERA",
                "BAYAWA NORTH",
                "BAYAWA SOUTH",
                "BIRNIN TUDU/GUDALE",
                "BUBUCHE",
                "DUNDAYE/KWAIDO",
                "TIGGI/AWADE",
                "YOLA",
            ],
            BAGUDO: [
                "BAGUDO/TUGA",
                "BAHINDI/B.DOMA",
                "BANI/TSAMIYA",
                "ILLO/S.GARI",
                "KA'OJE/GWAMBA",
                "KENDE/KURGU",
                "LAFAGU/GANTE",
                "LOLO/GIRIS",
                "MATSINKAI/GEZA",
                "SHARABI/KWAN",
                "ZAGGA/KWASARA",
            ],
            "BIRNIN KEBBI": [
                "AMBURSA",
                "DANGALADIMA",
                "GAWASU",
                "GULUMBE",
                "GWADANGAJI",
                "KARDI/YAMAMA",
                "KOLA/TARASA",
                "LAGGA",
                "MAKERA",
                "MARAFA",
                "MAURIDA /KARYO",
                "NASSARAWA I",
                "NASSARAWA II",
                "UJARIYO",
                "ZAURO",
            ],
            BUNZA: [
                "BUNZA D/GALADIMA",
                "BUNZA MARAFA",
                "GWADE",
                "MAIDAHINI",
                "RAHA",
                "SABON BIRNI",
                "SALWAI",
                "TILLI/HILEMA",
                "TUNGA",
                "ZOGIRMA",
            ],
            DANDI: [
                "BANIZUMBU",
                "BUMA",
                "DOLEKAINA",
                "FANA",
                "GEZA",
                "KAMBA-KAMBA",
                "KWAKKWABA",
                "KYANGAKWAI",
                "MAIGAWAZA",
                "MAIHAUSAWA",
                "SHIKO",
            ],
            FAKAI: [
                "BAJIDA",
                "BANGU/GARIN ISAH",
                "BIRNIN TUDU",
                "FAKAI ZUSSUN",
                "GULBIN KUKA/MAIJAHULLA",
                "INGABULU MAIKENDE",
                "KANGI",
                "MAHUTA",
                "MARAFA",
                "PENNI PENNI",
            ],
            GWANDU: [
                "CHEBERU/BADA",
                "DALIJAN",
                "DODORU",
                "GULMARE",
                "GWANDU MARAFA",
                "GWANDU SARKIN FAWA",
                "KAMBAZA",
                "MALISA",
                "MARUDA",
                "MASAMA/ KWASARA",
            ],
            JEGA: [
                "ALELU GEHURU",
                "DANGAMAJI",
                "DUMBEGU/BASAURA",
                "FIRCHIN",
                "GINDI/NASARAWA/KYARMI/ GALBI",
                "JANDUTSE BIRNIN MALAM",
                "KATANGA/FAGADA",
                "KIMBA",
                "KOKANI",
                "MAGAJI ‘A’",
                "MAGAJI ‘B’",
            ],
            KALGO: [
                "BADARIYA MAGARZA",
                "DANGOMA GAYI",
                "DIGGI",
                "ETENE",
                "KALGO",
                "KUKA",
                "MUTUBARE BANGANA",
                "NAYELWA",
                "WURO GAURI",
                "ZUGURU",
            ],
            "KOKO BESSE": [
                "BESSE",
                "DADA/ALELU",
                "DUTSIN MARI/",
                "ILLAILA S/GARI",
                "JADADI",
                "KOKO FIRCHIN",
                "KOKO MAGAJI",
                "LANI/TAFUKKA",
                "MADACCI/ FIRINI",
                "MAIKWAR/DAMBA",
                "TAKWARE",
                "ZARIA KALAKALA/AMIRU",
            ],
            MAIYAMA: [
                "ANDARAI/KURUNKUDU/ZUGUN LIBA",
                "GIWATAZO/ZARA",
                "GUBIN KURE/GAMJEJI",
                "KARAYE/DOGON DAJI",
                "KAWARA/S/YAR KAMBA",
                "KUBERI/GIDIGA",
                "LIBA/DANWA/KUKA KOGO",
                "MAIYAMA",
                "MUNGADI/BOTORO",
                "SAMBAWA/MAYALO",
                "SARAN DOSA/GUBBA",
            ],
            NGASKI: [
                "BIRNIN YAURI",
                "GAFARA MACHUPA",
                "GARIN BAKA MAKIRIN",
                "KANBUWA DANMARAYA",
                "KWAKWARAN",
                "LIBATA KWANGA",
                "MAKAWA UKERA",
                "NGASKI",
                "UTON",
                "WARRA",
            ],
            SAKABA: [
                "ADAI",
                "DANKOLO",
                "DOKA/BERE",
                "FADA",
                "GELWASA",
                "JANBIRNI",
                "MAKUKU",
                "MAZA-MAZA",
                "SAKABA",
                "TUDUN KUKA",
            ],
            SHANGA: [
                "ATUWO",
                "BINUW/GEBBE/BUKUNJI",
                "DUGU TSOHO/DUGU RAHA",
                "KAWARA",
                "RAFIN KIRYA/TAFKI TARA",
                "SAKACE/GOLONGO/HUNDOJI",
                "SAWASHI",
                "SHANGA",
                "TAKWARE",
                "YARBESSE",
            ],
            SURU: [
                "ALJANNARE",
                "BAKUWAI",
                "BANDAN",
                "BARBAREJO",
                "DAKIN GARI",
                "DANDANE",
                "DANIYA/SHEMA",
                "GINGA",
                "GIRO",
                "KWAIFA",
                "SURU",
            ],
            "WASAGU DANKO": [
                "AYU",
                "BENA",
                "DAN UMARU",
                "DANKO/MAGA",
                "GWANFI/KELE",
                "KANYA",
                "KYABU/KANDU",
                "RIBAH/MACHIKA",
                "WAJE",
                "WASAGU",
                "YALMO/SHINDI",
            ],
            YAURI: [
                "CHULU/KOMA",
                "GUNGUN SARKI",
                "JIJIMA",
                "TONDI",
                "Yelwa Central",
                "YELWA EAST",
                "YELWA NORTH",
                "YELWA SOUTH",
                "YELWA WEST",
                "ZAMARE",
            ],
            ZURU: [
                "BEDI",
                "CIROMAN DABAI",
                "ISGOGO/DAGO",
                "MANGA/USHE",
                "RAFIN ZURU",
                "RIKOTO",
                "RUMU/DABE/SEME",
                "SENCHI",
                "TADURGA",
                "ZODI",
            ],
        },
    },
    {
        code: "KO",
        name: "KOGI",
        lgas: [
            "ADAVI",
            "AJAOKUTA",
            "ANKPA",
            "BASSA",
            "DEKINA",
            "IBAJI",
            "IDAH",
            "IGALAMELA-ODOLU",
            "IJUMU",
            "KABBA-BUNU",
            "KOGI KK",
            "LOKOJA",
            "MOPA MURO",
            "OFU",
            "OGORI MAGONGO",
            "OKEHI",
            "OKENE",
            "OLAMABORO",
            "OMALA",
            "YAGBA EAST",
            "YAGBA WEST",
        ],
        subs: {
            ADAVI: [
                "ADAVI – EBA",
                "EGE/IRUVECHINMI I",
                "IDANUHUA",
                "IKARAWORO",
                "INZIONI/IPAKU/OSISI",
                "KUROKO I",
                "KUROKO II",
                "NAGAZI FARM CENTER",
                "OGAMINANA",
                "OKUNCHI/OZURI/ONIEKA",
            ],
            AJAOKUTA: [
                "ABODI/PATESI",
                "ACHAGANA",
                "ADOGO",
                "ADOGU/APAMIRA/OGO DOO UHUOVENE",
                "BADOKO",
                "EBIYA NORTH",
                "EBIYA SOUTH",
                "GANAJA/TOWNSHIP",
                "ICHUWA/UPAJA",
                "OBANGEDE/OHUNENE/UKOKO INYERE",
                "ODONU/UNSI",
                "OGIGIRI",
                "OLD AJAOKUTA",
                "OMGBO",
            ],
            ANKPA: [
                "ANKPA I",
                "ANKPA II",
                "ANKPA SUBURB I",
                "ANKPA SUBURB II",
                "ANKPA TOWNSHIP",
                "ENJEMA I",
                "ENJEMA II",
                "ENJEMA III",
                "ENJEMA IV",
                "OJOKU I",
                "OJOKU II",
                "OJOKU III",
                "OJOKU IV",
            ],
            BASSA: [
                "AKUBA I",
                "AKUBA II",
                "AYEDE/AKAKANA",
                "EFORO",
                "GBOLOKO",
                "IKENDE",
                "KPATA",
                "MOZUM",
                "OZONGOLO/KPANCHE",
                "OZUGBE",
            ],
            DEKINA: [
                "ABOCHO",
                "ADUMU EGUME",
                "ANYIGBA",
                "DEKINA TOWN",
                "EMEWE",
                "IYALE",
                "ODU I",
                "ODU II",
                "OGANE INIGU",
                "OGBABEDE",
                "OJIKPADALA",
                "OKURA OLAFIA",
            ],
            IBAJI: [
                "AKPANYO",
                "ANALO",
                "AYAH",
                "EJULE",
                "IYAN",
                "ODEKE",
                "OJILA",
                "ONYEDEGA",
                "UJEH",
                "UNALE",
            ],
            IDAH: [
                "EDE",
                "EGA",
                "ICHALA",
                "IGALAOGBA",
                "IGECHEBA",
                "OGEGELE",
                "OWOLIAPA",
                "SABON GARI",
                "UGWODA",
                "UKWAJA",
            ],
            "IGALAMELA-ODOLU": [
                "AJAKA I",
                "AJAKA II",
                "AKPANYA",
                "AVRUGO",
                "EKWULOKO",
                "ODOLU",
                "OFORACHI I",
                "OFORACHI II",
                "OJI-AJI",
                "UBELE",
            ],
            IJUMU: [
                "AIYEGUNLE",
                "AIYEREH/ARIMAH",
                "AIYETORO I",
                "AIYETORO II",
                "EGBEDA/EGGA/OKEDAYO",
                "EKINRIN ADDE",
                "IFE/IKOYI/OKEJUMU",
                "IGBOLAYERE/ILAERE",
                "ILETEJU/ORIGAH",
                "IYAH/AYEH",
                "IYAMOYE",
                "IYARA",
                "ODOKORO",
                "OGALE/ADUGE",
                "OKORO/IGAH/OGIDI",
            ],
            "KABBA-BUNU": [
                "AIYETEJU",
                "AIYETORO-KIRI",
                "AIYEWA",
                "AKUTUPA-KIRI",
                "ASUTA",
                "EGBEDA",
                "ILUKE",
                "ODO-AKETE",
                "ODO-APE",
                "ODOLU",
                "OKEBUKUN",
                "OKEDAYO",
                "OKEKOKO",
                "OLLEOKE-OFIN",
                "OTU",
            ],
            "KOGI KK": [
                "AKPASU",
                "CHIKARA NORTH",
                "CHIKARA SOUTH",
                "GEGU BEKI NORTH",
                "GEGU BEKI SOUTH",
                "GIRINYA",
                "IRENDU",
                "KOTONKARFE",
                "ODAKI",
                "TAWARI",
                "UKWO",
            ],
            LOKOJA: [
                "EGGAN",
                "KAKANDAN",
                "KUPA NORTH",
                "KUPA SOUTH",
                "LOKOJA ‘A’",
                "LOKOJA ‘B’",
                "LOKOJA ‘C’",
                "LOKOJA ‘D’",
                "LOKOJA ‘E’",
                "OWORO",
            ],
            "MOPA MURO": [
                "AGBAGOUN",
                "AIYEDAYO/AIYEDARO",
                "AIYEDE/OKAGI",
                "ILETEJU I",
                "ILETEJU II",
                "ODOLE I",
                "ODOLE II",
                "OKEAGI/ILAI",
                "OROKERE",
                "TAKETE/ODE/OTAFUN",
            ],
            OFU: [
                "ALOJI",
                "ALOMA",
                "EJULE ALLAH",
                "IBOKO/EFAKWU",
                "IGO",
                "ITOBE/OKOKENYI",
                "OCHADAMU",
                "OFOKE",
                "OGBONICHA",
                "UGWOLAWO 1",
                "UGWOLAWO 2",
            ],
            "OGORI MAGONGO": [
                "AIYEROMI",
                "ENI",
                "ILETEJU",
                "OBATIGBEN",
                "OBINYIN",
                "OKESI",
                "OKIBO",
                "OSHOBANE",
                "OTURU OPOWUROYE",
                "UGUGU",
            ],
            OKEHI: [
                "EIKA/OHIZENYI",
                "OBAIBA I",
                "OBAIBA II",
                "OBANGEDE/UHUODO",
                "OBOROKE EBA",
                "OBOROKE UVETE",
                "OBOROKE UVETE II",
                "OHUEPE/OMAVI UBORO",
                "OHUETA",
                "OKAITO/USUNGWEN",
                "OKUEHU",
            ],
            OKENE: [
                "ABUGA/OZUJA",
                "BARIKI",
                "IDOJI",
                "OBEHIRA EBA",
                "OBEHIRA UVETTA",
                "OBESSA",
                "OKENE-EBA/AGASA/AHACHE",
                "ONYUKOKO",
                "ORIETESU",
                "OTUTU",
                "UPOGORO/ODENKU",
            ],
            OLAMABORO: [
                "IMANE I",
                "IMANE II",
                "OGUGU I",
                "OGUGU II",
                "OGUGU III",
                "OLAMABORO I",
                "OLAMABORO II",
                "OLAMABORO III",
                "OLAMABORO IV",
                "OLAMABORO V",
            ],
            OMALA: [
                "ABEJUKOLO I",
                "ABEJUKOLO II",
                "AKPACHA",
                "BAGAJI",
                "BAGANA",
                "ICHEKE AJOKPACHI",
                "OGODU",
                "OJI-AJI",
                "OKPATALA",
                "OLLA`",
                "OPODA/OFEJIJI",
            ],
            "YAGBA EAST": [
                "ALU/IGBAGUN/ORANRE",
                "EJUKU",
                "IFE-OLUKOTUN I",
                "IFE-OLUKOTUN II",
                "ILAFIN/IDOFIN/ODOGBE",
                "ITEDO",
                "JEGE/OKEYAGI/OGBOM/ISHAN",
                "MAKUTU I",
                "MAKUTU II",
                "PONYAN",
            ],
            "YAGBA WEST": [
                "EJIBA",
                "ISANLU ESA/OKOLOKE",
                "IYAMERIN/IGBARUKU",
                "ODO ARA/OMI/OGGA",
                "ODO EGBE",
                "ODO EGBE II",
                "ODO-ERE/OKE-ERE",
                "ODO-ERI/OKOTO",
                "ODOEGBE I",
                "OGBE",
                "OKE EGBE I",
                "OKE EGBE II",
                "OKE EGBE III",
                "OKE EGBE IV",
            ],
        },
    },
    {
        code: "KW",
        name: "KWARA",
        lgas: [
            "ASA",
            "BARUTEN",
            "EDU",
            "EKITI",
            "ERO",
            "IFELODUN",
            "ILORIN EAST",
            "ILORIN SOUTH",
            "ILORIN WEST",
            "IREPODUN",
            "ISIN",
            "KAIAMA",
            "MORO",
            "OFFA",
            "OYUN",
            "PATIGI",
        ],
        subs: {
            ASA: [
                "ADIGBONGBO/AWE/ORIMARO",
                "AFON",
                "AGO-OJA/OSHIN/LADUBA",
                "BALLA/OTTE",
                "BUDO-EGBA",
                "EFUE/BERIKODO",
                "ELEBUE/AGBONA/FATA",
                "GAMBARI/AIYEKALE",
                "ILA-OJA",
                "ODO-ODE/ABOTO",
                "OGBONDOROKO/REKE",
                "OGELE",
                "OKESO",
                "ONIRE/ODEGIWA/ALAPA",
                "OWODE/GBOGUN",
                "YOWERE II/OKEWERU",
                "YOWERE/SOSOKI",
            ],
            BARUTEN: [
                "BORIYA/SHIYA",
                "GBEREBERERU/BABANE",
                "GURE/GWASORO",
                "GWANARA",
                "ILESHA",
                "KENU/TABERU",
                "KIYORU/BWEN",
                "KPURA/YAKIRU",
                "OKUTA",
                "SHINAU/TUMBUYAN",
                "YASHIKIRA",
            ],
            EDU: [
                "LAFIAGI I",
                "LAFIAGI II",
                "LAFIAGI III",
                "LAFIGI IV",
                "TSARAGI I",
                "TSARAGI II",
                "TSARAGI III",
                "TSONGA I",
                "TSONGA II",
                "TSONGA III",
            ],
            EKITI: [
                "ERUKU",
                "ISAPA",
                "KORO",
                "OBBO AIYEGUNLE   I",
                "OBBO AIYEGUNLE   II",
                "OBBO-ILE",
                "OKE-OPIN/ETAN",
                "OPIN",
                "OSI    I",
                "OSI   II",
            ],
            ERO: [
                "AYEDUN",
                "EKAN",
                "IDOFIN IGBANA I",
                "IDOFIN IGBANA II",
                "IDOFIN ODO ASHE",
                "ILOFFA",
                "IMODE/EGOSI",
                "IMOJI/ILALE/ERINMOPE",
                "ODO OWA I",
                "ODO OWA II",
            ],
            IFELODUN: [
                "AGUNJIN",
                "IDOFIAN I",
                "IDOFIAN II",
                "IGBAJA I",
                "IGBAJA II",
                "IGBAJA III",
                "ILE - IRE",
                "OKE - ODE I",
                "OKE - ODE II",
                "OKE - ODE III",
                "OMUPA",
                "ORA",
                "ORO - AGO",
                "SHARE I",
                "SHARE II",
                "SHARE III",
                "SHARE IV",
                "SHARE V",
            ],
            "ILORIN EAST": [
                "AGBEYANGI",
                "APADO",
                "GAMBARI I",
                "GAMBARI II",
                "IBAGUN",
                "IPONRIN",
                "MAGAJI ARE I",
                "MAGAJI ARE II",
                "MARAFA/PEPELE",
                "MAYA/ILE APA",
                "OKE OYI/ OKE OSE/OSIN",
                "ZANGO",
            ],
            "ILORIN SOUTH": [
                "AKANBI I",
                "AKANBI II",
                "AKANBI III",
                "AKANBI IV",
                "AKANBI V",
                "BALOGUN FULANI I",
                "BALOGUN FULANI II",
                "BALOGUN FULANI III",
                "OKAKA I",
                "OKAKA II",
                "OKE-OGUN",
            ],
            "ILORIN WEST": [
                "ADEWOLE",
                "AJIKOBI",
                "BABOKO",
                "BADARI",
                "BALOGUN ALANAMU",
                "MAGAJI NGARI",
                "OGIDI",
                "OJU EKUN/ZARUMI",
                "OKO ERIN",
                "OLOJE",
                "UBANDANWAKI",
                "WARAH/OSHIN/EGBEJILA",
            ],
            IREPODUN: [
                "AJASE IPO I",
                "AJASE IPO II",
                "ARANDUN",
                "ESIE/IJAN",
                "IPETU/RORE/ARORIN",
                "OKO",
                "OMU ARAN I",
                "OMU ARAN II",
                "OMU ARAN III",
                "ORO I",
                "ORO II",
            ],
            ISIN: [
                "ALLA",
                "EDIDI",
                "IJARA",
                "ISANLU I",
                "ISANLU II",
                "IWO",
                "OKE-ABA",
                "OKE-ONIGBIN",
                "OLLA",
                "OWU-ISIN",
                "SAGBAJA/PAMO",
            ],
            KAIAMA: [
                "ADENA",
                "BANI",
                "GWANABE I",
                "GWANABE II",
                "GWARIA",
                "KAIAMA I",
                "KAIAMA II",
                "KAIAMA III",
                "KEMANJI",
                "WAJIBE",
            ],
            MORO: [
                "ABATI/ALARA",
                "AJANAKU",
                "AROBADI",
                "BABADUDU",
                "BODE SAADU",
                "EJIDONGARI",
                "JEBBA",
                "LANWA",
                "LOGUN/JEHUNKUNU",
                "MALETE/GBUGUDU",
                "MEGIDA",
                "OKEMI",
                "OKUTALA",
                "OLOORU",
                "PAKUNMO",
                "SHAO",
                "WOMI/AYAKI",
            ],
            OFFA: [
                "BALOGUN",
                "ESSA 'A'",
                "ESSA 'B'",
                "ESSA 'C'",
                "IGBOIDUN",
                "OJOMU CENTRE 'A'",
                "OJOMU CENTRE 'B'",
                "OJOMU NORTH/NORTH/WEST",
                "OJOMU SOUTH/EAST",
                "SHAWO CENTRE",
                "SHAWO SOUTH WEST",
                "SHAWO SOUTH/EAST",
            ],
            OYUN: [
                "ERIN NORTH",
                "ERIN SOUTH",
                "IGBONNA",
                "IGOSUN",
                "IJAGBO",
                "IKOTUN",
                "ILEMONA",
                "INNAJA/AHOGBADA",
                "IPEE",
                "IRRA",
                "OJOKU",
            ],
            PATIGI: [
                "KPADA I",
                "KPADA II",
                "KPADA III",
                "LADE I",
                "LADE II",
                "LADE III",
                "PATIGI I",
                "PATIGI II",
                "PATIGI III",
                "PATIGI IV",
            ],
        },
    },
    {
        code: "LA",
        name: "LAGOS",
        lgas: [
            "AGEGE",
            "AJEROMI IFELODUN",
            "ALIMOSHO",
            "AMUWO ODOFIN",
            "APAPA",
            "BADAGRY",
            "EPE",
            "ETI OSA",
            "IBEJU LEKKI",
            "IFAKO IJAYE",
            "IKEJA",
            "IKORODU",
            "KOSOFE",
            "LAGOS ISLAND",
            "LAGOS MAINLAND",
            "MUSHIN",
            "OJO",
            "OSHODI ISOLO",
            "SOMOLU",
            "SURULERE",
        ],
        subs: {
            AGEGE: [
                "AGBOTIKUYO/DOPEMU",
                "DAROCHA",
                "ILORO/ONIPETESI",
                "ISALE ODO",
                "ISALE/IDIMANGORO",
                "KEKE",
                "OKEKOTO",
                "ONIWAYA/PAPA-UKU",
                "ORILE AGEGE/OKO OBA",
                "OYEWOLE/PAPA ASHAFA",
                "TABON TABON/OKO OBA",
            ],
            "AJEROMI IFELODUN": [
                "AGO-HAUSA",
                "ALABA ORO",
                "AWODI-ORA",
                "LAYENI",
                "MOSAFEJO",
                "OJO-ROAD",
                "OLODI",
                "TEMIDIRE I",
                "TEMIDIRE II",
                "TOLU",
                "WILMER",
            ],
            ALIMOSHO: [
                "ABULE-EGBA, ABORU, MEIRAN, ALAGBADO",
                "AYOBO/IJON",
                "EGBE/AGODO",
                "EGBEDA/ALIMOSHO",
                "IDIMU/ISHERI/OLOFIN",
                "IGANDO/EGAN",
                "IKOTUN/IJEGUN",
                "IPAJA NORTH",
                "IPAJA SOUTH",
                "PLEASURE/OKE-ODO",
                "SHASHA/AKOWONJO",
            ],
            "AMUWO ODOFIN": [
                "AMUWO",
                "FESTAC I",
                "FESTAC II",
                "FESTAC III",
                "HOUSING",
                "IBESHE",
                "IGBOLOGUN",
                "IJEGUN",
                "IREDE",
                "KIRIKIRI",
                "SATELLITE",
            ],
            APAPA: [
                "AFOLABI ALASIA & ENVIRONS",
                "APAPA I ( MARINE ROAD & ENVIRONS)",
                "APAPA II (LIVERPOOL ROAD & ENVIRONS)",
                "APAPA III (CREEK RD/TINCAN/ SNAKE ISLAND",
                "APAPA IV (PELEWURA & ENVIRONS)",
                "GASKIYA ROAD & ENVIRONS",
                "IJORA OLOYE & ENVIRONS",
                "MALU ROAD & ENVIRONS",
                "OLODAN/OLOJOWON & ENVIRONS",
                "SARI & ENVIRONS",
            ],
            BADAGRY: [
                "AJARA",
                "AJIDO",
                "APA",
                "AWHANJIGOH",
                "IBEREKO",
                "IKOGA",
                "ILOGBO/ARAROMI",
                "IWORO/GBANKO",
                "IYAFIN",
                "KETA-EAST",
                "POSUKOH",
            ],
            EPE: [
                "ABOMITI",
                "AGBOWA",
                "AGBOWA \\IKOSI",
                "AGO-OWU",
                "AJAGANNABE",
                "EJINRIN",
                "ETITA/EBODE",
                "IBONWON",
                "ILARA",
                "ISE/IGBOGUN",
                "ITOIKIN",
                "LAGBADE",
                "ODOMOLA",
                "ODORAGUNSIN",
                "OKE-BALOGUN",
                "ORIBA/LADABA",
                "ORUGBO",
                "POKA",
                "POPO-OBA",
            ],
            "ETI OSA": [
                "ADDO/LANGBASA/BADORE",
                "AJAH/SANGOTEDO",
                "IKOYI I",
                "IKOYI II",
                "ILADO/ETI-OSA",
                "ILASAN HOUSING /MAIYEGUN VILLAGE",
                "LEKKI IKATE AND ENVIRONS",
                "OBALENDE",
                "VICTORIA ISLAND I",
                "VICTORIA ISLAND II",
            ],
            "IBEJU LEKKI": [
                "IBEJI I",
                "IBEJU II",
                "IWEREKUN I",
                "IWEREKUN II",
                "LEKKI I",
                "LEKKI II",
                "ORIMEDU I",
                "ORIMEDU II",
                "ORIMEDU III",
                "SIRIWON/IGBEKODO I",
                "SIRIWON/IGBEKODO II",
            ],
            "IFAKO IJAYE": [
                "AJEGUNLE/AKINDE/ ANIMASHAUN",
                "ALAKUKO/KOLLINTON",
                "FAGBA/AKUTE",
                "IJAIYE/AGBADO/KOLLINTON",
                "IJAIYE/OGBA",
                "IJAIYE/OJOKORO",
                "IJU ISHAGA",
                "IJU OBAWOLE",
                "NEW IFAKO/OYEMEKUN",
                "OLD IFAKO/KARAOLE",
                "PANADA/ABULE EGBA",
            ],
            IKEJA: [
                "ADEKUNLE VILL./ADENIYI JONES/OGBA",
                "AIRPORT/ONIPETESI/ONILEKERE",
                "ALAUSA/OREGUN/OLUSOSUN",
                "ANIFOWOSHE/IKEJA",
                "GRA/POLICE BARRACKS",
                "IPODO/SERIKI ARO",
                "OJODU/AGIDINGBI/OMOLE",
                "OKE-IRA/AGUDA",
                "ONIGBONGBO/MILITARY CANTONEMENT",
                "WASIMI/OPEBI/ALLEN",
            ],
            IKORODU: [
                "AGA/IJOMU",
                "AGBALA",
                "AGURA IPONMI",
                "BAIYEKU/ORETA",
                "ERIKORODO",
                "IBESHE",
                "IGBOGBO I",
                "IGBOGBO II",
                "IJEDE I",
                "IJEDE II",
                "IMOTA I",
                "IMOTA II",
                "IPAKODO",
                "ISELE I",
                "ISELE II",
                "ISELE III",
                "ISIU",
                "ODOGUNYAN",
                "OLORUNDA IGBAGA",
            ],
            KOSOFE: [
                "AGBOYI I",
                "AGBOYI II",
                "ANTHONY/MARYLAND",
                "IFAKO/SOLUYI",
                "ISHERI/OLOWORA",
                "KETU/ALAPERE",
                "KETU/IKOSI",
                "OJOTA/OGUDU",
                "OWODE/AJEGUNLE",
                "OWORONSHOKI",
            ],
            "LAGOS ISLAND": [
                "AGARAWU/OBADINA",
                "ANIKANTAMO",
                "EIYEKOLE",
                "EPETEDO",
                "IDUMOTA/OKE",
                "IDUNTAFA",
                "ILUPESI",
                "ISALE-AGBEDE",
                "LAFIAJI/EBUTE",
                "OJU-OTO",
                "OKO-AWO",
                "OKO-FAJI",
                "OLOSUN",
                "OLOWOGBOWO/ ELEGBATA",
                "OLUSHI/KAKAWA",
                "OLUWOLE",
                "ONIKAN",
                "POPO-AGUDA",
                "SANDGROUSE",
            ],
            "LAGOS MAINLAND": [
                "ALAGOMEJI",
                "EPETEDO",
                "GLOVER/EBUTE METTA",
                "IWAYA",
                "MAROKO/EBUTE METTA",
                "OKO‐BABA",
                "OLALEYE VILLAGE",
                "OTTO/IDDO",
                "OYADIRAN ESTATE/ABULE‐OJA",
                "OYINGBO MARKET/EBUTE METTA",
                "YABA/IGBOBI",
            ],
            MUSHIN: [
                "ALAKARA",
                "BABALOSA",
                "BABALOSA/IDI ARABA",
                "IDI ARABA",
                "IDI ORO/ODI OLOWO",
                "ILASAMAJA",
                "ILUPEJU",
                "ILUPEJU INDUSTRIAL",
                "ITIRE",
                "KAYODE/FADEYI",
                "MUSHIN ATEWOLARA",
                "OJUWOYE",
                "OLATEJU",
                "PAPA AJAO",
            ],
            OJO: [
                "AJANGBADI",
                "ETEGBIN",
                "IBA",
                "IDOLUWO",
                "IJANIKIN",
                "ILOGBO",
                "IREWE",
                "OJO- TOWN",
                "OKOKOMAIKO",
                "SABO- ONIBA",
                "TAFFI",
            ],
            "OSHODI ISOLO": [
                "AJAO",
                "EJIGBO",
                "ILASAMAJA",
                "ISOLO",
                "MAFOLUKU",
                "OKOTA",
                "ORILE OSHODI",
                "OSHODI/ BOLADE",
                "SHAGATEDO",
                "SHOGUNLE",
                "SHOGUNLE/ ALASIA",
            ],
            SOMOLU: [
                "ABULE OKUTA",
                "ALADE",
                "BAJULAIYE",
                "FOLA AGORO",
                "GBAGADA PHASE I",
                "GBAGADA PHASE II",
                "IGBOBI FADEYI",
                "ILAJE",
                "LADI-LAK",
                "MAFOWOKU",
                "ONIPANU",
                "PALMGROVE",
            ],
            SURULERE: [
                "ADENIRAN OGUNSANYA",
                "AGUDA",
                "AKINHANMI/COLE",
                "COKER",
                "IGBAJA/STADIUM",
                "IJESHATEDO",
                "IKATE",
                "IPONRI HOUSING/ ERIC MOORE",
                "ITIRE",
                "ORILE",
                "SHITTA/OGUNLANA",
                "YABA/OJUELEGBA",
            ],
        },
    },
    {
        code: "NA",
        name: "NASARAWA",
        lgas: [
            "AKWANGA",
            "AWE",
            "DOMA",
            "KARU",
            "KEANA",
            "KEFFI",
            "KOKONA",
            "LAFIA",
            "NASARAWA",
            "NASARAWA EGGON",
            "OBI",
            "TOTO",
            "WAMBA",
        ],
        subs: {
            AKWANGA: [
                "AGYAGA",
                "AKWANGA EAST",
                "AKWANGA WEST",
                "ANCHO BABA",
                "ANCHO/NIGHAAN",
                "ANDAHA",
                "GUDI",
                "GWANJE",
                "MOROA",
                "NINGO/BOHAR",
                "NUNKU",
            ],
            AWE: [
                "AKIRI",
                "AZARA",
                "GALADIMA",
                "JANGARU",
                "KANJE/ABUNI",
                "MADAKI",
                "MAKWANGIJI",
                "RIBI",
                "TUNGA",
                "WUSE",
            ],
            DOMA: [
                "AGBASHI",
                "AKPANAJA",
                "ALAGYE",
                "DANGALADIMA",
                "DOKA",
                "MADAKI",
                "MADAUCHI",
                "RUKUBI",
                "SABON GARI",
                "SARKI DAWAKI",
            ],
            KARU: [
                "AGADA/BAGAJI",
                "ASO/KODAPE",
                "GITATA",
                "GURKU/KABUSU",
                "KARSHI I",
                "KARSHI II",
                "KARU",
                "KEFFIN SHANU/BETTI",
                "PANDA/KARE",
                "TATTARA/KONDORO",
                "UKE",
            ],
            KEANA: [
                "AGAZA",
                "ALOSHI",
                "AMIRI",
                "GIZA GALADIMA",
                "IWAGU",
                "KADARKO",
                "KWARA",
                "MADAKI",
                "OBENE",
                "OKI",
            ],
            KEFFI: [
                "ANG. RIMI",
                "ANGWAN IYA I",
                "ANGWAN IYA II",
                "GANGAREN TUDU",
                "JIGWADA",
                "KEFFI TOWN EAST/KOFAR GORIYA",
                "LIMAN ABAJI",
                "SABON GARI",
                "TUDUN KOFAR",
                "YARA",
            ],
            KOKONA: [
                "AGWADA",
                "AMBA",
                "BASSA",
                "DARI",
                "GARAKU",
                "HADARI",
                "KOFAR GWARI",
                "KOKONA",
                "KOYA/KANA",
                "NINKORO",
                "YELWA",
            ],
            LAFIA: [
                "ADOGI",
                "AGYARAGUN TOFA",
                "ARIKYA",
                "ASHIGIE",
                "ASSAKIO",
                "BAKINRIJIYA/AKURBA/SARKIN PADA",
                "CHIROMA",
                "GAYAM",
                "KEFFI/WAMBAI",
                "MAKAMA",
                "SHABU/KWANDERE",
                "WAKWA",
                "ZANWA",
            ],
            NASARAWA: [
                "AKUM",
                "ARA I",
                "ARA II",
                "GUTO/AISA",
                "KANAH/ONDA/APAWU",
                "LAMINGA",
                "LOKO",
                "NASARAWA CENTRAL",
                "NASARAWA EAST",
                "NASARAWA MAIN TOWN",
                "NASARAWA NORTH",
                "ODU",
                "TUNGA/BAKONO",
                "UDENIN GIDA",
                "UDENIN MAGAJI",
            ],
            "NASARAWA EGGON": [
                "AGUNJI",
                "ALOCE/GINDA",
                "ALONGANI",
                "ENDE",
                "IGGA/BURUM BURUM",
                "IKKA WANGIBI",
                "KAGBU WANA",
                "LAMBAGA/ARIKPA",
                "LIZZIN KEFFI/EZZEN",
                "MADA STATION",
                "NASARAWA EGGON",
                "UBBE",
                "UMME",
                "WAKAMA",
            ],
            OBI: [
                "ADUDU",
                "AGWATASHI",
                "DEDDERE/RIRI",
                "DUDUGURU",
                "GIDAN AUSA I",
                "GIDAN AUSA II",
                "GWADANYE",
                "KYAKALE",
                "OBI",
                "TUDUN ADABU",
            ],
            TOTO: [
                "BUGA KARMO",
                "DAUSU",
                "GADAGBA",
                "GWARGWADA",
                "KANYEHU",
                "KATAKPA",
                "SHAFAN ABAKPA",
                "SHAFAN KWATO",
                "SHEGE",
                "TOTO",
                "UGYA",
                "UMAISHA",
            ],
            WAMBA: [
                "ARUM",
                "GITTA",
                "JIMIYA",
                "KONVAH",
                "KWARA",
                "MANGAR",
                "NAKERE",
                "WAMBA EAST",
                "WAMBA WEST",
                "WAYO",
            ],
        },
    },
    {
        code: "NI",
        name: "NIGER",
        lgas: [
            "AGAIE",
            "AGWARA",
            "BIDA",
            "BORGU",
            "BOSSO",
            "CHANCHAGA",
            "EDATTI",
            "GBAKO",
            "GURARA",
            "KATCHA",
            "KONTAGORA",
            "LAPAI",
            "LAVUN",
            "MAGAMA",
            "MARIGA",
            "MASHEGU",
            "MOKWA",
            "MUNYA",
            "PAIKORO",
            "RAFI",
            "RIJAU",
            "SHIRORO",
            "SULEJA",
            "TAFA",
            "WUSHISHI",
        ],
        subs: {
            AGAIE: [
                "BARO",
                "BOKU",
                "DAUACI",
                "EKOBADEGGI",
                "EKOSSA",
                "EKOWUGI",
                "EKOWUNA",
                "ETSUGAIE",
                "KUTIRKO",
                "MAGAJI",
                "TAGAGI",
            ],
            AGWARA: [
                "ADEHE",
                "AGWATA",
                "BUSURU",
                "GALLAH",
                "KASHINI",
                "KOKOLI",
                "MAGO",
                "PAPIRI",
                "ROFIA",
                "SUTEKU",
            ],
            BIDA: [
                "BARIKI",
                "CENIYAN",
                "DOKODZA",
                "KYARI",
                "LANDZUN",
                "MASABA  I",
                "MASABA  II",
                "MASAGA  I",
                "MASAGA  II",
                "MAYAKI NDAJIYA",
                "NASSARAFU",
                "UMARU MAJIGI  I",
                "UMARU MAJIGI  II",
                "WADATA",
            ],
            BORGU: [
                "BABANNA",
                "DUGGA",
                "KABE/PISSA",
                "KARABONDE",
                "KONKOSO",
                "MALALE",
                "NEW BUSSA",
                "RIVERINE",
                "SHAGUNU",
                "WAWA",
            ],
            BOSSO: [
                "BEJI",
                "BOSSO CENTRAL  I",
                "BOSSO CENTRAL  II",
                "CHANCHAGA",
                "GARATU",
                "KAMPALA",
                "KODO",
                "MAIKUNKELE",
                "MAITUMBI",
                "SHATA",
            ],
            CHANCHAGA: [
                "LIMAWA 'A'",
                "LIMAWA 'B'",
                "MAKERA",
                "MINNA CENTRAL",
                "MINNA SOUTH",
                "NASSARAWA 'A'",
                "NASSARAWA 'B'",
                "NASSARAWA 'C'",
                "SABONGARI",
                "TUDUN WADA NORTH",
                "TUDUN WADA SOUTH",
            ],
            EDATTI: [
                "ENAGI",
                "ETSU TASHA",
                "FAZHI",
                "GAZHE  I",
                "GAZHE  II",
                "GBANGBAN",
                "GONAGI",
                "GUZAN",
                "ROKOTA",
                "SAKPE",
            ],
            GBAKO: [
                "BATAGI",
                "BATAKO",
                "EDOKOTA",
                "EDOZHIGI",
                "ETSU AUDU",
                "GBADAFU",
                "GOGATA",
                "LEMU",
                "NUWANKOTA",
                "SAMMAJIKO",
            ],
            GURARA: [
                "BONU",
                "DIKO",
                "GAWU",
                "IZOM",
                "KABO",
                "KWAKA",
                "LAMBATA",
                "LEFU",
                "SHAKO",
                "TUFA",
            ],
            KATCHA: [
                "BADEGGI",
                "BAKEKO",
                "BISANTI",
                "DZWAFU",
                "EDOTSU",
                "ESSA",
                "GBAKOGI",
                "KATCHA",
                "KATEREGI",
                "SIDI SABA",
            ],
            KONTAGORA: [
                "AREWA",
                "CENTRAL",
                "GABAS",
                "KUDU",
                "MADARA",
                "MAGAJIYA",
                "MASUGA",
                "NAGWAMATSE",
                "RAFIN GORA",
                "TUNGAN KAWO",
                "TUNGAN WAWA",
                "USALLE",
                "YAMMA",
            ],
            LAPAI: [
                "AREWA/YAMMA",
                "BIRNIN MAZA/TASHIBO",
                "EBBO/GBACINKU",
                "EVUTI/KPADA",
                "GULU/ANGUWA VATSA",
                "GUPA/ABUGI",
                "GURDI/ZAGO",
                "KUDU/GABAS",
                "MUYE/EGBA",
                "TAKUTI/SHAKU",
            ],
            LAVUN: [
                "BATATI",
                "BUSU/KUCHI",
                "DABBAN",
                "DASSUN",
                "DOKO",
                "EGBAKO",
                "GABA",
                "JIMA",
                "KUSOTACHI",
                "KUTIGI",
                "LAGUN",
                "MAMBE",
            ],
            MAGAMA: [
                "AUNA CENTRAL",
                "AUNA EAST",
                "AUNA EAST CENTRAL",
                "AUNA SOUTH",
                "AUNA SOUTH EAST",
                "IBELU CENTRAL",
                "IBELU EAST",
                "IBELU NORTH",
                "IBELU WEST",
                "NASKO",
                "NASSARAWA",
            ],
            MARIGA: [
                "BANGI",
                "BERI",
                "BOBI",
                "GALMA/WAMBA",
                "GULBIN - BOKA",
                "IGWAMA",
                "INKWAI",
                "KAKIHUM",
                "KOTONKORO",
                "KUMBASHI",
                "MABURYA",
            ],
            MASHEGU: [
                "BABBAN RAMI",
                "DAPANGI/MAKERA",
                "IBBI",
                "KABOJI",
                "KASANGA",
                "KULHO",
                "KWATACHI",
                "MASHEGU",
                "MAZAKUKA/LIKORO",
                "SAHO - RAMI",
            ],
            MOKWA: [
                "BOKANI",
                "GBAJIBO/MUWO",
                "GBARA",
                "JA'AGI",
                "JEBBA NORTH",
                "KPAKI/TAKUMA",
                "KUDU",
                "LABOZHI",
                "MOKWA",
                "MUREGI",
                "RABBA/NDAYAKO",
            ],
            MUNYA: [
                "BENI",
                "DANDAUDU",
                "DANGUNU",
                "DAZA",
                "FUKA",
                "GINI",
                "GUNI",
                "KABULA",
                "KAZAI",
                "KUCHI",
                "SARKIN PAWA",
            ],
            PAIKORO: [
                "ADUNU",
                "CHIMBI",
                "GWAM",
                "ISHAU",
                "JERE",
                "KAFIN KORO",
                "KWAGANA",
                "KWAKUTI",
                "NIKUCHI T/MALLAM",
                "PAIKO CENTRAL",
                "TUTUNGO JEDNA",
            ],
            RAFI: [
                "KAGARA GARI",
                "KAKURI",
                "KONGOMA CENTRAL",
                "KONGOMA WEST",
                "KUNDU",
                "KUSHERKI NORTH",
                "KUSHERKI SOUTH",
                "SABON GARI",
                "TEGINA GARI",
                "TEGINA WEST",
                "YAKILA",
            ],
            RIJAU: [
                "DANRANGI",
                "DUGGE",
                "DUKKU",
                "GENU",
                "JAMA'ARE",
                "RIJAU",
                "SHAMBO",
                "T/BUNU",
                "T/MAGAJIYA",
                "USHE",
                "WARARI",
            ],
            SHIRORO: [
                "ALLAWA",
                "BANGAJIYA",
                "BASSA/KUKOKI",
                "EGWA/GWADA",
                "ERENA",
                "GALKOGO",
                "GURMANA",
                "GUSSORO",
                "KATO",
                "KUSHAKA/KUREBE",
                "KWAKI/CHUKWUBA",
                "MANTA",
                "PINA",
                "SHE",
                "UBANDOMA",
            ],
            SULEJA: [
                "BAGAMA 'A'",
                "BAGAMA 'B'",
                "HASHIMI  'A'",
                "HASHIMI  'B'",
                "IKU SOUTH  I",
                "IKU SOUTH  II",
                "KURMIN SARKI",
                "MAGAJIYA",
                "MAJE NORTH",
                "WAMBAI",
            ],
            TAFA: [
                "DOGON KURMI",
                "GARAM",
                "IJA GWARI",
                "IJA KORO",
                "IKU",
                "NEW BWARI",
                "WUSE EAST",
                "WUSE WEST",
                "ZUMA EAST",
                "ZUMA WEST",
            ],
            WUSHISHI: [
                "AKARE",
                "BARWA",
                "GWARJIKO",
                "KANWURI",
                "KODO",
                "KWATA",
                "LOKOGOMA",
                "MAITO",
                "SABON GARI",
                "TUKUNJI/YEMIGI",
                "ZUNGERU",
            ],
        },
    },
    {
        code: "OG",
        name: "OGUN",
        lgas: [
            "ABEOKUTA NORTH",
            "ABEOKUTA SOUTH",
            "ADO ODO OTA",
            "EGBADO NORTH",
            "EGBADO SOUTH",
            "EWEKORO",
            "IFO",
            "IJEBU EAST",
            "IJEBU NORTH",
            "IJEBU NORTH EAST",
            "IJEBU ODE",
            "IKENNE",
            "IMEKO AFON",
            "IPOKIA",
            "OBAFEMI OWODE",
            "ODEDA",
            "ODOGBOLU",
            "OGUN WATERSIDE",
            "REMO NORTH",
            "SAGAMU",
        ],
        subs: {
            "ABEOKUTA NORTH": [
                "AGO OKO",
                "ELEGA",
                "GBAGURA",
                "IBARA ORILE / ONISASA",
                "IKA",
                "IKEREKU",
                "IKIJA",
                "ILUGUN / IBEREKODO",
                "IMALA / IDI EMI",
                "ISAGA / ILEWO ORILE",
                "ITA OSHIN / OLOMORE",
                "LAFENWA",
                "OKE AGO OWU",
                "OLORUNDA / IJALE",
                "SABO",
                "TOTORO / SOKORI",
            ],
            "ABEOKUTA SOUTH": [
                "AGO EGUN/IJESA",
                "AKE I",
                "AKE II",
                "AKE III",
                "ERUNBE/OKE IJEUN",
                "IBARA I",
                "IBARA II",
                "IGBORE/AGO-OBA",
                "IJAYE/IDI/ABA",
                "IJEMO",
                "IMO/ISABO",
                "ITOKO",
                "KEESI/EMERE",
                "SODEKE/ISALE IJEUN I",
                "SODEKE/ISALE IJEUN II",
            ],
            "ADO ODO OTA": [
                "ADO I",
                "ADO II",
                "AGBARA",
                "AGBARA II",
                "ALAPOTI",
                "ATAN",
                "ERE",
                "IGBESA",
                "IJOKO",
                "IJU",
                "ILOGBO",
                "KETU ADIE OWE",
                "OTA I",
                "OTA II",
                "OTA III",
                "SANGO",
            ],
            "EGBADO NORTH": [
                "AYETORO I",
                "AYETORO II",
                "EBUTE IGBOORO",
                "IBESE",
                "IBOORO/ JOGA",
                "IDOFOI",
                "IGUA",
                "IJOUN",
                "IMASAI",
                "OHUNBE",
                "SUNWA",
            ],
            "EGBADO SOUTH": [
                "AJILETE",
                "IDOGO",
                "ILARO 1",
                "ILARO II",
                "ILARO III",
                "ILOBI/ERINJA",
                "IWOYE",
                "OKE-ODAN",
                "OWODE I",
                "OWODE II",
            ],
            EWEKORO: [
                '"ARIGBAJO "',
                '"ASA/YOBO "',
                '"ELERE/ONIGBEDU "',
                '"ITORI "',
                '"MOSAN "',
                '"PAPALANTO "',
                '"WASIMI "',
                "ABALABI",
                "OBADA-OKO",
                "OWOWO",
            ],
            IFO: [
                "AGBADO",
                "AJUWON /AKUTE",
                "COKER",
                "IBOGUN",
                "IFO I",
                "IFOII",
                "IFOIII",
                "ISERI/OJODU",
                "OKE ARO /IBARAGUN",
                "OSOSUN",
                "SUNREN",
            ],
            "IJEBU EAST": [
                "AJEBANDELE",
                "IJEBU IFE I",
                "IJEBU IFE II",
                "IJEBU IMUSIN",
                "IKIJA",
                "IMOBI I",
                "IMOBI II",
                "ITELE",
                "OGBERE",
                "OWU",
            ],
            "IJEBU NORTH": [
                "AGO-IWOYE I",
                "AGO-IWOYE II",
                "AKO-ONIGBAGBO/GELEYE",
                "ATIKORI",
                "MAMU/ETIRI",
                "OJOWO/JAPARA",
                "OKE-AGBO",
                "OKE-SOPEN",
                "OMEN",
                "ORU-AWA/ILAPORU",
                "OSUN",
            ],
            "IJEBU NORTH EAST": [
                "ATAN/ IMUKU",
                "ERUNWON",
                "IGEDE/ ITAMARUN",
                "ILESE",
                "IMEWURO/ ODODEYO/ IMOMO",
                "ISONYIN",
                "ODOSENLU",
                "ODOSIMADEGUN/ ODOSENBORA",
                "OJU ONA",
                "OKE ERI/ OGBOGBO",
            ],
            "IJEBU ODE": [
                "IJADA-IMEPE I",
                "IJADA-IMEPE II",
                "IJASI-IDEPO",
                "ISIWO",
                "ISOKU/OSOSA",
                "ITAMAPAKO",
                "ITANTEBO",
                "ODO-EGBO OLIWORO",
                "ODO-ESA",
                "POROGUN I",
                "POROGUN II",
            ],
            IKENNE: [
                "IKENNE I",
                "IKENNE II",
                "ILISAN I",
                "ILISAN II",
                "ILISAN/IROLU",
                "IPERU I",
                "IPERU II",
                "IPERU III",
                "OGERE I",
                "OGERE II",
            ],
            "IMEKO AFON": [
                "AFON",
                "AGBORO/GBOMO",
                "ATAPELE",
                "IDOFA",
                "ILARA/ALAGBE",
                "IMEKO",
                "IWOYE/JABATA",
                "KAJOLA/AGBERIODO",
                "OKE AGBEDE",
                "OWODE/IDIAYIN",
            ],
            IPOKIA: [
                "AGADA",
                "AGOSASA",
                "AJEGUNLE",
                "IDIROKO",
                "IFONYINTEDO",
                "IHUNBO / ILASE",
                "IJOFIN / ODOSA",
                "IPOKIA  I",
                "IPOKIA  II",
                "MAUN  I",
                "MAUN  II",
                "TUBE",
            ],
            "OBAFEMI OWODE": [
                "AJEBO",
                "AJURA",
                "ALAPAKO ONI",
                "EGBEDA",
                "KAJOLA",
                "MOKOLOKI",
                "MOLOKO ASIPA",
                "OBA",
                "OBAFEMI",
                "OFADA",
                "ONIDUNDU",
                "OWODE",
            ],
            ODEDA: [
                "ALABATA",
                "ALAGBAGBA",
                "BALOGUN ITESI",
                "ILUGUN",
                "OBANTOKO",
                "OBETE",
                "ODEDA",
                "OLODO",
                "OPEJI",
                "OSIELE",
            ],
            ODOGBOLU: [
                "AIYEPE",
                "ALA",
                "IBEFUN",
                "IDOWA",
                "ILADO",
                "IMODI",
                "IMOSAN",
                "JOBORE",
                "ODOGBOLU I",
                "ODOGBOLU II",
                "OGBO MORAIKA ITA EPO 11",
                "OGBO MORAIKA ITA EPO I",
                "OKUN- OWA",
                "OMU",
                "OSOSA",
            ],
            "OGUN WATERSIDE": [
                "ABIGI",
                "AYEDE/LOMIRO",
                "AYILA/ITEBU",
                "EFIRE",
                "IBIADE",
                "IWOPIN",
                "LUKOGBE/ILUSHIN",
                "MAKUN/IROKUN",
                "ODE OMI",
                "ONI",
            ],
            "REMO NORTH": [
                "AIYEGBAMI",
                "AKAKA",
                "IGAN AJINLA",
                "ILARA",
                "IPARA",
                "MOBORODE/OKE OLA",
                "ODE I",
                "ODE II",
                "ODOFIN/IMAGBON/PETEKU/ DAWA",
                "ORILE-OKO",
            ],
            SAGAMU: [
                "AGBOWA",
                "AYEGBAMI / IJOKUN",
                "IBIDO /ITUNLA / ALARA",
                "IJA AGBA",
                "ISOKUN / OYEBAJO",
                "ISOTE",
                "LATAWA",
                "ODE LEMO",
                "OGIJO / LIKOSI",
                "OKO /EPE / ITUNLA  I",
                "OKO /EPE / ITUNLA  II",
                "SABO  I",
                "SABO  II",
                "SIMAWA / IWELEPE",
                "SURULERE",
            ],
        },
    },
    {
        code: "ON",
        name: "ONDO",
        lgas: [
            "AKOKO NORTH EAST",
            "AKOKO NORTH WEST",
            "AKOKO SOUTH EAST",
            "AKOKO SOUTH WEST",
            "AKURE NORTH",
            "AKURE SOUTH",
            "ESE ODO",
            "IDANRE",
            "IFEDORE",
            "ILAJE",
            "ILEOLUJI/OKEIGBO",
            "IRELE",
            "ODIGBO",
            "OKITIPUPA",
            "ONDO EAST",
            "ONDO WEST",
            "OSE",
            "OWO",
        ],
        subs: {
            "AKOKO NORTH EAST": [
                "EDO",
                "EKAN",
                "IKADO I",
                "IKADO II",
                "ILEPA I",
                "ILEPA II",
                "ISOWOPO I",
                "ISOWOPO II",
                "IYOMETA I",
                "IYOMETA II",
                "OORUN I",
                "OORUN II",
                "OYINMO",
            ],
            "AKOKO NORTH WEST": [
                "AJOWA",
                "ARIGIDI II",
                "ARIGIDI/IYE",
                "ESE/AFIN",
                "IKARAM/IBARAM",
                "ODO IRUN",
                "OGBAGI",
                "OKE IRUN",
                "OKEAGBE",
                "OYIN/OGE",
            ],
            "AKOKO SOUTH EAST": [
                "EPINMI I",
                "EPINMI II",
                "IFIRA",
                "IPE I",
                "IPE II",
                "IPESI",
                "ISUA I",
                "ISUA II",
                "ISUA III",
                "ISUA IV",
                "SOSAN",
            ],
            "AKOKO SOUTH WEST": [
                "AKUNGBA I",
                "AKUNGBA II",
                "IKUN",
                "OBA I",
                "OBA II",
                "OKA I IBAKA SABO",
                "OKA II A IKANMU",
                "OKA IIB OKIA KOROWA",
                "OKA IIIA AGBA",
                "OKA IIIB OWASE/IKESE",
                "OKA IV OWAKE/EBO",
                "OKA VA OWALUSI",
                "OKA VB OKA ODO",
                "SUPARE I",
                "SUPARE II",
            ],
            "AKURE NORTH": [
                "AGAMO /OKE OORE",
                "AYEDE OGBSE",
                "AYETORO",
                "IGBATORO",
                "IGOBA/ISINIGBO",
                "ILUABO/ELEYEWO",
                "ISIMIJA/IRADO",
                "MOFERERE",
                "OBA -ILE",
                "ODO -OJA/IJIGBO",
                "OKE AFA/OWODE",
                "OKE IJU",
            ],
            "AKURE SOUTH": [
                "APONMU",
                "GBOGI / ISIKAN I",
                "GBOGI / ISIKAN II",
                "IJOMU / OBANLA",
                "LISA",
                "ODA",
                "ODOPETU",
                "OKE ARO / URO I",
                "OKE ARO / URO II",
                "OSHODI / ISOLO",
                "OWODE / IMUAGUN",
            ],
            "ESE ODO": [
                "APOI I",
                "APOI II",
                "APOI III",
                "APOI IV",
                "APOI V",
                "AROGBO 1",
                "AROGBO II",
                "AROGBO III",
                "UKPARAMA I",
                "UKPARAMA II",
            ],
            IDANRE: [
                "ALA ELEFOSAN",
                "ALADE ATOSIN",
                "IDALE LEMIKAN",
                "IDALE LOGBOSERE",
                "IJOMU ISURIN",
                "IROWO",
                "ISALU EHINPETI",
                "ISALU JIGBOKIN",
                "OFOSU/ONISERE",
                "OWENA/APONMULONA",
            ],
            IFEDORE: [
                "ERO/IBOJI/MARIWO",
                "IGBARAOKE I",
                "IGBARAOKE II",
                "IJARE I",
                "IJARE II",
                "ILARA I",
                "ILARA II",
                "IPOGUN/IBULE",
                "ISARUN/ERIGI",
                "OBO/IKOTA/OLO-GBO",
            ],
            ILAJE: [
                "AHERI",
                "ETIKAN",
                "MAHIN 1V",
                "MAHIN I",
                "MAHIN II",
                "MAHIN III",
                "UGBO I",
                "UGBO II",
                "UGBO III",
                "UGBO IV",
                "UGBO V",
                "UGBO V1",
            ],
            "ILEOLUJI/OKEIGBO": [
                "ILEOLUJI I",
                "ILEOLUJI II",
                "ILEOLUJI III",
                "ILEOLUJI IV",
                "ILEOLUJI V",
                "ILEOLUJI VI",
                "OKE-IGBO III",
                "OKE-IGBOIV",
                "OKEIGBO I",
                "OKEIGBO II",
            ],
            IRELE: [
                "AJAGBA I",
                "AJAGBA II",
                "AKOTOGBO I",
                "AKOTOGBO II",
                "IRELE I",
                "IRELE II",
                "IRELE III",
                "IRELE IV",
                "IRELE V",
                "IYANSAN/OMI",
            ],
            ODIGBO: [
                "AGBABU",
                "AGO ALAYE",
                "AJUE",
                "ARAROMI OBU",
                "AYAN",
                "EBIJAW",
                "KOSERU",
                "ODIGBO",
                "ONIPARAGA",
                "ORE I",
                "ORE II",
            ],
            OKITIPUPA: [
                "AYEKA/IGBODIGO",
                "ERINJE",
                "IGBOTAKO  I",
                "IGBOTAKO  II",
                "IJU-ODO/EREKITI",
                "IKOYA/OLOTO",
                "ILUTITUN  I",
                "ILUTITUN  II",
                "ILUTITUN III",
                "ODE AYE  I",
                "ODE AYE  II",
                "OKITIPUPA  I",
                "OKITIPUPA  II",
            ],
            "ONDO EAST": [
                "ASANTAN OJA",
                "ATERU/IGBA OTASAN",
                "BOLORUNDURO",
                "EPE",
                "FAGBO",
                "OBADA",
                "OBOTO",
                "ORISUMIBARE",
                "OWENA",
                "TEPO",
            ],
            "ONDO WEST": [
                "ENU OWA/OBALALU",
                "GBAGHENGA/OGBONGBO/ AJAGBA-ALAAFIA",
                "IFORE/ODOSIDA",
                "ILUNLA/BAGBE/ODOWO I",
                "ILUNLA/BAGBE/ODOWO II",
                "LITAYE/OBUN KEKERE/IGBINDO",
                "LODASA/PARUKU/LIJOKA",
                "ODOJOMU/ERIN KETA/EGIRI",
                "OKE AGUNLA/OKEROWO/ OKEKUTA",
                "OKE OTUNBA/OKEDIBO/ SOKOTI",
                "OKELISA/OKEDIBO/OGBODU",
                "ORISUNMIBARE/ARAROMI",
            ],
            OSE: [
                "AFO",
                "IDOANI I",
                "IDOANI II",
                "IDOGUN",
                "IFON I",
                "IFON II",
                "IJAGBA",
                "IKARO/ELEGBEKA",
                "IMERI",
                "IMORU ARIMOGIJA",
                "OKELUSE",
                "UTE",
            ],
            OWO: [
                "EHINGBE",
                "IGBOROKO I",
                "IGBOROKO II",
                "IJEBU I",
                "IJEBU II",
                "ILORO",
                "IPELE",
                "ISAIPEN",
                "ISUADA",
                "IYERE",
                "USO/EMURE",
            ],
        },
    },
    {
        code: "OS",
        name: "OSUN",
        lgas: [
            "ATAKUMOSA EAST",
            "ATAKUMOSA WEST",
            "AYEDAADE",
            "AYEDIRE",
            "BOLUWADURO",
            "BORIPE",
            "EDE NORTH",
            "EDE SOUTH",
            "EGBEDORE",
            "EJIGBO",
            "IFE CENTRAL",
            "IFE EAST",
            "IFE NORTH",
            "IFE SOUTH",
            "IFEDAYO",
            "IFELODUN",
            "ILA",
            "ILESHA EAST",
            "ILESHA WEST",
            "IREPODUN",
            "IREWOLE",
            "ISOKAN",
            "IWO",
            "OBOKUN",
            "ODO OTIN",
            "OLA OLUWA",
            "OLORUNDA",
            "ORIADE",
            "OROLU",
            "OSOGBO",
        ],
        subs: {
            "ATAKUMOSA EAST": [
                "AJEBANDELE",
                "AYEGUNLE",
                "ETI ONI",
                "FAFORIJI",
                "FOREST RESERVE I",
                "FOREST RESERVE II",
                "IGANGAN",
                "IPERINDO",
                "IPOLE",
                "IWARA",
            ],
            "ATAKUMOSA WEST": [
                "IBODI",
                "IFELODUN",
                "IFEWARA  I",
                "IFEWARA II",
                "ISA-OBI",
                "ITAGUNMODI",
                "MUROKO",
                "OKE-BODE",
                "OSU I",
                "OSU II",
                "OSU III",
            ],
            AYEDAADE: [
                "ANLUGBUA",
                "ARAROMI OWU",
                "BALOGUN",
                "GBONGAN RURAL",
                "IJUGBE/OKE ESO/OKE OWU",
                "LAGERE AMOLA",
                "OBALUFON",
                "ODEOMU RURAL",
                "OLUFI",
                "OTUN BALOGUN",
                "OTUN OLUFI",
            ],
            AYEDIRE: [
                "ILEOGBO 1",
                "ILEOGBO II",
                "ILEOGBO III",
                "ILEOGBO IV",
                "KUTA I",
                "KUTA II",
                "OKE OSUN",
                "OLUPONNA I",
                "OLUPONNA II",
                "OLUPONNA III",
            ],
            BOLUWADURO: [
                "ERIPA",
                "GBELERU OBAALA I",
                "GBELERU OBAALA II",
                "IRESI  I",
                "IRESI II",
                "OBALA ILORO",
                "OKE IRUN",
                "OKE ODE OTAN",
                "OKE OMI OTAN",
                "OKE OTAN",
            ],
            BORIPE: [
                "AAGBA",
                "ADA I",
                "ADA II",
                "COLLEGE/EGBEDA",
                "ISALE ASA, IREE",
                "ISALE OYO",
                "OJA OBA",
                "OKE AAREE",
                "OKE ESA/OKE OGI",
                "OLOTI",
                "ORORUWO",
            ],
            "EDE NORTH": [
                "ABOGUNDE/SAGBA",
                "ALUSEKERE",
                "APASO",
                "ASUNMO",
                "BARA EJEMU",
                "ISIBO/BUHARI-ISHOLA",
                "OLOBA/ATAPARA",
                "OLOGUN/AGBAAKIN",
                "OLUSOKUN",
                "SABO/AGBONGBE I",
                "SABO/AGBONGBE II",
            ],
            "EDE SOUTH": [
                "ALAJUE I",
                "ALAJUE II",
                "BABANLA/AGATE",
                "BABASANYA",
                "JAGUNJAGUN",
                "KUYE",
                "LOOGUN",
                "OLODAN",
                "OLOKI AKODA",
                "SEKONA",
            ],
            EGBEDORE: [
                "ARA I",
                "ARA II",
                "AWO/ABUDO",
                "IDO-OSUN",
                "IKOTUN",
                "IRAGBERI I",
                "IRAGBERI II",
                "IWOYE /IDOO/ ORIGBO",
                "OJO /ARO",
                "OKINNI/OFATEDO/ OLORUNSOGO",
            ],
            EJIGBO: [
                'ELEJIGBO "A"',
                'ELEJIGBO "B"/OSOLO',
                'ELEJIGBO "C"/MAPO',
                'ELEJIGBO "D"',
                "ELEJIGBO/AYEGBOGBO",
                'IFE ODAN "A"/,OWU ILE',
                'IFE ODAN "B"/MASIFA',
                "ILAWO/ISOKO/ISUNDUNRIN",
                "INISA I/AATO/IGBON",
                "INISA II/AFAAKE/AYEGUNLE",
                "OLA/AAYE/AGURODO",
            ],
            "IFE CENTRAL": [
                "AKARABATA",
                "ILARE I",
                "ILARE II",
                "ILARE III",
                "ILARE IV",
                "IREMO I",
                "IREMO II",
                "IREMO III",
                "IREMO IV",
                "IREMO V",
                "MOORE/OJAJA",
            ],
            "IFE EAST": [
                "ILODE I",
                "ILODE II",
                "MODAKEKE I",
                "MODAKEKE II",
                "MODAKEKE III",
                "MOORE",
                "OKEREWE I",
                "OKEREWE II",
                "OKEREWE III",
                "YEKEMI",
            ],
            "IFE NORTH": [
                "ASIPA/AKINLALU",
                "EDUNABON I",
                "EDUNABON II",
                "FAMIA",
                "IPETUMODU I",
                "IPETUMODU II",
                "MORO",
                "OYERE I",
                "OYERE II",
                "YAKOOYO",
            ],
            "IFE SOUTH": [
                "AARE",
                "ABIRI OGUDU",
                "AYE",
                "AYESAN",
                "IKIJA I",
                "IKIJA II",
                "KERE",
                "MEFOWORADE",
                "OKE OWENA",
                "OLODE",
                "OSI",
            ],
            IFEDAYO: [
                "AKESIN",
                "ASAONI",
                "AWORO/ OKE ILA RURAL",
                "AYETORO",
                "BALOGUN",
                "COOPERATIVE",
                "ISINMI OLOOTU",
                "OBAALE",
                "OYI",
                "TEMIDIRE",
            ],
            IFELODUN: [
                "AMOLA IKIRUN",
                "EESA IKIRUN",
                "EKO ENDE/EKO AJALA",
                "IBA I",
                "IBA II",
                "IKIRUN RURAL",
                "ISALE/OKE AFO",
                "OBAGUN",
                "OKEBA IKIRUN",
                "OLONDE IKIRUN",
                "OWODE IKIRUN",
                "STATION RD, IKIRUN",
            ],
            ILA: [
                "AJABA/EDEMOSI/ABA ORANGUN",
                "EJIGBO I",
                "EJIGBO II",
                "EJIGBO III",
                "EYINDI",
                "IPERIN",
                "IPERIN/EYINDI",
                "ISEDO I",
                "ISEDO II",
                "OKE OLA",
                "OKE-EDE",
            ],
            "ILESHA EAST": [
                "BILADU",
                "BOLORUNDURO",
                "IFOSAN",
                "IJAMO",
                "ILERIN",
                "ILORO/ IROYE",
                "IMO",
                "ISARE",
                "ITISIN",
                "OKESA",
                "UPPER &LOWER IJOKA",
            ],
            "ILESHA WEST": [
                "AYESO",
                "EREJA",
                "IKOYI/IKOTI/ARAROMI",
                "ILAJE",
                "ISIDA/ADETI",
                "ISOKUN",
                "ITAKOGUN/UPPER EGBE-IDI",
                "LOWER EGBE-IDI",
                "OMOFE/IDASA",
                "UPPER/LOWER IGBOGI",
            ],
            IREPODUN: [
                "BARA 'A'",
                "BARA 'B'",
                "ELERIN 'A'",
                "ELERIN 'B'",
                "ELERIN 'C'",
                "ELERIN 'D'",
                "ELERIN 'E'",
                "OLOBU 'A'",
                "OLOBU 'B'",
                "OLOBU 'C'",
                "OLOBU 'D'",
            ],
            IREWOLE: [
                "IKIRE 'A'",
                "IKIRE 'B'",
                "IKIRE 'C'",
                "IKIRE 'D'",
                "IKIRE 'E'",
                "IKIRE 'F'",
                "IKIRE 'G'",
                "IKIRE 'H'",
                "IKIRE 'I'",
                "IKIRE 'J'",
                "IKIRE 'K'",
            ],
            ISOKAN: [
                "ALAPOMU I",
                "ALAPOMU II",
                "ASALU IKOYI",
                "ASALU MOGIMOGI",
                "AWALA I",
                "AWALA II",
                "IDOGUN",
                "OLUKOYI (OJA-OSUN)",
                "OOSA ADIFA",
                "OOSA IKOYI",
                "ORANRAN",
            ],
            IWO: [
                "GIDIGBO I",
                "GIDIGBO II",
                "GIDIGBO III",
                "ISALE OBA I",
                "ISALE OBA II",
                "ISALE OBA III",
                "ISALE OBA IV",
                "MOLETE I",
                "MOLETE II",
                "MOLETE III",
                "OKE ADAN I",
                "OKE ADAN II",
                "OKE ADAN III",
                "OKE OBA I",
                "OKE OBA II",
            ],
            OBOKUN: [
                "EESUN / IDOOKO",
                "ESA-ODO",
                "ESA-OKE",
                "IBOKUN",
                "ILAHUN/IKINYINWA",
                "ILARE",
                "ILASE / IDOMINASI",
                "IMESI-ILE",
                "IPETU/ADA OWODE",
                "OTAN-ILE",
            ],
            "ODO OTIN": [
                "ASI/ASABA",
                "BAALE",
                "EKOSIN/IYEKU",
                "ESA OTUN BAALE ODE",
                "FAJI/OPETE",
                "IGBAYE",
                "IJABE/ILA-ODO",
                "JAGUN/OSI BAALE ODE",
                "OBA OJOMU",
                "OKU/EKUSA",
                "OLOYAN/ELEMOSO/EESA",
                "OLUKOTUN",
                "OLUNISA",
                "OORE/AGBEYE",
                "OSOLO/OPARINOLA",
            ],
            "OLA OLUWA": [
                "AJAGBA /IWO-OKE",
                "ASA /AJAGUNLASE",
                "ASAMU/ILEMOWU",
                "BODE- OSI",
                "IKIRE ILE /IWARA",
                "ISERO /IKONIFIN",
                "OBAMORO /ILE-OGBO",
                "OGBAAGBA I",
                "OGBAAGBA II",
                "TELEMU",
            ],
            OLORUNDA: [
                "AGOWANDE",
                "AKOGUN",
                "ATELEWO",
                "AYETORO",
                "BALOGUN",
                "ILIE",
                "OBA OKE",
                "OBA-ILE",
                "OWODE I",
                "OWODE II",
                "OWOOPE",
            ],
            ORIADE: [
                "APOTI/DAGBAJA",
                "ERIN-JESA",
                "ERIN-OKE",
                "ERINMO/IWARAJA",
                "IJEBU-IJESA",
                "IJEJA/ILOKO",
                "IKEJI ARAKEJI/OWENA",
                "IKEJI-ILE",
                "IPETU-IJESA I",
                "IPETU-IJESA II",
                "IRA",
                "IWOYE-IJESA",
            ],
            OROLU: [
                "OLUFON 'A'",
                "OLUFON 'B'",
                "OLUFON 'C'",
                "OLUFON 'D'",
                "OLUFON 'E'",
                "OLUFON 'F'",
                "OLUFON 'G'",
                "OLUFON 'H'",
                "OLUFON 'I'",
                "OLUFON 'J'",
            ],
            OSOGBO: [
                "ALAGBAA",
                "ARE AGO",
                "ATAOJA 'A'",
                "ATAOJA 'B'",
                "ATAOJA 'C'",
                "ATAOJA 'D'",
                "ATAOJA 'E'",
                "BABA KEKERE",
                "EKERIN",
                "EKETA",
                "JAGUN 'A'",
                "JAGUN 'B'",
                "OTUN BALOGUN 'A'",
                "OTUN JAGUN 'A'",
                "OTUN JAGUN 'B'",
            ],
        },
    },
    {
        code: "OY",
        name: "OYO",
        lgas: [
            "AFIJIO",
            "AKINYELE",
            "ATIBA",
            "ATISBO",
            "EGBEDA",
            "IBADAN NORTH",
            "IBADAN NORTH EAST",
            "IBADAN NORTH WEST",
            "IBADAN SOUTH EAST",
            "IBADAN SOUTH WEST",
            "IBARAPA CENTRAL",
            "IBARAPA EAST",
            "IBARAPA NORTH",
            "IDO",
            "IREPO",
            "ISEYIN",
            "ITESIWAJU",
            "IWAJOWA",
            "KAJOLA",
            "LAGELU",
            "OGBOMOSHO NIORTH",
            "OGBOMOSHO SOUTH",
            "OGO OLUWA",
            "OLORUNSOGO",
            "OLUYOLE",
            "ONA ARA",
            "OORELOPE",
            "ORIIRE",
            "OYO EAST",
            "OYO WEST",
            "SAKI EAST",
            "SAKI WEST",
            "SURULERE",
        ],
        subs: {
            AFIJIO: [
                "AKINMORIN/JOBELE",
                "AWE I",
                "AWE II",
                "FIDITL  II",
                "FIDITL. I",
                "ILORAL I",
                "ILORAL II",
                "ILORAL III",
                "IMINI",
                "IWARE",
            ],
            AKINYELE: [
                "AJIBADE/ALABATA/ELEKURU",
                "AKINYELE/ISABIYI/IREPODUN",
                "ARULOGUN/ENIOSA/ARORO",
                "IJAYE/OJEDEJI",
                "IKEREKU",
                "IROKO",
                "IWOKOTO/TALONTAN/IDI-ORO",
                "OJO-EMO/MONIYA",
                "OJOO/AJIBODE/LANIBA",
                "OLANLA/OBODA/LABODE",
                "OLODE/AMOSUN/ONIDUNDU",
                "OLORISA-OKO/OKEGBEMI/ MELE",
            ],
            ATIBA: [
                "AGUNPOPO I",
                "AGUNPOPO II",
                "AGUNPOPO III",
                "AREMO",
                "ASHIPA I",
                "ASHIPA II",
                "ASHIPA III",
                "BASHORUN",
                "OKE-AFIN I",
                "OKE-AFIN II",
            ],
            ATISBO: [
                "AGO-ARE I",
                "AGO-ARE II",
                "ALAGA",
                "BAASI",
                "IRAWO-ILE",
                "IRAWO-OWODE",
                "OFIKI",
                "OWO/AGUNREGE/SABE",
                "TEDE I",
                "TEDE II",
            ],
            EGBEDA: [
                "AYEDE/ALUGBO KOLOKO",
                "EGBEDA",
                "ERUNMU",
                "OLODAN/AJIWOGBO",
                "OLODE/ALAKIA",
                "OLODO II",
                "OLODO III",
                "OLODO/KUMAPAYI I",
                "OLUBADAN ESTATE",
                "OSEGERE/AWAYE",
                "OWOBAALE/KASUMU",
            ],
            "IBADAN NORTH": [
                "WARD 1 N2",
                "WARD II N3",
                "WARD III, N4",
                "WARD IV, N5A",
                "WARD IX N6B PARTY I",
                "WARD V, N5B",
                "WARD VI, N6A PARTY I",
                "WARD VII, N6A PARTY II",
                "WARD VIII, N6A PARTY III",
                "WARD X, N6B PARTY II",
                "WARD XI, NW8",
                "WARD XII, NW8",
            ],
            "IBADAN NORTH EAST": [
                "WARD 1 EI",
                "WARD II, NI (PART II)",
                "WARD III, E3",
                "WARD IV, E4",
                "WARD IX, E7II",
                "WARD V, E5A",
                "WARD VI, E5B",
                "WARD VII, E6",
                "WARD VIII, E71",
                "WARD X,  E8",
                "WARD XI, E9I",
                "WARD XII, E9II",
            ],
            "IBADAN NORTH WEST": [
                "WARD 02 N1(PART 2)",
                "WARD 03 NW1",
                "WARD 04 N1(PART2)",
                "WARD 05 NW3(PART 1)",
                "WARD 06 NW3(PART 1)",
                "WARD 07 NW4",
                "WARD 08 NW5",
                "WARD 09 NW6",
                "WARD 1 N1(PART1)",
                "WARD 10 NW7",
                "WARD 11 NW7",
            ],
            "IBADAN SOUTH EAST": [
                "C1",
                "S1",
                "S2A",
                "S2B",
                "S3",
                "S4A",
                "S4B",
                "S5",
                "S6A",
                "S6B",
                "S7A",
                "S7B",
            ],
            "IBADAN SOUTH WEST": [
                "WARD 01 C1",
                "WARD 02 SW1",
                "WARD 03 SW2",
                "WARD 04 SW3",
                "WARD 05 SW4",
                "WARD 06 SW5",
                "WARD 07 SW6",
                "WARD 08 SW7",
                "WARD 09 SW8 (I)",
                "WARD 10 SW8 (II)",
                "WARD 11 SW9 (I)",
                "WARD 12 SW9 (II)",
            ],
            "IBARAPA CENTRAL": [
                "IBEREKODO (AGBOORO/ITA BAA)",
                "IBEREKODO (PATAOJU)",
                "IDERE I (MOLETE)",
                "IDERE II (OMINIGBO/OKO OBA",
                "IDERE III (KOSO/APA)",
                "IDOFIN SAGANUN",
                "IGBOLE/PAKO",
                "ISALE OBA",
                "OKESERIN I & II",
                "OKO ODO",
            ],
            "IBARAPA EAST": [
                "ABORERIN",
                "ANKO",
                "ISABA",
                "ISALE TOGUN",
                "ITABO",
                "NEW ERUWA",
                "OKE OBA",
                "OKE OTUN",
                "OKE-IMALE",
                "SANGO",
            ],
            "IBARAPA NORTH": [
                "AYETE I",
                "AYETE II",
                "IGANGAN I",
                "IGANGAN II",
                "IGANGAN III",
                "IGANGAN IV",
                "OFIKI I",
                "OFIKI II",
                "TAPA I",
                "TAPA II",
            ],
            IDO: [
                "ABA EMO /ILAJU /ALAKO",
                "AKINWARE/AKINDELE",
                "AKUFO/IDIGBA/ARAROMI",
                "APETE/AYEGUN/AWOTAN",
                "BATAKE/IDI-IYA",
                "ERINWUSI/KOGUO ODETOLA",
                "FENWA/OGANLA/ELENUSONSO",
                "IDO/ONIKEDE/OKUNA-AWO",
                "OGUNDELE/ALAHO/SIBA/IDI- AHUN",
                "OMI-ADIO/OMIONIGBAGBO/ BAKATARI",
            ],
            IREPO: [
                "AGORO",
                "AJAGUNNA",
                "ATIPA",
                "IBA I",
                "IBA II",
                "IBA III",
                "IBA IV",
                "IBA V",
                "IKOLABA",
                "LAHA/AJANA",
            ],
            ISEYIN: [
                "ADO AWAYE",
                "AKINWUMI/OSOOGO",
                "EKUNLE I",
                "EKUNLE II",
                "FARAMORA",
                "IJEMBA/OKE-EYIN/OKE OLA",
                "ISALU I",
                "ISALU II",
                "KOSO I",
                "KOSO II",
                "LADOGAN",
            ],
            ITESIWAJU: [
                "BABA ODE",
                "IGBOJAIYE",
                "IPAPO",
                "KOMU",
                "OKAKA I",
                "OKAKA II",
                "OKE AMU",
                "OTU I",
                "OTU II",
                "OWODE/IPAPO",
            ],
            IWAJOWA: [
                "AGBAAKIN I",
                "AGBAAKIN II",
                "IWERE-ILE  I",
                "IWERE-ILE  II",
                "IWERE-ILE III",
                "IWERE-ILE IV",
                "SABI-GANA I",
                "SABI-GANA II",
                "SABI-GANA III",
                "SABI-GANA IV",
            ],
            KAJOLA: [
                "AYETORO-OKE",
                "ELERO",
                "GBELEKALE I&II",
                "IBA-OGAN",
                "IJO",
                "ILAJI-OKE/IWERE-OKE",
                "IMOBA/OKE-OGUN",
                "ISEMI-ILE/IMIA/ILUA",
                "ISIA",
                "KAJOLA",
                "OLELE",
            ],
            LAGELU: [
                "AYETE I",
                "AYETE II",
                "IGANGAN I",
                "IGANGAN II",
                "IGANGAN III",
                "IGANGAN IV",
                "OFIKI I",
                "OFIKI II",
                "OGUNJANA/OLOWODE/ OGBURO",
                "OYEDEJI/OLODE/KUTAYI",
                "SAGBE/PABIEKUN",
                "TAPA I",
                "TAPA II",
                "UNITED NATION PRY SCH. OGUNREMI",
            ],
            "OGBOMOSHO NIORTH": [
                "AAJE/ABOGUNDE",
                "ABOGUNDE",
                "AGUOJO/MASIFA",
                "ISALE AALASA",
                "ISALE AFON",
                "ISALE ORA/SAJA",
                "JAGUN",
                "OKE ELERIN",
                "OSUPA",
                "SABO/TARA",
            ],
            "OGBOMOSHO SOUTH": [
                "AKATA",
                "ALAPATA",
                "AROWOMOLE",
                "IBAPON",
                "IJERU I",
                "IJERU II",
                "ILOGBO",
                "ISOKO",
                "LAGBEDU",
                "OKE OLA/FARM SETTLEMENT",
            ],
            "OGO OLUWA": [
                "AJAAWA I",
                "AJAAWA II",
                "AYEDE",
                "AYETORO",
                "IDEWURE",
                "LAGBEDU",
                "MOWOLOWO/IWO-ATE",
                "ODO-OBA",
                "OPETE",
                "OTAMOKUN",
            ],
            OLORUNSOGO: [
                "ABOKE (ABOYUNOGUN)",
                "ELERUGBA/ELEHINKE/SAGBON (APERU)",
                "IKOLABA/OBADIMO",
                "ONIGBETI I (IYAMOPO)",
                "ONIGBETI II /SAGBON AGORO",
                "ONIGBETI III-IV (AGBENI)",
                "OPA/OGUNNIYI",
                "SERIKI I & ABOSIN (OKIN)",
                "SERIKI II (AGBELE)",
                "WARO /APATA-ALAJE",
            ],
            OLUYOLE: [
                "ABANLA/OLUNDE",
                "AYEGUN",
                "IDI-IROKO/IKEREKU",
                "IDI-OSAN/EGBEDATUBA",
                "MUSLIM/OGBERE",
                "ODO-ONA NLA",
                "OKANHINDE/LATUNDE",
                "OLOMI/OLURINDE",
                "ONIPE",
                "ORISUNBARE/OJO-EKUN",
            ],
            "ONA ARA": [
                "AKANRAN/OLORUNDA",
                "ARAROMI/APERIN",
                "BADEKU",
                "GBADA -EFON",
                "ODI-ODEYALE/ODI APERIN",
                "OGBERE",
                "OGBERE TIOYA",
                "OJOKU/AJIA",
                "OLODE/GBEDUN/OJEBODE",
                "OLORUNSOGO",
                "OREMEJI/AGUGU",
            ],
            OORELOPE: [
                "AARE",
                "ALEPATA",
                "BONNI",
                "IGBOPE/IYEYE I",
                "IGBOPE/IYEYE II",
                "IGI-ISUBU",
                "ONIBODE I",
                "ONIBODE II",
                "ONIBODE III",
                "ONIGBOHO/ALOMO/OKERE",
            ],
            ORIIRE: [
                "ORIIRE I",
                "ORIIRE II",
                "ORIIRE III",
                "ORIIRE IV",
                "ORIIRE IX",
                "ORIIRE V",
                "ORIIRE VI",
                "ORIIRE VII",
                "ORIIRE VIII",
                "ORIIRE X",
            ],
            "OYO EAST": [
                "AGBOYE/MOLETE",
                "AJAGBA",
                "ALAODI/ MODEKE",
                "APAARA",
                "APINNI",
                "BALOGUN",
                "JABATA",
                "OKE APO",
                "OLU AJO",
                "OWODE/ARAROMI",
            ],
            "OYO WEST": [
                "AJOKIDERU",
                "AKEETAN",
                "FASOLA",
                "ISEKE",
                "ISOKUN I",
                "ISOKUN II",
                "IYAJI",
                "OPAPA",
                "OWODE",
                "PAKOYI / IDODE",
            ],
            "SAKI EAST": [
                "AGBONLE",
                "AGO AMODU I",
                "AGO AMODU II",
                "OGBOORO I",
                "OGBOORO II",
                "OJE OWODE I",
                "OJE OWODE II",
                "SEPETERI I",
                "SEPETERI II",
                "SEPETERI III",
                "SEPETERI IV",
            ],
            "SAKI WEST": [
                "AGANMU/KOOKO",
                "AJEGUNLE",
                "BAGII",
                "EKOOKAN/ IMUA",
                "IYA",
                "OGIDIGBO /KINNIKINNI",
                "OKE ORO",
                "OKERE I",
                "OKERE II",
                "SANGOTE/BOODA/BAABO/ ILUA",
                "SEPETERI/BAPON",
            ],
            SURULERE: [
                "AROLU",
                "BAYAOJE",
                "IGBON/GAMBARI",
                "ILAJUE",
                "IREGBA",
                "IRESAADU",
                "IRESAAPA",
                "IWOFIN",
                "MAYIN",
                "OKO",
            ],
        },
    },
    {
        code: "PL",
        name: "PLATEAU",
        lgas: [
            "BARKINLADI",
            "BASSA",
            "BOKKOS",
            "JOS EAST",
            "JOS NORTH",
            "JOS SOUTH",
            "KANAM",
            "KANKE",
            "LANTANG NORTH",
            "LANTANG SOUTH",
            "MANGU",
            "MIKANG",
            "PANKSHIN",
            "QUAANPAN",
            "RIYON",
            "SHENDAM",
            "WASE",
        ],
        subs: {
            BARKINLADI: [
                "BARKIN LADI",
                "GASSA/SHO",
                "GINDIN AKWATI",
                "HEIPANG",
                "KAPWIS",
                "KURA FALLS",
                "LOBRING",
                "MARIT/MAZAT",
                "RAFAN",
                "TAFAN",
                "ZABOT",
            ],
            BASSA: [
                "BUHIT",
                "BUJI",
                "GABIA",
                "GURUM",
                "JENGRE",
                "KADAMO",
                "KAKKEK",
                "KASURU",
                "KIMAKPA",
                "KISHIKA",
                "MAFARA",
                "RIMI",
                "TA'AGBE",
                "TAHU",
                "ZABOLO",
                "ZOBWO",
            ],
            BOKKOS: [
                "BOKKOS",
                "BUTURA",
                "DAFFO",
                "KAMWAI",
                "KWATAS",
                "MANGOR",
                "MANGUNA",
                "MBAR/MANGAR",
                "MUSHERE CENTRAL",
                "MUSHERE WEST",
                "RICHA",
                "SHA",
                "TANGUR",
                "TOFF",
            ],
            "JOS EAST": [
                "FEDERE",
                "FOBUR ( A )",
                "FOBUR ( B )",
                "FURSUM",
                "JARAWAN KOGI",
                "MAI GEMU",
                "MAI JUJU",
                "SHERE EAST",
                "SHERE WEST",
                "ZANDI",
            ],
            "JOS NORTH": [
                "ABBA NA SHEHU",
                "ALI KAZAURE",
                "GANGARE",
                "GARBA DAHO",
                "IBRAHIM KATSINA",
                "JENTA ADAMU",
                "JENTA APATA",
                "JOS JARAWA",
                "NARAGUTA 'A'",
                "NARAGUTA 'B'",
                "SARKIN ARAB",
                "TAFAWA BALEWA",
                "TUDUN WADA KABONG",
                "VANDERPUYE",
            ],
            "JOS SOUTH": [
                "BUKURU",
                "DU",
                "GIRING",
                "GYEL 'A'",
                "GYEL 'B'",
                "KURU 'A'",
                "KURU 'B'",
                "SHEN",
                "TURU",
                "VWANG",
                "ZAWAN 'A",
                "ZAWAN 'B'",
            ],
            KANAM: [
                "BIRBYANG",
                "DENGI",
                "DUGUB",
                "GAGDI",
                "GARGA",
                "GUMSHER",
                "GWAMLAR",
                "JARMAI",
                "JOM",
                "KANAM",
                "KANTANA",
                "KUNKYAM",
                "MUNBUTBO",
                "NAMARAN",
            ],
            KANKE: [
                "AMPANG EAST",
                "AMPER CHIKA 'A'",
                "AMPER CHIKA 'B'",
                "AMPER SERI",
                "DAWAKI",
                "GARRAM",
                "KABWIR GYANGYANG",
                "KABWIR PADA",
                "LANGSHI",
                "NEMEL",
            ],
            "LANTANG NORTH": [
                "FUNYALANG",
                "JAT",
                "KELLER",
                "KUFFEN",
                "KWALLAk",
                "KWANPE",
                "LIPCHOK",
                "MBAN/ZAMKO”",
                "NYER",
                "PAJAT",
                "PILGANI",
                "PISHE/YASHI",
                "REAK",
                "WAROH”",
            ],
            "LANTANG SOUTH": [
                "DADIN KOWA",
                "FAJUL",
                "GAMAKAI",
                "LASHEL",
                "MABUDI",
                "MAGAMA",
                "SABON GIDA",
                "TALGWANG",
                "TIMBOL",
                "TURAKI",
            ],
            MANGU: [
                "AMPANG WEST",
                "CHANSO",
                "GINDIRI I",
                "GINDIRI II",
                "JANNARET",
                "JIPAL/CHAKFEM",
                "KADUNU",
                "KERANG",
                "KOMBUN",
                "LANGAI",
                "MANGU HALLE",
                "MANGU I",
                "MANGU II",
                "MANGUN",
                "PANYAM",
                "PUSHIT",
            ],
            MIKANG: [
                "BALTEP",
                "GARKAWA CENTRAL",
                "GARKAWA NORTH",
                "GARKAWA NORTH/EAST",
                "KOENOEM 'A'",
                "KOENOEM 'B'",
                "LALIN",
                "PIAPUNG 'A'",
                "PIAPUNG 'B'",
                "TUNKUS",
            ],
            PANKSHIN: [
                "BELNING",
                "CHIGWONG",
                "CHIP",
                "DOK-PAI",
                "FIER",
                "JIBLIK",
                "KADUNG",
                "KANGSHU",
                "LANKAN",
                "PANKSHIN CENTRAL",
                "TAL",
                "WOKKOS",
            ],
            QUAANPAN: [
                "BWALL",
                "DOEMAK GOECHIM",
                "DOEMAK KOPLONG",
                "DOKAN KASUWA",
                "KURGWI",
                "KWA",
                "KWALLA MOEDA",
                "KWALLA YILA'AR",
                "KWANDE",
                "KWANG",
                "NAMU",
            ],
            RIYON: [
                "ATTAKAR",
                "BUM",
                "DANTO",
                "JOL/KWI",
                "RAHOSS",
                "RIM",
                "RIYOM",
                "SARUBUTU",
                "SOPP",
                "TAHOSS",
            ],
            SHENDAM: [
                "DERTENG",
                "KALONG",
                "KURUNGBOU A",
                "KURUNGBOU B",
                "MOEKAT",
                "PANKSHOM",
                "POESHIP",
                "SHENDAM A",
                "SHENDAM B",
                "SHIMANKAR",
                "YELWA",
            ],
            WASE: [
                "BASHAR",
                "DANBIRAM",
                "GUDUS",
                "KADARKO",
                "KUMBONG",
                "KUMBUR",
                "KUYAMBANA",
                "MAVO",
                "NYALUM/ KAMPANI",
                "SALUWE",
                "WASE TOFA",
                "YOLA WAKAT",
            ],
        },
    },
    {
        code: "RI",
        name: "RIVERS",
        lgas: [
            "ABUA/ODUAL",
            "AHOADA EAST",
            "AHOADA WEST",
            "AKUKU TORU",
            "ANDONI",
            "ASARI TORU",
            "BONNY",
            "DEGEMA",
            "ELEME",
            "EMOHUA",
            "ETCHE",
            "GOKANA",
            "IKWERRE",
            "KHANA",
            "OBIO AKPOR",
            "OGBA EGBEMA NDONI",
            "OGU BOLO",
            "OKIRIKA",
            "OMUMA",
            "OPOBO NKORO",
            "OYIGBO",
            "PORT HARCOURT",
            "TAI",
        ],
        subs: {
            "ABUA/ODUAL": [
                "ABUA I",
                "ABUA II",
                "ABUA III",
                "ABUA IV",
                "ADADA",
                "AKANI",
                "ANYU",
                "EMAGO-KUGBO",
                "EMELEGO",
                "EMUGHAM I",
                "EMUGHAM II",
                "OKPEDEN",
                "OTAPHA",
            ],
            "AHOADA EAST": [
                "AHOADA I",
                "AHOADA II",
                "AHOADA III",
                "AHOADA IV",
                "AKOH I",
                "AKOH II",
                "AKOH III",
                "UPPATA I",
                "UPPATA II",
                "UPPATA III",
                "UPPATA IV",
                "UPPATA V",
                "UPPATA VI",
            ],
            "AHOADA WEST": [
                "EDIRO I",
                "EDIRO II",
                "IGBUDUYA I",
                "IGBUDUYA II",
                "IGBUDUYA III",
                "IGBUDUYA IV",
                "JOINKRAMA",
                "OKARKI",
                "UBIE I",
                "UBIE II",
                "UBIE III",
                "UBIE IV",
            ],
            "AKUKU TORU": [
                "ALISE GROUP",
                "BRIGGS I",
                "BRIGGS II",
                "BRIGGS III",
                "EMMANUEL I",
                "EMMANUEL II",
                "EMMANUEL III",
                "GEORGEWILL I",
                "GEORGEWILL II",
                "GEORGEWILL III",
                "JACK I",
                "JACK II",
                "JACK III",
                "KULA I",
                "KULA II",
                "NORTH/SOUTH GROUP",
                "OBONMA",
            ],
            ANDONI: [
                "AGWUT OBOLO",
                "ASARAMA",
                "ATABA I",
                "EKEDE",
                "IKURU TOWN",
                "NGO",
                "SAMANGA",
                "UNYEADA I",
                "UNYEADA II",
                "UNYENGALA",
            ],
            "ASARI TORU": [
                "BUGUMA EAST I",
                "BUGUMA EAST II",
                "BUGUMA EAST WEST",
                "BUGUMA NORTH EAST",
                "BUGUMA NORTH WEST I",
                "BUGUMA NORTH WEST II",
                "BUGUMA SOUTH",
                "BUGUMA SOUTH EAST",
                "BUGUMA SOUTH WEST",
                "BUGUMA WEST",
                "ISIA GROUP I",
                "ISIA GROUP II",
                "WEST CENTRAL GROUP",
            ],
            BONNY: [
                "ABALAMABIE",
                "COURT/ADA ALLISON",
                "DAN JUMBO/BERESIRI",
                "DEMA ABBEY",
                "FINIMA",
                "KALAIBIMA",
                "NANABIE",
                "NEW LAYOUT",
                "OLOMA/AYAMINIMA",
                "ORO-IGWE",
                "OROSIRIRI",
                "PETERSIDE",
            ],
            DEGEMA: [
                "BAKANA I",
                "BAKANA II",
                "BAKANA III",
                "BAKANA IV",
                "BAKANA V",
                "BAKANA VI",
                "BILLE",
                "BUKUMA",
                "DEGEMA I",
                "DEGEMA II",
                "DEGEMA III",
                "KE/OLD BAKANA",
                "OBUAMA",
                "TOMBIA I",
                "TOMBIA II",
                "TOMBIA III",
                "TOMBIA IV",
            ],
            ELEME: [
                "AGBONCHIA",
                "AKPAJO",
                "ALESA",
                "ALETO",
                "ALODE",
                "EBUBU",
                "EKPORO",
                "ETEO",
                "OGALE",
                "ONNE",
            ],
            EMOHUA: [
                "EGBEDA",
                "ELELE - ALIMINI",
                "EMOHUA I",
                "EMOHUA II",
                "IBAA",
                "OBELLE",
                "ODEGU I",
                "ODEGU II",
                "OGBAKIRI I",
                "OGBAKIRI II",
                "OMUDIOGA/AKPAABU/ITU",
                "RUMUEKPE",
                "RUNDELE",
                "UBIMINI",
            ],
            ETCHE: [
                "AFARA",
                "AKPOKU/UMUOYE OKEHI",
                "AKWA/ODAGWA",
                "EGBU",
                "EGWI/ OPIRO",
                "IGBO I",
                "IGBO II",
                "IGBO III",
                "IGBODO",
                "MBA",
                "NDASHI",
                "NIHI",
                "OBIBI/AKWUKABI",
                "OBITE",
                "ODUFOR",
                "OKEHI",
                "ORWU",
                "OZUZU",
                "ULAKWO",
            ],
            GOKANA: [
                "B-DERE",
                "BERA",
                "BIARA  II",
                "BIARA I",
                "BODO I",
                "BODO II",
                "BODO III",
                "BOMU I",
                "BOMU II",
                "DEEYOR/DERKEN/NWEBIARA",
                "K-DERE I",
                "K-DERE II",
                "KPOR/LEWE/GBE",
                "MOGHO",
                "NWEOL/GIOKO/BARAKO",
                "YEGHE I",
                "YEGHE II",
            ],
            IKWERRE: [
                "ALUU",
                "APANI",
                "ELELE  I",
                "ELELE  II",
                "IGWURUTA",
                "ISIOKPO  I",
                "ISIOKPO  II",
                "OBIMA",
                "OMAGWU",
                "OMEDEMI/IPO",
                "OMERELU",
                "OZUAHA",
                "UMUANWA",
            ],
            KHANA: [
                "BAEN/KPEAN/ DUBORO",
                "BANE",
                "BANGHA",
                "BEERI",
                "BORI",
                "BOUE",
                "GWARA/KAA/ EEKEN",
                "KAANI",
                "KON/ KWAWA",
                "LORRE/LUEBE/ KPAA",
                "LUEKU/ NYOKURU",
                "OKWALE",
                "OPUOKO/ KALAOKO",
                "SII/BETEM/ KANNI BABBE",
                "SOGHO",
                "TAABAA",
                "UEGWERE",
                "WIIYAKARA",
                "ZAAKPON",
            ],
            "OBIO AKPOR": [
                "CHOBA",
                "ELELENWO",
                "ORO-IGWE",
                "OZUOBA/OGBOGORO",
                "RUKPOKWU",
                "RUMUEME (7A)",
                "RUMUEME (7B)",
                "RUMUEME (7C)",
                "RUMUIGBO",
                "RUMUODARA",
                "RUMUODOMAYA",
                "RUMUOKORO",
                "RUMUOKWU",
                "RUMUOKWUTA",
                "RUMUOLUMENI",
                "RUMUOMASI",
                "WOJI",
            ],
            "OGBA EGBEMA NDONI": [
                "EGBEMA I",
                "EGBEMA II",
                "EGI",
                "EGI II",
                "EGI III",
                "IGBURU",
                "KREGANI",
                "NDONI I",
                "NDONI II",
                "NDONI III",
                "OBRIKOM",
                "OMOKU",
                "OMOKU I (OBOSI)",
                "OMOKU II (OBAKATA)",
                "OMOKU III (OBOSI)",
                "OMOKU IV (OBAKATA)",
            ],
            "OGU BOLO": [
                "BOLO I",
                "BOLO II",
                "BOLO III",
                "BOLO IV",
                "ELE",
                "OGU I",
                "OGU II",
                "OGU III",
                "OGU IV",
                "OGU V",
                "OGU VI",
                "WAKAMA",
            ],
            OKIRIKA: [
                "KALIO",
                "OGAN",
                "OGOLOMA I",
                "OGOLOMA II",
                "OGOLOMA III",
                "OKRIKA",
                "OKRIKA I",
                "OKRIKA II",
                "OKRIKA III",
                "OKRIKA IV",
                "OKRIKA V",
            ],
            OMUMA: [
                "ARIRANIIRI/OWU-AHIA COMMUNITY",
                "EBERI-DIKEOMUUO COMMUNITY",
                "OBIBI/AJULOKE COMMUNITY",
                "OBIOHIA COMMUNITY",
                "OFEH COMMUNITY",
                "OHIMOGHO COMMUNITY",
                "OYORO",
                "UMUAJULOKE COMMUNITY",
                "UMUOGBA I COMMUNITY",
                "UMUOGBA II COMMUNITY",
            ],
            "OPOBO NKORO": [
                "DAPPAYE AMA-KIRI I",
                "DAPPAYE AMA-KIRI II",
                "DIEPIRI",
                "JAJA",
                "KALAIBIAMA I",
                "KALAIBIAMA II",
                "NKORO I",
                "NKORO II",
                "NKORO III",
                "QUEEN'S TOWN, KAIAMA",
                "UKONU",
            ],
            OYIGBO: [
                "WARD 1",
                "WARD 10",
                "WARD 2",
                "WARD 3",
                "WARD 4",
                "WARD 5",
                "WARD 6",
                "WARD 7",
                "WARD 8",
                "WARD 9",
            ],
            "PORT HARCOURT": [
                "ABULOMA/AMADI-AMA",
                "DIOBU",
                "ELEKAHIA",
                "MGBUNDUKWU (ONE)",
                "MGBUNDUKWU (TWO)",
                "NKPOLU OROWORUKWO",
                "OCHIRI/RUMUOKALAGBOR",
                "OGBUM-NU-ABALI",
                "OROABALI",
                "OROGBUM",
                "OROMINEKE/EZIMGBU",
                "OROWORUKWO",
                "PORT HARCOURT TOWNSHIP VI",
                "PORT HARCOURT TOWNSHIP VII",
                "PORT HARCOURT TOWNSHIP V",
                "RUMUOIBEKWE",
                "RUMUWOJI (ONE)",
                "RUMUWOJI (THREE)",
                "RUMUWOJI (TWO)",
            ],
            TAI: [
                "BAN-OGOI",
                "BOTEM/GBENEO",
                "BUBU/BARA/KANI",
                "GIO/KPORGHOR/GBAM",
                "KIRA/BOROBARA",
                "KOROKORO",
                "KOROMA/HORO",
                "KPITE",
                "NNWA",
                "OYIGBO WEST",
            ],
        },
    },
    {
        code: "SO",
        name: "SOKOTO",
        lgas: [
            "BINJI",
            "BODINGA",
            "DANGE SHUNNI",
            "GADA",
            "GORONYO",
            "GUDU",
            "GWADABAWA",
            "ILLELA",
            "ISA",
            "KEBBE",
            "KWARE",
            "RABAH",
            "SABON BIRNI",
            "SHAGARI",
            "SILAME",
            "SOKOTO NORTH",
            "SOKOTO SOUTH",
            "TAMBUWAL",
            "TANGAZA",
            "TURETA",
            "WAMAKKO",
            "WURNO",
            "YABO",
        ],
        subs: {
            BINJI: [
                "BINJI",
                "BUNKARI",
                "GAWAZZAI",
                "INNAME",
                "JAMALI",
                "MAIKULKI",
                "SAMAMA",
                "SORON GABAS",
                "SORON YAMMA",
                "TUDUN KOSE",
            ],
            BODINGA: [
                "BADAU/DARHELA",
                "BAGARAWA",
                "BANGI/ DABAGA",
                "BODIGA/TAUMA",
                "DANCHADI",
                "DINAYADI/BADAWA",
                "KWACCIYAR LALLE",
                "MAZAN GARI/ KAURAN MIYO",
                "SIFAWA/LUKUYAWA",
                "TAKATUKU/MADORAWA",
                "TUUWA/KULLAFASA",
            ],
            "DANGE SHUNNI": [
                "BODAI/JURGA",
                "DANGE",
                "FAJALDU",
                "GIERE/GAJARA",
                "RIKINA",
                "RUDU/AMANAWA",
                "RUGAR GIDADO",
                "SHUNI",
                "TSAFANADE",
                "TUNTUBE/TSEHE",
                "WABABE/SALALU",
            ],
            GADA: [
                "DUKAMAJE/ILLAH",
                "GADA",
                "GILBADI",
                "KADASSAKA",
                "KADDI",
                "KADDI/BUDA",
                "KAFFE",
                "KIRI",
                "KWARMA",
                "KYADAWA/HOLAI",
                "TSITSE",
            ],
            GORONYO: [
                "BIRJINGO",
                "BOYEKAI",
                "GIYAWA",
                "GORONYO",
                "KAGARA",
                "KOJIYO",
                "KWAKWAZO",
                "RIMAWA",
                "SABON G/DOLEDAN/TASAKKO",
                "SHINAKA",
                "TAKAKUME",
            ],
            GUDU: [
                "AWULKITI",
                "BACHAKA",
                "BALLE",
                "CHILAS MAKUYA",
                "GWAZANGE BOTO",
                "KARFEN CHANA",
                "KARFEN SARKI",
                "KURDULA",
                "MARAKEN BORI",
                "TULLUN DOYA",
            ],
            GWADABAWA: [
                "ASARA AREWA",
                "ASARA KUDU",
                "ATAKWANYO",
                "CHIMOLA AEWA",
                "CHIMOLA KUDU",
                "GIDAN KAYA",
                "GIGANE",
                "GWADABAWA",
                "HUCHI",
                "MANMANDE",
                "SALAME",
            ],
            ILLELA: [
                "ARABA",
                "DAMBA",
                "DARNA SABON GARI",
                "DARNA TSOLAWO",
                "G/KATTA",
                "GARU",
                "GIDAN HAMMA",
                "ILLELA",
                "KALMALO",
                "RUNGUMAWAR GATTI",
                "TOZAI",
            ],
            ISA: [
                "BARGAJA",
                "GEBE A",
                "GEBE B",
                "ISA NORTH",
                "ISA SOUTH",
                "TIDIBALE",
                "TOZAI",
                "TSABREN S DARAI",
                "TURBA",
                "YARFAKO",
            ],
            KEBBE: [
                "FAKKU",
                "GIRKAU",
                "KEBBE EAST",
                "KEBBE WEST",
                "KUCHI",
                "MARGAI A",
                "MARGAI B",
                "NASAGUDU",
                "SANGI",
                "UNGUSHI",
            ],
            KWARE: [
                "BANKANU",
                "BASANSAN",
                "DURBAWA",
                "G. RUGGA",
                "G.MODIBBO/ G. AKWARA",
                "HAMMA'ALI",
                "KABANGA",
                "KWARE",
                "S/BIRNI G. KARMA",
                "TUNGA MALLAMAWA",
            ],
            RABAH: [
                "GANDI A",
                "GANDI B",
                "GAWAKUKE TOFA",
                "GWADDODI",
                "KURYA",
                "RABAH",
                "RARA",
                "RIJI MAIKUJERA",
                "TSAMIYA",
                "TURSA",
                "YARTSAKUWA",
            ],
            "SABON BIRNI": [
                "GANGARA",
                "GATAWA",
                "KALGO",
                "KURAWA",
                "LAJINGE",
                "MAKUWANA",
                "S/BIRNI EAST",
                "S/BIRNI WEST",
                "TARA",
                "TSAMAYE",
                "UNGUWAR LALLE",
            ],
            SHAGARI: [
                "DANDIN MAHE",
                "GAMGAM",
                "HORO BIRNI",
                "JAREDI",
                "KAJIJI",
                "KAMBAMA",
                "LAMBARA",
                "MANDERA",
                "SANYINNAWAL",
                "SHAGARI",
            ],
            SILAME: [
                "GANDE EAST",
                "GANDE WEST",
                "KATAMI NORTH",
                "KATAMI SOUTH",
                "KUBODU NORTH",
                "KUBODU SOUTH",
                "LABANI",
                "MARAFA EAST",
                "MARAFA WEST",
                "SILAME",
            ],
            "SOKOTO NORTH": [
                "M/RAFI ‘A’",
                "M/RAFI ‘B’",
                "MAGAJIN GARI ‘A’",
                "MAGAJIN GARI ‘B’",
                "S/ADAR GANDU",
                "S/ADARG/IGWAI",
                "S/MUSULMI ‘A’",
                "S/MUSULMI ‘B’",
                "WAZIRI ‘A’",
                "WAZIRI ‘B’",
                "WAZIRI ‘C’",
            ],
            "SOKOTO SOUTH": [
                "GAGI 'A'",
                "GAGI 'B'",
                "GAGI 'C'",
                "RIJIYAR DOROWA 'A'",
                "RIJIYAR DOROWA 'B'",
                "SARKIN ADAR KOFAR ATIKU",
                "SARKIN ADAR KWANNI",
                "SARKIN ZANFARA 'A'",
                "SARKIN ZANFARA'B'",
                "TUDUN WADA 'A'",
                "TUDUN WADA'B'",
            ],
            TAMBUWAL: [
                "BAGIDA LUKINGO",
                "BAKAYA SABON BIRNI",
                "BARKEJI NABAGUDA",
                "BASHIRE MAIKADA",
                "DOGONDAJI SALA",
                "FAGA ALASAN",
                "JABO KAGARA",
                "ROMON/SARKI",
                "SAIDA GOSHE",
                "SANYINNA",
                "TAMBUWAL SHINFIRI",
            ],
            TANGAZA: [
                "GIDAN MADI",
                "KALANJENI",
                "KWACCEJURU",
                "MAGONHO",
                "RAKA",
                "RUWA WURI",
                "SAKKWAI",
                "SALEWA",
                "SUTTI",
                "TANGAZA",
            ],
            TURETA: [
                "BARAYAR GIWA",
                "BIMASA G/KARE",
                "DUMA",
                "FURA GIRKE",
                "KURUWA",
                "KWARARE",
                "LAMBA TURETA",
                "LOFA",
                "TSAMIYA",
                "TURETA GARI",
            ],
            WAMAKKO: [
                "ARKILLA",
                "BADO/KASARAWA",
                "DUNDAYE/GUMBURAWA",
                "GIDAN BUBU/GIDAN YARO",
                "GIDAN HAMIDU/G.KAYA",
                "GUMBI WAJEKERE",
                "GWAMATSE",
                "KALAMBAINA/GIRABSHI",
                "KAMMATA",
                "KAURAR KIMBA GEDAWA",
                "WAMAKKO",
            ],
            WURNO: [
                "ACHIDA",
                "ALKAMMU/GYALGYAL",
                "CHACHO/MARNNA",
                "DANKEMU",
                "DIMBISO",
                "DINAWA",
                "KWARGABA",
                "KWASARE/SISAWA",
                "LAHODU/GIDAN BANGO",
                "MAGARYA",
                "MARAFA",
            ],
            YABO: [
                "__",
                "B/RUWA",
                "BENGAJE",
                "BINJI",
                "FAKKA",
                "KILGORI",
                "RUGGAR IYA",
                "TORANKAWA",
                "YABO 'A'",
                "YABO 'B'",
            ],
        },
    },
    {
        code: "TA",
        name: "TARABA",
        lgas: [
            "ARDO KOLA",
            "BALI",
            "DONGA",
            "GASHAKA",
            "GASSOL",
            "IBI",
            "JALINGO",
            "KARIM LAMIDO",
            "KURMI",
            "LAU",
            "SARDAUNA",
            "TAKUM",
            "USSA",
            "WUKARI",
            "YORRO",
            "ZING",
        ],
        subs: {
            "ARDO KOLA": [
                "ALIM GORA",
                "ARDO KOLA",
                "IWARE",
                "JAURO YUNU",
                "LAMIDO BORNO",
                "MAYO RENEWO",
                "SARKIN DUTSE",
                "SUNKANI",
                "TAU",
                "ZANGON KOMBI",
            ],
            BALI: [
                "BADAKOSHI",
                "BALI ' A'",
                "BALI 'B'",
                "GANG DOLE",
                "GANG MATA",
                "GANGLARI",
                "GANGTIBA",
                "KAIGAMA",
                "MAIHULA",
                "SUNTAI",
                "TAKALAFIYA",
            ],
            DONGA: [
                "AKATE",
                "ASIBITI",
                "BIKADARKO",
                "FADA",
                "GAYAMA",
                "GINDIN DUTSE",
                "GYATTA AURE",
                "MARARABA",
                "NYITA",
                "SUNTAI",
            ],
            GASHAKA: [
                "GALUMJINA",
                "GANGUMI",
                "GARBABI",
                "GASHAKA",
                "GAYAM",
                "JAMTARI",
                "MAI-IDANU",
                "MAYO SELBE",
                "SERTI 'A'",
                "SERTI 'B'",
            ],
            GASSOL: [
                "GASSOL",
                "GUNDUMA",
                "MUTUM BIYU I",
                "MUTUM BIYU II",
                "NAM NAI",
                "SABON GIDA",
                "SARKIN SHIRA",
                "SENDIRDE",
                "TUTARE",
                "WUROJAM",
                "WURYO",
                "YARIMA",
            ],
            IBI: [
                "DAMPAR I",
                "DAMPAR II",
                "DAMPAR III",
                "NWONYO I",
                "NWONYO II",
                "RIMI UKU I",
                "RIMI UKU II",
                "SARKIN KUDU I",
                "SARKIN KUDU II",
                "SARKIN KUDU III",
            ],
            JALINGO: [
                "ABBARE YELWA",
                "BARADE",
                "KACHALLA SEMBE",
                "KONA",
                "MAJIDADI",
                "MAYO-GWOI",
                "SARKIN DAWAKI",
                "SINTALI",
                "TURAKI 'A'",
                "TURAKI 'B'",
            ],
            "KARIM LAMIDO": [
                "AMAR",
                "ANDAMIN",
                "BACHAMA",
                "BIKWIN",
                "DAROFAI",
                "DIDANGO",
                "JEN ARDIDO",
                "JEN KAIGAMA",
                "KARIM A",
                "KARIM B",
                "KWANCHI",
            ],
            KURMI: [
                "ABONG",
                "AKWENTO/BOKO",
                "ASHUKU/ENEME",
                "BAISSA",
                "BENTE/GALEA",
                "BISSAULA",
                "DIDAN",
                "NDAFORO/GENDA",
                "NJUWANDE",
                "NYIDO/TOSSO",
            ],
            LAU: [
                "ABBARE I",
                "ABBARE II",
                "DONADDA",
                "GARIN MAGAJI",
                "GARIN-DOGO",
                "JIMLARI",
                "KUNINI",
                "LAU I",
                "LAU II",
                "MAYO LOPE",
            ],
            SARDAUNA: [
                "GEMBU A",
                "GEMBU B",
                "KABRI",
                "KAKARA",
                "MAGU",
                "MAYO-NDAGA",
                "MBAMNGA",
                "NDUMI-YAJI",
                "NGUROJE",
                "TITONG",
                "WARWAR",
            ],
            TAKUM: [
                "BETE",
                "BIKASHIMBILA",
                "CHACHANJI",
                "DUTSE",
                "FETE",
                "GAHWETON",
                "MANYA",
                "ROGO",
                "SHIBONG",
                "TIKARI",
                "YUKUBEN",
            ],
            USSA: [
                "BIKA",
                "FIKYU",
                "JENUWA GIDA",
                "KPAMBO",
                "KPAMBO PURI",
                "KWAMBAI",
                "KWESATI",
                "LISSAM I",
                "LISSAM II",
                "LUMBU",
                "RUFU",
            ],
            WUKARI: [
                "AKWANA",
                "AVYI",
                "BANTAJE",
                "CHUNKU",
                "HOSPITAL",
                "JIBU",
                "KENTE",
                "PUJE",
                "RAFIN KADA",
                "TSOKUNBI",
            ],
            YORRO: [
                "BIKASSA I",
                "BIKASSA II",
                "NYAJA I",
                "NYAJA II",
                "PANTISAWA I",
                "PANTISAWA II",
                "PUPULE I",
                "PUPULE II",
                "PUPULE III",
                "SUMBU I",
                "SUMBU II",
            ],
            ZING: [
                "BITAKO",
                "BUBONG",
                "DINDING",
                "LAMMA",
                "MONKIN 'A'",
                "MONKIN 'B'",
                "YAKOKO",
                "ZING (AI)",
                "ZING (AII)",
                "ZING B",
            ],
        },
    },
    {
        code: "YO",
        name: "YOBE",
        lgas: [
            "BADE",
            "BURSARI",
            "DAMATURU",
            "FIKA",
            "FUNE",
            "GEIDAM",
            "GUJBA",
            "GULANI",
            "JAKUSKO",
            "KARASUWA",
            "MACHINA",
            "NANGERE",
            "NGURU",
            "POTISKUM",
            "TARMUWA",
            "YUNUSARI",
            "YUSUFARI",
        ],
        subs: {
            BADE: [
                "DAGONA",
                "GWIO KURA",
                "KATUZU",
                "LAWAN AUDU/LAWAN ALWALI",
                "LAWAN FANNAMI",
                "LAWAN MUSA",
                "SARKIN HAUSAWA",
                "SUGUM/TAGALI",
                "USUR DAWAYO",
                "ZANGO",
            ],
            BURSARI: [
                "BAYAMARI",
                "DAMNAWA/JULURI",
                "DANANI",
                "DAPCHI",
                "GARUN DOLE/GARIN ALKALI",
                "GUBA/DAPSO",
                "GUJI METALARI",
                "KALIYARI",
                "KURNAWA",
                "MASABA",
            ],
            DAMATURU: [
                "BINDIGARI/FAWARI",
                "DAMAKASU",
                "DAMATURU CENTRAL",
                "GAMBIR/MADURI",
                "KALALLAWA/GABAI",
                "KUKARETA/WARSALA",
                "MAISANDARI/W. IBRAHIM",
                "MURFA KALAM",
                "NAYINAWA",
                "NJIWAJI/GWANGE",
                "SASAWA/KABARU",
            ],
            FIKA: [
                "DAYA/CHANA",
                "FIKA/ANZE",
                "GAKADAISHEMBIRE",
                "GUDI/DOZI/GODOWOLI",
                "JANGA/BOZA",
                "MUBI/FUSAMI",
                "NGALDA/DUMBULWA",
                "SHOYE/GARINABA",
                "TURMI/MALURI",
                "ZANGAYA/MAZAWUN",
            ],
            FUNE: [
                "ABAKIRE",
                "ALAGARN",
                "BORN KIJI",
                "DAMAGUM",
                "DAURA",
                "DOGON KUKA",
                "FUNE/NGELZARMA",
                "GABA TASHA",
                "GUDUGURKA",
                "JAJERE",
                "KAYERI",
                "KOLLERE",
                "MASHIO",
            ],
            GEIDAM: [
                "ASHEIKRI",
                "BALLE/GALLABA/MELERI",
                "DAMAKARWA/KUSUR",
                "DEJINA/FUKURTI",
                "FUTCHUMIRAN",
                "GUMSA",
                "HAUSARI",
                "KAWURI",
                "MAANA/DAGAMBI",
                "SHAME KURA/DILAWA",
                "ZURGU NGILIWA/BORKO",
            ],
            GUJBA: [
                "BUNI GARI/LAWANTI",
                "BUNI YADI NORTH AND SOUTH",
                "DADINGEL",
                "GONIRI",
                "GOTALA/GOTUMBA",
                "GUJBA",
                "MANDUNARI",
                "MUTAI",
                "NGURBUWA",
                "WAGIR",
            ],
            GULANI: [
                "BARA",
                "BORN KIJI TETTEBA",
                "BULARAFA",
                "BUMSA",
                "DOKSHI",
                "GABAI",
                "GAGURE",
                "GARIN TUWO",
                "GULANI",
                "KUSHIMAGA",
                "NJIBILWA",
                "RUHU",
            ],
            JAKUSKO: [
                "BUDUWA/SAMINAKA",
                "DUMBARI",
                "GIDGID/BAYAM",
                "GOGARAM",
                "JABA",
                "JAKUSKO",
                "JAWUR/KATAMA",
                "LAFIYA LOILOI",
                "MUGURAM",
                "ZABUDUM DACHIA",
            ],
            KARASUWA: [
                "BUKARTI",
                "FAJIGANARI",
                "GARIN GAWO",
                "GASMA",
                "JAJIMAJI",
                "KARASUWA GALU",
                "KARASUWA GARU GUNA",
                "WACHAKAL",
                "WARO",
                "YAJERI",
            ],
            MACHINA: [
                "BOGO",
                "DAMAI",
                "DONE",
                "FALIMARAM",
                "KOM KOMMA",
                "KUKA YASKU",
                "LAMISU",
                "MACHINA",
                "MASKAWIDARE",
                "TAGANAMA",
            ],
            NANGERE: [
                "CHILLARIYE",
                "DADISO/CHIKURIWA",
                "DAWASA/G.BABA",
                "DAZIGAU",
                "DEGUBI",
                "KUKURI/CHIROMARI",
                "LANGAWA/DARIN",
                "NANGERE",
                "PAKARAU",
                "TIKAU",
                "WATINANI",
            ],
            NGURU: [
                "BULABULIN",
                "BULANGUWA",
                "DABULE",
                "DUMSAI",
                "GARBI/BOMBORI",
                "HAUSARI",
                "KANURI",
                "MAJAKURA",
                "MIRWA/KABIR SAGIR",
                "NGILEWA",
            ],
            POTISKUM: [
                "ARIKIME PRI. SCH.",
                "ARMY BARRACKS PRI. SCH.",
                "DAMBOA PRI. SCH.",
                "DANCHIWA PRI. SCH",
                "DORAWA PRI. SCH.",
                "FIKA GSS",
                "KARA PRI. SCH.",
                "KWATA PRI. SCH.",
                "MAMUDO PRI. SCH.",
                "NGOJIN PRI. SCH.",
            ],
            TARMUWA: [
                "BABBANGIDA",
                "BARKAMI/BULTURI",
                "BIRIRI/CHIROKUSKO",
                "JUMBAM",
                "KOKA/SUGUL",
                "KORIYEL",
                "LANTEWA",
                "MAFA",
                "MANDADAWA",
                "SHEKAU",
            ],
            YUNUSARI: [
                "BULTUWA MAR YARO",
                "DARA TOSHIA",
                "DEGELTURA NGAMAZAI",
                "DEKWA",
                "DILALA KALGI",
                "MAIRARI",
                "MOZOGUN KUJARI",
                "NGIRABO",
                "SWADI KAFIYA",
                "ZAJIBIRIRI DUMBOL",
            ],
            YUSUFARI: [
                "ALANJIRORI",
                "GUMSHI",
                "GUYA",
                "JEBUWA",
                "KAJIMARAM/SUMBAR",
                "KASKA/TULO-TULO",
                "KUMAGANNAM",
                "MAIMALARI",
                "MAYORI",
                "YUSUFARI",
            ],
        },
    },
    {
        code: "ZA",
        name: "ZAMFARA",
        lgas: [
            "ANKA",
            "BAKURA",
            "BIRNIN MAGAJI",
            "BUKKUYUM",
            "BUNGUDU",
            "GUMMI",
            "GUSAU",
            "KAURA NAMODA",
            "MARADUN",
            "MARU",
            "SHINKAFI",
            "TALATA MAFARA",
            "TSAFE",
            "ZURMI",
        ],
        subs: {
            ANKA: [
                "BAGEGA",
                "BARAYAR ZAKI",
                "DAN GALADIMA",
                "GALADIMA",
                "MAGAJI",
                "MATSERI",
                "SABON BIRNI",
                "WARAMU",
                "WUYA",
                "YAR SABAYA",
            ],
            BAKURA: [
                "BAKURA",
                "BIRNIN TUDU",
                "DAKKO",
                "DAMRI",
                "DAN KADU",
                "DAN MANAU",
                "NASARAWA",
                "RINI",
                "YAR GEDA",
                "YAR KUFUJI",
            ],
            "BIRNIN MAGAJI": [
                "B/MAGAJI",
                "DANFAMI S/BIRNI",
                "GORA",
                "GUSAMI GARI",
                "GUSAMI HAYI",
                "KIYAWA",
                "MADOMAWA EAST",
                "MODOMAWA WEST",
                "NASARAWA GODEL EAST",
                "NASARAWA GODEL WEST",
            ],
            BUKKUYUM: [
                "ADABKA",
                "BUKKUYUM",
                "GWASHI",
                "KYARAM",
                "MASAMA",
                "NASARAWA",
                "RUWAN JEMA",
                "YASHI",
                "ZARUMMAI",
                "ZAUMA",
            ],
            BUNGUDU: [
                "BINGI NORTH",
                "BINGI SOUTH",
                "BUNGUDU",
                "FURFURI /KWAIKWAI",
                "GADA/ KARAKKAI",
                "KWATARKWASHI",
                "NAHUCE",
                "RAWAYYA/BELA",
                "SAMAWA",
                "SANKALAWA",
                "TOFA",
            ],
            GUMMI: [
                "B/MAGAJI",
                "B/TUDU",
                "BARDOKI",
                "F/GAMO",
                "FALALE",
                "GAYARI",
                "GYALANGE",
                "ILLELARAWAL",
                "MAGAJI GARI",
                "SHIYAR RAFI",
                "UBANDAWAKI",
            ],
            GUSAU: [
                "GALADIMA",
                "MADA",
                "MADAWAKI",
                "MAGAMI",
                "MAYANA",
                "RIJIYA",
                "RUWAN BORE",
                "SABON GARI",
                "TUDUN WADA",
                "WANKE",
                "WONAKA",
            ],
            "KAURA NAMODA": [
                "BANGA",
                "DAN ISAH",
                "GABAKE",
                "GALADIMA D/GAMADIMA",
                "KAGARA",
                "KUNGURKI",
                "KURYA MADARO",
                "KYAMBARAWA",
                "S/BAURAS/MAFARA",
                "SAKAJIKI",
                "YANKABA",
            ],
            MARADUN: [
                "BIRNIN KAYA DOSARA",
                "DAMAGA/ GAMAGIWA",
                "FARU MAGAMI",
                "GIDAN GOGA",
                "GORA",
                "JANBAKO",
                "KAYA",
                "MARADUN NORTH",
                "MARADUN SOUTH",
                "TSIBIRL",
            ],
            MARU: [
                "BINDIN",
                "BINGI",
                "DANGULBI",
                "DANKURMI",
                "DANSADAU",
                "KANMA",
                "KUYAN BANA",
                "MARU",
                "MAYANCI",
                "RUWAN DORAWA",
            ],
            SHINKAFI: [
                "BADARAWA",
                "CHIKI",
                "GALADI",
                "JANGERU",
                "KATURU",
                "KURYA",
                "KWARE",
                "SHANAWA",
                "SHINKAFI NRHT",
                "SHINKAFI SOUTH",
            ],
            "TALATA MAFARA": [
                "GARBADU",
                "GWARAM",
                "JANGEBE",
                "KAGARA",
                "MORAI",
                "RUWAN BORE",
                "RUWAN GIZO",
                "S/KAYAYE MATUGI",
                "SAUNA R/GORA",
                "SHIYAR GALADIMA",
                "T/TSABA MAKERA",
            ],
            TSAFE: [
                "BILBIS",
                "CHEDIYA",
                "DANJIBGA",
                "DAUKI",
                "KETE KIZARA",
                "KWAREN GANUWA",
                "TSAFE",
                "YANDOTO DAJI",
                "YANKUZO “A”",
                "YANKUZO “B”",
                "YANWAREN DAJI",
            ],
            ZURMI: [
                "BOKO",
                "DAURAN B/TSABA",
                "DOLE",
                "GALADIMA YAN RUWA",
                "KANWA",
                "KWASHABAWA",
                "MASHEMA",
                "MAYASA/KUTURU",
                "RUKUDAWA",
                "YANBUKI/DUTSI",
                "ZURMI",
            ],
        },
    },
];
